// src/atoms/AddLeadHeaderContainer/AddLeadHeaderContainer.styled.tsx
import { styled, Stack } from "@mui/material";
var AddLeadHeaderContainer = styled(Stack, {
  name: "Container",
  slot: "Root",
  skipSx: true
})`
  padding: 6px 16px;
  background-color: #e6f3fa;
  line-height: 24px;
  vertical-align: middle;
  border-top: solid 1px #ddd;
`;

// src/atoms/AddressLink/AddressLink.tsx
import * as React from "react";
import { useMemo } from "react";

// src/atoms/AddressLink/MapLinkIcon.styled.ts
import { styled as styled2 } from "@mui/material";
import { LocationOn } from "@mui/icons-material";
var MapLinkIcon = styled2(LocationOn, {
  name: "MapLinkIcon",
  slot: "Root",
  skipSx: true,
  skipVariantsResolver: true
})`
  margin-right: 4px;
`;

// src/atoms/AddressLink/AddressLink.tsx
import { getFormattedAddress } from "@sales-center/common";
import { Link, Stack as Stack2, Typography } from "@mui/material";
var hereSharedUrl = "https://share.here.com/l/";
function AddressLink(props) {
  const {
    address,
    direction = "row",
    alignItems = "center",
    dataTestId,
    ...stack
  } = props;
  const link = useMemo(() => {
    if (!address || !address.longitude || !address.latitude) return /* @__PURE__ */ React.createElement(React.Fragment, null, "\u2014");
    const icon = /* @__PURE__ */ React.createElement(MapLinkIcon, { fontSize: "small", color: "primary" });
    const { lineOne, lineTwo, city, state, postalCode, latitude, longitude } = address;
    const formattedAddress = getFormattedAddress(
      lineOne,
      lineTwo,
      city,
      state,
      postalCode
    );
    const mapLink = !!latitude && !!longitude ? `${hereSharedUrl}${latitude},${longitude}?p=yes` : void 0;
    if (mapLink) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, icon, "Location:\xA0", /* @__PURE__ */ React.createElement(
        Link,
        {
          href: mapLink,
          target: "_blank",
          color: "#005aa3",
          underline: "none",
          overflow: "hidden",
          textOverflow: "ellipsis",
          "data-test-id": dataTestId
        },
        formattedAddress
      ));
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, icon, /* @__PURE__ */ React.createElement(
      Typography,
      {
        overflow: "hidden",
        textOverflow: "ellipsis",
        "data-test-id": dataTestId
      },
      formattedAddress
    ));
  }, [address, dataTestId]);
  return /* @__PURE__ */ React.createElement(Stack2, { ...stack, direction, alignItems }, link);
}

// src/atoms/AppAvatar/AppAvatar.tsx
import * as React2 from "react";

// src/atoms/AppAvatar/useStyles.ts
var getStyles = (props, theme) => ({
  root: {
    fontSize: props.size ? `${props.size * (3 / 6)}px` : "12px",
    border: "1px solid #2488C6",
    width: props.size ? `${props.size}px` : "28px",
    height: props.size ? `${props.size}px` : "28px",
    marginRight: theme.spacing(0.8)
  },
  outlined: {
    color: theme.palette.primary.main,
    background: theme.palette.common.white
  },
  contained: {
    color: theme.palette.common.white,
    background: theme.palette.primary.main
  }
});

// src/atoms/AppAvatar/AppAvatar.tsx
import { useTheme, Avatar } from "@mui/material";
function AppAvatar(props) {
  const { variant, text } = props;
  const styles8 = getStyles(props, useTheme());
  const classVariant = variant === "outlined" ? styles8.outlined : styles8.contained;
  const className = [styles8.root, classVariant];
  return /* @__PURE__ */ React2.createElement(Avatar, { sx: className }, text);
}

// src/atoms/AppAvatar/LocationAvatar.tsx
import * as React3 from "react";
var LocationAvatar = (props) => {
  const { matched } = props;
  const avatarVariant = matched ? "contained" : "outlined";
  const avatarText = matched ? "PP" : "SC";
  return /* @__PURE__ */ React3.createElement(AppAvatar, { variant: avatarVariant, text: avatarText, ...props });
};
LocationAvatar.displayName = "LocationAvatar";

// src/atoms/AutoCompleteInput/AutoCompleteInput.tsx
import * as React4 from "react";
import {
  TextField,
  CircularProgress
} from "@mui/material";
var AutoCompleteInput = (props) => {
  const { loading, label = "Search", variant = "standard", ...rest } = props;
  return /* @__PURE__ */ React4.createElement(
    TextField,
    {
      ...rest,
      variant: variant ?? "standard",
      label,
      InputProps: {
        ...rest.InputProps,
        endAdornment: /* @__PURE__ */ React4.createElement(React4.Fragment, null, loading ? /* @__PURE__ */ React4.createElement(CircularProgress, { color: "inherit", size: 20 }) : null, rest.InputProps.endAdornment)
      }
    }
  );
};
AutoCompleteInput.displayName = "AutoCompleteInput";

// src/atoms/Button/ExportButton/ExportCSVButton.tsx
import * as React7 from "react";
import { useCallback as useCallback2, useEffect } from "react";
import {
  Box,
  Button as Button2,
  Typography as Typography2,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import { SaveAltRounded as ExportIcon } from "@mui/icons-material";

// src/atoms/Button/ExportButton/MultiServiceLocationDialog.tsx
import * as React6 from "react";

// src/atoms/AlertDialogSlide.tsx
import * as React5 from "react";
import { useCallback } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide
} from "@mui/material";
var Transition = React5.forwardRef(function Transition2(props, ref) {
  return /* @__PURE__ */ React5.createElement(Slide, { direction: "up", ref, ...props });
});
function AlertDialogSlide(props) {
  const {
    backdropClick,
    open,
    okButtonDisabled,
    okClick,
    cancelClick,
    title,
    children,
    message,
    cancelButtonText = "Cancel",
    fullWidth,
    maxWidth,
    messageFontSize = 14,
    okButtonText = "Ok",
    disableDelete,
    middleButtonClick,
    middleButtonDisabled,
    middleButtonTestId = "middleBtn",
    middleButtonText
  } = props;
  const getStyles14 = (props2) => ({
    paper: {
      minWidth: props2.minWidth ? `${props2.minWidth}px` : "0"
    }
  });
  const handleClose = useCallback(
    (_event, reason) => {
      if (backdropClick && reason === "backdropClick") {
        backdropClick();
      } else {
        cancelClick();
      }
    },
    [backdropClick, cancelClick]
  );
  const styles8 = getStyles14(props);
  return /* @__PURE__ */ React5.createElement(
    Dialog,
    {
      open,
      TransitionComponent: Transition,
      keepMounted: true,
      onClose: handleClose,
      "aria-labelledby": "alert-dialog-slide-title",
      "aria-describedby": "alert-dialog-slide-description",
      fullWidth,
      maxWidth,
      PaperProps: {
        sx: styles8.paper
      }
    },
    /* @__PURE__ */ React5.createElement(DialogTitle, { id: "alert-dialog-slide-title" }, title),
    /* @__PURE__ */ React5.createElement(DialogContent, null, message && /* @__PURE__ */ React5.createElement(
      DialogContentText,
      {
        id: "alert-dialog-slide-description",
        style: { fontSize: messageFontSize }
      },
      message
    ), children),
    /* @__PURE__ */ React5.createElement(DialogActions, null, /* @__PURE__ */ React5.createElement(Button, { onClick: cancelClick, color: "primary", "data-test-id": "cancelBtn" }, cancelButtonText), middleButtonText && /* @__PURE__ */ React5.createElement(
      Button,
      {
        disabled: middleButtonDisabled,
        onClick: middleButtonClick,
        color: "primary",
        "data-test-id": middleButtonTestId
      },
      middleButtonText
    ), okButtonText && !disableDelete && /* @__PURE__ */ React5.createElement(
      Button,
      {
        disabled: okButtonDisabled,
        onClick: okClick,
        color: "primary",
        "data-test-id": "okBtn"
      },
      okButtonText
    ))
  );
}

// src/atoms/Button/ExportButton/MultiServiceLocationDialog.tsx
function MultiServiceLocationDialog(props) {
  return /* @__PURE__ */ React6.createElement(
    AlertDialogSlide,
    {
      ...props,
      title: "Export",
      message: "",
      okButtonText: "Continue"
    }
  );
}

// src/atoms/Button/ExportButton/ExportCSVButton.tsx
var styles = {
  ExportButton: {
    width: "auto",
    marginLeft: (theme) => theme.spacing(0.6),
    height: "40px"
  },
  checkbox: {
    marginRight: (theme) => theme.spacing(9)
  },
  checkboxLabel: {
    fontSize: "12px"
  },
  heading: {
    fontSize: "14px"
  }
};
var ExportCSVButton = (props) => {
  const {
    exportClickCallback,
    fileName,
    multipleServiceLocations,
    gridButton,
    disableInteraction
  } = props;
  const [open, setOpen] = React7.useState(false);
  const [multiSLSelected, setMultiselect] = React7.useState(
    multipleServiceLocations ? true : false
  );
  const [disabled, setDisabled] = React7.useState(false);
  const closeDialog = useCallback2(async () => {
    setOpen(false);
  }, [setOpen]);
  const exportData = useCallback2(async () => {
    setDisabled(true);
    const data = await exportClickCallback(multiSLSelected);
    if (data) {
      const hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURIComponent(data);
      hiddenElement.target = "_blank";
      hiddenElement.download = `${fileName}.csv`;
      hiddenElement.click();
      hiddenElement.remove();
    }
    closeDialog();
    setDisabled(false);
  }, [exportClickCallback, fileName, closeDialog, multiSLSelected]);
  const exportClick = useCallback2(async () => {
    setOpen(multipleServiceLocations ? true : false);
    if (!multipleServiceLocations) {
      exportData();
    }
  }, [setOpen, exportData, multipleServiceLocations]);
  const onCheckedUnChecked = useCallback2(
    (_event, checked) => {
      setMultiselect(checked);
    },
    [setMultiselect]
  );
  useEffect(() => {
    setMultiselect(multipleServiceLocations ? true : false);
  }, [multipleServiceLocations]);
  return /* @__PURE__ */ React7.createElement(React7.Fragment, null, gridButton ? /* @__PURE__ */ React7.createElement(
    Button2,
    {
      disabled: disabled || disableInteraction,
      onClick: exportClick,
      color: "primary"
    },
    /* @__PURE__ */ React7.createElement(
      ExportIcon,
      {
        fontSize: "small",
        sx: { marginRight: (theme) => theme.spacing(0.6) }
      }
    ),
    "Export"
  ) : /* @__PURE__ */ React7.createElement(
    Button2,
    {
      color: "primary",
      variant: "outlined",
      onClick: exportClick,
      sx: styles.ExportButton,
      disabled
    },
    "Export"
  ), /* @__PURE__ */ React7.createElement(
    MultiServiceLocationDialog,
    {
      okClick: exportData,
      open,
      cancelClick: closeDialog,
      okButtonDisabled: disabled
    },
    /* @__PURE__ */ React7.createElement(Box, null, /* @__PURE__ */ React7.createElement(Box, { display: "flex", alignItems: "center" }, /* @__PURE__ */ React7.createElement(Typography2, { sx: styles.heading }, "One or more Records contain multiple Service Locations")), /* @__PURE__ */ React7.createElement(Box, null, /* @__PURE__ */ React7.createElement(
      FormControlLabel,
      {
        sx: {
          label: styles.checkboxLabel,
          root: styles.checkbox
        },
        label: "Include each Service Location as a new line item",
        control: /* @__PURE__ */ React7.createElement(
          Checkbox,
          {
            color: "primary",
            checked: multiSLSelected,
            onChange: onCheckedUnChecked
          }
        )
      }
    ))),
    " "
  ));
};
ExportCSVButton.displayName = "ExportCSVButton";

// src/atoms/Button/Button.tsx
import { styled as styled3, Button as MuiButton } from "@mui/material";
var Button3 = styled3(MuiButton, {
  name: "LinkButton",
  slot: "Root",
  skipSx: true,
  skipVariantsResolver: true,
  shouldForwardProp: (prop) => prop !== "margin"
})(({ theme, margin }) => ({
  marginRight: margin,
  width: "18vh",
  height: "33px",
  borderRadius: "4px",
  border: "solid 1px #3b9099",
  backgroundColor: theme.palette.common.white,
  color: "#3b9099",
  fontFamily: "HelveticaNeue",
  fontSize: "12px",
  textDecoration: "none",
  display: "inline-block",
  textAlign: "center",
  lineHeight: "30px",
  userSelect: "none",
  cursor: "pointer",
  position: "relative",
  "::disabled": {
    borderColor: theme.palette.common.black,
    color: "gray",
    pointerEvents: "none",
    "::after": {
      backgroundPosition: "-43px -10px"
    }
  },
  "::after": {
    content: '""',
    width: "6px",
    height: "10px",
    backgroundPosition: "-11px -10px",
    backgroundSize: "49px 37px",
    float: "right",
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(1.1),
    position: "absolute",
    right: 0,
    cursor: "progress"
  },
  "::focus": {
    outline: 0
  },
  "::hover": {
    border: "solid 1px #3b9099",
    backgroundColor: "#3b9099",
    color: theme.palette.common.white,
    cursor: "waiting",
    "::after": {
      backgroundPosition: "-35px -10px"
    }
  },
  "::active": {
    border: "solid 1px #2e747c",
    backgroundColor: "#2e747c",
    outline: "none"
  }
}));

// src/atoms/Button/LinkButton.tsx
import * as React8 from "react";
import { useCallback as useCallback3 } from "react";
function LinkButton(props) {
  const { onClick, children, dataTestId } = props;
  const handleOnClick = useCallback3(
    (event) => {
      event.stopPropagation();
      event.preventDefault();
      onClick();
    },
    [onClick]
  );
  return /* @__PURE__ */ React8.createElement(
    "a",
    {
      href: "#",
      onClick: handleOnClick,
      style: { fontSize: "14px" },
      "data-test-id": dataTestId
    },
    children
  );
}

// src/atoms/Button/CancelButton.tsx
import * as React9 from "react";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
var styles2 = {
  delete: {
    minWidth: "unset"
  }
};
var CancelButton = (props) => {
  const { onClick, disabled, sx, style } = props;
  return /* @__PURE__ */ React9.createElement(
    IconButton,
    {
      onClick,
      disabled,
      sx: {
        root: styles2.delete,
        ...sx
      },
      style,
      size: "small"
    },
    /* @__PURE__ */ React9.createElement(CancelIcon, { fontSize: "small", color: disabled ? "disabled" : "error" })
  );
};

// src/atoms/Button/LoadingButton.tsx
import * as React12 from "react";

// src/atoms/ButtonWithTooltip/ButtonWithTooltip.tsx
import * as React11 from "react";

// src/atoms/LightTooltip.tsx
import * as React10 from "react";
import { tooltipClasses, styled as styled4, Tooltip } from "@mui/material";
var LightTooltip = styled4(
  ({
    className,
    tooltipWidth,
    tooltipShadow,
    background,
    color,
    ...props
  }) => /* @__PURE__ */ React10.createElement(Tooltip, { ...props, classes: { popper: className } })
)(({ theme, tooltipWidth, tooltipShadow, background, color }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    "&::before": {
      backgroundColor: theme.palette.common.white,
      border: "1px solid #999"
    }
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: background || theme.palette.common.white,
    color: color || theme.palette.text.primary,
    boxShadow: theme.shadows[tooltipShadow || 1],
    fontSize: 14,
    fontWeight: 400,
    maxWidth: tooltipWidth
  }
}));

// src/atoms/ButtonWithTooltip/ButtonWithTooltip.tsx
import { Button as Button4, Box as Box2 } from "@mui/material";
var ButtonWithTooltip = (props) => {
  const {
    tooltipTitle,
    showTooltip,
    spanSx,
    dataTestId,
    buttonSx,
    ...buttonProps
  } = props;
  return showTooltip ? /* @__PURE__ */ React11.createElement(LightTooltip, { title: tooltipTitle }, /* @__PURE__ */ React11.createElement(
    Box2,
    {
      component: "span",
      sx: spanSx,
      style: props.fullWidth ? { width: "100%" } : void 0
    },
    /* @__PURE__ */ React11.createElement(Button4, { "data-test-id": dataTestId, ...buttonProps }, props.children)
  )) : /* @__PURE__ */ React11.createElement(Button4, { "data-test-id": dataTestId, ...buttonProps }, props.children);
};
ButtonWithTooltip.displayName = "ButtonWithTooltip";

// src/atoms/Button/LoadingButton.tsx
import { CircularProgress as CircularProgress2 } from "@mui/material";
var styles3 = {
  root: { flex: "0 0 auto" }
};
var LoadingButton = ({
  loading,
  disabled,
  children,
  ...props
}) => /* @__PURE__ */ React12.createElement(
  ButtonWithTooltip,
  {
    ...props,
    disabled: loading || disabled,
    sx: {
      ...props.classes,
      ...styles3
    }
  },
  loading && /* @__PURE__ */ React12.createElement(CircularProgress2, { size: "25px", style: { position: "absolute" } }),
  children
);
LoadingButton.displayName = "LoadingButton";

// src/atoms/Button/MoreButton.tsx
import * as React13 from "react";
import { useCallback as useCallback4, useState as useState2 } from "react";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import {
  Button as Button5,
  Popover,
  List,
  ListItem,
  ListItemText,
  ListItemButton
} from "@mui/material";
var styles4 = {
  more: {
    minWidth: "unset",
    maxWidth: "fit-content"
  },
  list: {
    minWidth: "150px"
  }
};
var topRight = {
  vertical: "top",
  horizontal: "right"
};
var MoreButton = (props) => {
  const {
    className,
    disabled,
    style,
    options,
    anchorOrigin = topRight,
    transformOrigin = topRight,
    dataTestId,
    horizontal
  } = props;
  const [anchorEl, setAnchorEl] = useState2(null);
  const handleClick = useCallback4(
    (event) => {
      setAnchorEl(event.currentTarget);
    },
    []
  );
  const handleClose = useCallback4(() => {
    setAnchorEl(null);
  }, []);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : void 0;
  return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(
    Button5,
    {
      "data-test-id": dataTestId,
      "aria-describedby": id,
      disabled,
      onClick: handleClick,
      style,
      sx: {
        transform: `rotate(${horizontal ? "90deg" : "0deg"})`,
        ...styles4.more,
        ...className
      }
    },
    /* @__PURE__ */ React13.createElement(MoreVertIcon, { fontSize: "small" })
  ), /* @__PURE__ */ React13.createElement(
    Popover,
    {
      id,
      open,
      anchorEl,
      onClose: handleClose,
      elevation: 2,
      anchorOrigin,
      transformOrigin
    },
    /* @__PURE__ */ React13.createElement(List, { dense: true, sx: styles4.list }, options.map(
      (item, i) => !item.hidden && /* @__PURE__ */ React13.createElement(
        MoreMenuItem,
        {
          key: i,
          disabled: item.disabled,
          close: handleClose,
          item,
          tooltipText: item.tooltipText,
          style: item.style,
          "data-test-id": `${item.dataTestId}`
        }
      )
    ))
  ));
};
var MoreMenuItem = (props) => {
  const { item, close, disabled = false, tooltipText, style } = props;
  const onClick = useCallback4(() => {
    item.onClick();
    close();
  }, [item, close]);
  return tooltipText ? /* @__PURE__ */ React13.createElement(LightTooltip, { title: tooltipText }, /* @__PURE__ */ React13.createElement("span", null, /* @__PURE__ */ React13.createElement(
    ListItem,
    {
      button: true,
      disabled,
      onClick,
      "data-test-id": item.dataTestId
    },
    /* @__PURE__ */ React13.createElement(ListItemText, null, item.label)
  ))) : /* @__PURE__ */ React13.createElement(
    ListItemButton,
    {
      disabled,
      onClick,
      "data-test-id": item.dataTestId,
      style
    },
    /* @__PURE__ */ React13.createElement(ListItemText, null, item.label)
  );
};

// src/atoms/CalendarButton/CalendarButton.tsx
import * as React16 from "react";

// src/atoms/icons/CalendarIcon.tsx
import * as React14 from "react";
import { styled as styled5, useTheme as useTheme2, SvgIcon } from "@mui/material";
var Container = styled5(SvgIcon)(({ theme }) => ({
  marginLeft: theme.spacing(0.6),
  marginBottom: theme.spacing(0.2),
  verticalAlign: "middle",
  width: "12px",
  height: "14px"
}));
var CalendarIcon = (props) => {
  const theme = useTheme2();
  return /* @__PURE__ */ React14.createElement(Container, null, /* @__PURE__ */ React14.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "14",
      viewBox: "0 0 12 14"
    },
    /* @__PURE__ */ React14.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React14.createElement("path", { d: "M0 0L14 0 14 14 0 14z", transform: "translate(-1)" }), /* @__PURE__ */ React14.createElement(
      "path",
      {
        fill: props.useThemeColor ? theme.palette.primary.main : props.color || theme.palette.text.primary,
        fillRule: "nonzero",
        d: "M11.667 1.75h-.584V.583H9.917V1.75H4.083V.583H2.917V1.75h-.584c-.641 0-1.166.525-1.166 1.167v9.333c0 .642.525 1.167 1.166 1.167h9.334c.641 0 1.166-.525 1.166-1.167V2.917c0-.642-.525-1.167-1.166-1.167zm0 10.5H2.333V4.667h9.334v7.583z",
        transform: "translate(-1)"
      }
    ))
  ));
};

// src/atoms/icons/TidalCalendarIcon.tsx
import * as React15 from "react";
import { styled as styled6, SvgIcon as SvgIcon2 } from "@mui/material";
var Container2 = styled6(SvgIcon2)(({ theme }) => ({
  marginLeft: theme.spacing(0.6),
  marginBottom: theme.spacing(0.2),
  verticalAlign: "middle",
  width: "12px",
  height: "14px"
}));
function TidalCalendarIcon() {
  return /* @__PURE__ */ React15.createElement(Container2, null, /* @__PURE__ */ React15.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "14",
      viewBox: "0 0 12 14"
    },
    /* @__PURE__ */ React15.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React15.createElement("path", { d: "M0 0L14 0 14 14 0 14z", transform: "translate(-1)" }), /* @__PURE__ */ React15.createElement(
      "path",
      {
        fill: "#1565c0",
        fillRule: "nonzero",
        d: "M11.667 1.75h-.584V.583H9.917V1.75H4.083V.583H2.917V1.75h-.584c-.641 0-1.166.525-1.166 1.167v9.333c0 .642.525 1.167 1.166 1.167h9.334c.641 0 1.166-.525 1.166-1.167V2.917c0-.642-.525-1.167-1.166-1.167zm0 10.5H2.333V4.667h9.334v7.583z",
        transform: "translate(-1)"
      }
    ))
  ));
}

// src/atoms/CalendarButton/CalendarButton.tsx
import { format } from "date-fns";
import { Button as Button6, Typography as Typography3 } from "@mui/material";

// src/atoms/CalendarButton/typings.ts
var CAN_DATE_FORMAT = "yyyy/MM/dd";
var US_DATE_EMPTY_PLACEHOLDER = "- - / - - / - - - -";
var CAN_DATE_EMPTY_PLACEHOLDER = "- - - - / - - / - -";

// src/atoms/CalendarButton/CalendarButton.tsx
var CalendarButton = (props) => {
  const placeholder = React16.useMemo(() => {
    if (props.formatString == CAN_DATE_FORMAT) {
      return CAN_DATE_EMPTY_PLACEHOLDER;
    }
    return US_DATE_EMPTY_PLACEHOLDER;
  }, [props.formatString]);
  return /* @__PURE__ */ React16.createElement(
    Button6,
    {
      variant: "text",
      onClick: props.onClick,
      disabled: props.disabled,
      "data-test-id": props.dataTestId
    },
    /* @__PURE__ */ React16.createElement(
      Typography3,
      {
        color: "#1565c0",
        display: "inline",
        sx: {
          letterSpacing: "0.46px",
          lineHeight: "10px",
          fontSize: "13px",
          fontWeight: 500
        }
      },
      props.date ? props?.formatString ? format(new Date(props.date), props?.formatString) : new Date(props.date).toDateString() : placeholder,
      props?.tidal ? /* @__PURE__ */ React16.createElement(TidalCalendarIcon, null) : /* @__PURE__ */ React16.createElement(CalendarIcon, { color: props.color })
    )
  );
};

// src/atoms/CalendarButton/CalendarDatePicker.tsx
import * as React18 from "react";
import { useCallback as useCallback6, useEffect as useEffect2, useMemo as useMemo3, useState as useState3 } from "react";
import { MobileDatePicker } from "@mui/x-date-pickers";

// src/atoms/CalendarButton/CustomActionBar.tsx
import * as React17 from "react";
import { PickersActionBar } from "@mui/x-date-pickers";
import { Box as Box3, FormControlLabel as FormControlLabel2, Checkbox as Checkbox2 } from "@mui/material";
import { ENTITY_TYPES } from "@sales-center/common";
function CustomActionBar(props) {
  const { isnextactiondate, setupdateotherdate, entitytype, disabled } = props;
  const onChangeUpdateOtherDate = React17.useCallback(
    (_3, checked) => {
      if (setupdateotherdate) setupdateotherdate(checked);
    },
    [setupdateotherdate]
  );
  return /* @__PURE__ */ React17.createElement(Box3, { gridRow: 3, gridColumn: "1/4" }, entitytype !== ENTITY_TYPES.Lead && /* @__PURE__ */ React17.createElement(Box3, { paddingLeft: 2, sx: { gridColumn: "1/4", gridRow: "3" } }, /* @__PURE__ */ React17.createElement(
    FormControlLabel2,
    {
      control: /* @__PURE__ */ React17.createElement(
        Checkbox2,
        {
          color: "primary",
          disabled,
          onChange: onChangeUpdateOtherDate
        }
      ),
      label: `Also make this the ${isnextactiondate !== "expectedclosing" ? "Expected Closing" : "Next Action"} Date`
    }
  )), /* @__PURE__ */ React17.createElement(PickersActionBar, { ...props, sx: { gridRow: "4" } }));
}

// src/atoms/CalendarButton/CalendarDatePicker.tsx
function CalendarDatePicker(props) {
  const {
    value,
    canUpdate,
    clearable,
    datePickerType = "none",
    entityType,
    updateOtherDateCallback,
    onAccept,
    id,
    tidal,
    format: format2,
    color,
    disabled,
    dataTestId
  } = props;
  const [open, setOpen] = useState3(false);
  const [updateOtherDate, setUpdateOtherDate] = useState3(false);
  const onOpen = useCallback6(() => setOpen(true), []);
  const onClose = useCallback6(() => setOpen(false), []);
  const [nextActionDate, setNextActionDate] = useState3(value);
  const onChange = useCallback6((selection) => {
    setNextActionDate(selection);
  }, []);
  const originalNextActionDate = useMemo3(() => value, [value]);
  useEffect2(() => {
    if (value !== originalNextActionDate) {
      setNextActionDate(value);
    }
  }, [originalNextActionDate, value]);
  const onCancelDialog = useCallback6(() => {
    onClose();
    setUpdateOtherDate(false);
    setNextActionDate(originalNextActionDate);
  }, [onClose, originalNextActionDate]);
  const onClearDialog = useCallback6(() => {
    onClose();
    setUpdateOtherDate(false);
    onAccept(null);
  }, [onAccept, onClose]);
  const onAcceptDialog = useCallback6(() => {
    onClose();
    if (originalNextActionDate !== nextActionDate) {
      onAccept(nextActionDate);
    }
    if (updateOtherDate && updateOtherDateCallback && datePickerType !== "none") {
      if (datePickerType === "nextaction") {
        updateOtherDateCallback({
          opportunityId: id,
          expectedClosingDate: nextActionDate
        });
      } else {
        updateOtherDateCallback({
          opportunityId: id,
          nextActionDate
        });
      }
      setUpdateOtherDate(false);
    }
  }, [
    nextActionDate,
    onAccept,
    onClose,
    originalNextActionDate,
    updateOtherDate,
    updateOtherDateCallback,
    id,
    datePickerType
  ]);
  const onCloseDialog = useCallback6((_event, reason) => {
    if (reason == "backdropClick") {
      return;
    }
  }, []);
  return /* @__PURE__ */ React18.createElement(
    MobileDatePicker,
    {
      ...props,
      open,
      onOpen,
      onClose,
      onChange,
      showToolbar: false,
      format: format2,
      value: nextActionDate,
      DialogProps: {
        onClose: onCloseDialog
      },
      slots: {
        toolbar: void 0,
        actionBar: canUpdate ? CustomActionBar : void 0,
        textField: () => /* @__PURE__ */ React18.createElement(
          CalendarButton,
          {
            date: value,
            onClick: onOpen,
            tidal,
            formatString: format2,
            color,
            disabled,
            dataTestId
          }
        )
      },
      slotProps: {
        actionBar: {
          /*eslint-disable */
          //@ts-ignore
          isnextactiondate: datePickerType,
          setupdateotherdate: setUpdateOtherDate,
          onCancel: onCancelDialog,
          onAccept: onAcceptDialog,
          onClear: onClearDialog,
          disabled: !nextActionDate,
          entitytype: entityType,
          actions: clearable ? ["clear", "cancel", "accept"] : ["cancel", "accept"]
        }
      }
    }
  );
}

// src/atoms/CardFooterCollapse/CardFooterCollapse.tsx
import * as React55 from "react";
import { useCallback as useCallback7, useState as useState4 } from "react";

// src/atoms/icons/AddNoteIcon.tsx
import * as React19 from "react";
var AddNoteIcon = () => {
  return /* @__PURE__ */ React19.createElement("img", { src: "/static-assets/icons/add-note.svg", alt: "Add Note" });
};

// src/atoms/icons/AttachmentPaperClipIcon.tsx
import * as React20 from "react";
var AttachmentPaperClipIcon = () => {
  return /* @__PURE__ */ React20.createElement("img", { src: "/static-assets/icons/attachment-paperclip-light.svg" });
};

// src/atoms/icons/Chevron.tsx
import * as React21 from "react";
import { ChevronLeft as ChevronLeftIcon } from "@mui/icons-material";
import { Box as Box4, styled as styled7 } from "@mui/material";
var ChevronContainer = styled7(Box4, {
  name: "ChevronContainer",
  slot: "Root",
  skipSx: true,
  skipVariantsResolver: true,
  shouldForwardProp: (prop) => prop !== "color"
})(({ color, theme }) => ({
  color: color ?? theme.palette.grey[600],
  display: "inline-block",
  transform: "rotate(0deg)",
  transition: "all 0.25s ease-in-out",
  " svg": {
    width: "24px"
  }
}));
var Chevron = (props) => {
  const { dataTestId, ...containerProps } = props;
  return /* @__PURE__ */ React21.createElement(
    ChevronContainer,
    {
      style: {
        transform: `rotate(${props.open ? "90deg" : "-90deg"})`
      },
      "data-test-id": dataTestId,
      ...containerProps
    },
    /* @__PURE__ */ React21.createElement(
      ChevronLeftIcon,
      {
        color: "inherit",
        sx: { position: "relative", top: "-2px" }
      }
    )
  );
};

// src/atoms/icons/AgreementIcon.tsx
import * as React22 from "react";
function AgreementIcon() {
  return /* @__PURE__ */ React22.createElement(
    "svg",
    {
      width: "40",
      height: "41",
      viewBox: "0 0 40 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M4.7699 40.3944H1.96306C1.83659 40.3944 1.71135 40.3695 1.59451 40.3211C1.47766 40.2727 1.3715 40.2018 1.28207 40.1124C1.19264 40.0229 1.12172 39.9168 1.07332 39.7999C1.02493 39.6831 1 39.5579 1 39.4314V1.96305C1 1.83658 1.02493 1.71135 1.07332 1.59451C1.12172 1.47766 1.19264 1.3715 1.28207 1.28207C1.3715 1.19264 1.47766 1.12171 1.59451 1.07331C1.71135 1.02491 1.83659 1 1.96306 1H31.9822C32.2369 1.00215 32.4806 1.1043 32.6608 1.28445C32.8409 1.46459 32.9431 1.7083 32.9452 1.96305V39.4314C32.9431 39.6861 32.8409 39.9299 32.6608 40.11C32.4806 40.2901 32.2369 40.3923 31.9822 40.3944H7.46148",
        fill: "#005AA3"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M4.7699 40.3944H1.96306C1.83659 40.3944 1.71135 40.3695 1.59451 40.3211C1.47766 40.2727 1.3715 40.2018 1.28207 40.1124C1.19264 40.0229 1.12172 39.9168 1.07332 39.7999C1.02493 39.6831 1 39.5579 1 39.4314V1.96305C1 1.83658 1.02493 1.71135 1.07332 1.59451C1.12172 1.47766 1.19264 1.3715 1.28207 1.28207C1.3715 1.19264 1.47766 1.12171 1.59451 1.07331C1.71135 1.02491 1.83659 1 1.96306 1H31.9822C32.2369 1.00215 32.4806 1.1043 32.6608 1.28445C32.8409 1.46459 32.9431 1.7083 32.9452 1.96305V39.4314C32.9431 39.6861 32.8409 39.9299 32.6608 40.11C32.4806 40.2901 32.2369 40.3923 31.9822 40.3944H7.46148",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M30.9285 28.6815V37.5876C30.9285 37.8452 30.8262 38.0923 30.6441 38.2744C30.4619 38.4566 30.2149 38.5589 29.9573 38.5589H3.98788C3.73028 38.5589 3.48323 38.4566 3.30108 38.2744C3.11893 38.0923 3.0166 37.8452 3.0166 37.5876V1.96305C3.01877 1.70688 3.12205 1.46194 3.30397 1.28157C3.48589 1.10119 3.7317 0.999991 3.98788 1H29.9573C30.2135 0.999991 30.4593 1.10119 30.6412 1.28157C30.8231 1.46194 30.9264 1.70688 30.9285 1.96305V24.8128",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M30.9285 28.6815V37.5876C30.9285 37.8452 30.8262 38.0923 30.6441 38.2744C30.4619 38.4566 30.2149 38.5589 29.9573 38.5589H3.98788C3.73028 38.5589 3.48323 38.4566 3.30108 38.2744C3.11893 38.0923 3.0166 37.8452 3.0166 37.5876V1.96305C3.01877 1.70688 3.12205 1.46194 3.30397 1.28157C3.48589 1.10119 3.7317 0.999991 3.98788 1H29.9573C30.2135 0.999991 30.4593 1.10119 30.6412 1.28157C30.8231 1.46194 30.9264 1.70688 30.9285 1.96305V24.8128",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M13.6436 31.2407C13.7094 33.6031 13.9069 34.9694 16.3269 34.2863C18.5329 33.6607 21.0681 31.9404 20.8541 33.2574C20.64 34.5743 22.5003 34.5579 23.9902 33.0104",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M26.8382 31.9408L23.8174 33.0603L23.982 29.8501L26.8382 31.9408Z",
        fill: "white",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M35.4415 14.2277L23.9814 29.8516L26.8354 31.9449L38.2955 16.3211L35.4415 14.2277Z",
        fill: "white",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M37.9532 13.6172L38.1192 13.7389C38.4712 13.9971 38.7063 14.3846 38.7726 14.8162C38.839 15.2477 38.7312 15.6879 38.4729 16.04L37.3824 17.5267L34.5284 15.4333L35.6043 13.9665C35.7328 13.7857 35.8964 13.6327 36.0854 13.5167C36.2745 13.4007 36.485 13.324 36.7044 13.2914C36.9237 13.2588 37.1475 13.2708 37.3621 13.3268C37.5767 13.3828 37.7777 13.4816 37.9532 13.6172Z",
        fill: "#005AA3",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M37.407 17.5361L38.3701 18.244C38.5658 18.3886 38.6965 18.6048 38.7335 18.8453C38.7705 19.0859 38.7109 19.3313 38.5676 19.5281L33.3984 26.5822",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M13.6348 8.79492H21.3474",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M7.45312 13.314H27.529",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M7.45312 17.3887H27.529",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M7.45312 21.751H27.529",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  );
}

// src/atoms/icons/DeleteIcon.tsx
import * as React23 from "react";
var DeleteIcon = () => /* @__PURE__ */ React23.createElement(
  "svg",
  {
    width: "36",
    height: "45",
    viewBox: "0 0 36 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React23.createElement(
    "path",
    {
      d: "M7.43136 23.7204H10.9692L11.8865 31.7445C12.0205 33.0717 13.127 34.0724 14.4607 34.0724H21.5391C22.8728 34.0724 23.9793 33.0717 24.1124 31.7533L25.0306 23.7204H28.5622C31.6 23.7204 34.0713 21.2491 34.0713 18.2112C34.0713 16.1637 32.9438 14.313 31.1584 13.36C31.267 12.7689 31.32 12.2046 31.32 11.6477C31.32 6.28794 26.9566 1.92763 21.5934 1.92763C17.5783 1.92763 14.0225 4.36879 12.5563 8.06396C12.0867 7.94625 11.6128 7.88693 11.1407 7.88693C8.09682 7.88693 5.59978 10.1667 5.27741 13.1525C3.2575 14.0076 1.92847 15.9889 1.92847 18.2112C1.92847 21.2491 4.39694 23.7204 7.43136 23.7204ZM22.8339 31.6158C22.7667 32.2832 22.2099 32.7866 21.5391 32.7866H14.4607C13.7899 32.7866 13.2331 32.2832 13.165 31.607L11.5089 17.1205H24.4909L22.8339 31.6158ZM10.7885 15.8347H10.2009V13.656H14.1377H21.8621H25.7989V15.8347H25.2113H10.7885ZM14.7806 12.3703V11.7205H21.2192V12.3703H14.7806ZM6.09197 14.2182C6.34623 14.1334 6.52138 13.8996 6.53111 13.6315C6.62183 11.1313 8.64676 9.17264 11.1407 9.17264C11.6702 9.17264 12.206 9.26995 12.7337 9.46174C12.8982 9.52106 13.079 9.51133 13.2353 9.43506C13.3922 9.35878 13.5109 9.22192 13.5649 9.05587C14.6993 5.56128 17.9255 3.21334 21.5934 3.21334C26.2478 3.21334 30.0343 6.99703 30.0343 11.6477C30.0343 12.2636 29.9577 12.8954 29.7998 13.5797C29.7295 13.8855 29.8899 14.1972 30.1793 14.3177C31.7626 14.9766 32.7856 16.5049 32.7856 18.2112C32.7856 20.54 30.8909 22.4347 28.5622 22.4347H25.1775L25.785 17.1205H26.4418C26.7968 17.1205 27.0846 16.8326 27.0846 16.4776V13.0131C27.0846 12.6581 26.7968 12.3703 26.4418 12.3703H22.5049V11.0777C22.5049 10.7227 22.2171 10.4348 21.8621 10.4348H14.1377C13.7827 10.4348 13.4949 10.7227 13.4949 11.0777V12.3703H9.558C9.20299 12.3703 8.91514 12.6581 8.91514 13.0131V16.4776C8.91514 16.8326 9.20299 17.1205 9.558 17.1205H10.2148L10.8223 22.4347H7.43136C5.10603 22.4347 3.21418 20.54 3.21418 18.2112C3.21418 16.3966 4.37057 14.792 6.09197 14.2182Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ React23.createElement(
    "path",
    {
      d: "M14.7355 29.9026C14.7512 29.9026 14.7672 29.902 14.7832 29.901C15.1373 29.875 15.4032 29.5667 15.3774 29.2126L14.7452 20.6003C14.7189 20.2462 14.4106 19.9844 14.0569 20.0061C13.7028 20.0322 13.4369 20.3404 13.4627 20.6945L14.0948 29.3068C14.12 29.6449 14.4018 29.9026 14.7355 29.9026Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ React23.createElement(
    "path",
    {
      d: "M18 29.9026C18.355 29.9026 18.6429 29.6147 18.6429 29.2597V20.6474C18.6429 20.2924 18.355 20.0045 18 20.0045C17.645 20.0045 17.3572 20.2924 17.3572 20.6474V29.2597C17.3572 29.6147 17.645 29.9026 18 29.9026Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ React23.createElement(
    "path",
    {
      d: "M21.2168 29.901C21.2328 29.902 21.2488 29.9026 21.2645 29.9026C21.5982 29.9026 21.88 29.6449 21.9051 29.3068L22.5373 20.6945C22.5631 20.3404 22.2972 20.0322 21.9431 20.0061C21.5872 19.9851 21.2811 20.2462 21.2548 20.6003L20.6226 29.2126C20.5968 29.5667 20.8627 29.875 21.2168 29.901Z",
      fill: "black"
    }
  )
);
DeleteIcon.displayName = "DeleteIcon";

// src/atoms/icons/EditButton.tsx
import * as React24 from "react";
var EditButtonIcon = (props) => {
  return /* @__PURE__ */ React24.createElement("div", { className: "editable-pic", onClick: props.onClick }, /* @__PURE__ */ React24.createElement(
    "svg",
    {
      id: "i-edit",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      width: "15",
      height: "15",
      fill: "none",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    },
    /* @__PURE__ */ React24.createElement("path", { d: "M30 7 L25 2 5 22 3 29 10 27 Z M21 6 L26 11 Z M5 22 L10 27 Z" })
  ));
};

// src/atoms/icons/EditPencilIcon.tsx
import * as React25 from "react";
var EditPencilIcon = () => {
  return /* @__PURE__ */ React25.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "17",
      height: "17",
      viewBox: "0 0 17 17"
    },
    /* @__PURE__ */ React25.createElement("g", { fill: "none", fillRule: "evenodd", opacity: ".812" }, /* @__PURE__ */ React25.createElement("g", null, /* @__PURE__ */ React25.createElement("g", null, /* @__PURE__ */ React25.createElement("g", null, /* @__PURE__ */ React25.createElement(
      "path",
      {
        d: "M0 0L21 0 21 21 0 21z",
        transform: "translate(-284 -302) translate(65 278) translate(217 22)"
      }
    ), /* @__PURE__ */ React25.createElement(
      "path",
      {
        fill: "#626262",
        fillRule: "nonzero",
        d: "M2.625 15.094v3.281h3.281l9.678-9.678-3.281-3.28-9.678 9.677zM18.121 6.16c.341-.341.341-.893 0-1.234L16.074 2.88c-.342-.341-.893-.341-1.234 0L13.239 4.48l3.281 3.281 1.601-1.601z",
        transform: "translate(-284 -302) translate(65 278) translate(217 22)"
      }
    )))))
  );
};

// src/atoms/icons/FileUploadIcon.tsx
import * as React26 from "react";
var FileUploadIcon = (props) => {
  const { color = "#ddd", transitionTime = 0.5 } = props;
  return /* @__PURE__ */ React26.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "149",
      height: "149",
      viewBox: "0 0 149 149"
    },
    /* @__PURE__ */ React26.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React26.createElement(
      "g",
      {
        style: {
          fill: color,
          transition: `fill ${transitionTime}s`
        },
        fillRule: "nonzero"
      },
      /* @__PURE__ */ React26.createElement("g", null, /* @__PURE__ */ React26.createElement("g", null, /* @__PURE__ */ React26.createElement(
        "path",
        {
          d: "M128.667 149H21.333c-1.288 0-2.333-1.028-2.333-2.296V87h4.667v57.407h102.666v-6.888H131v9.185c0 1.268-1.045 2.296-2.333 2.296zM130 70h-4.653V4.667H49.529L22.29 31.983l-3.29-3.3 27.92-28C47.357.247 47.948 0 48.565 0h79.108C128.958 0 130 1.045 130 2.333V70z",
          transform: "translate(-1020 -295) translate(735 -1) translate(285 296)"
        }
      ), /* @__PURE__ */ React26.createElement(
        "path",
        {
          d: "M23.571 40H19v-9.5c0-1.312 1.023-2.375 2.286-2.375h25.143V2H51v28.5c0 1.312-1.023 2.375-2.286 2.375H23.571V40zM137.125 149c-.63 0-1.234-.25-1.679-.696l-10.987-10.987-3.071 3.071c-.927.927-2.43.927-3.358 0l-6.335-6.334c-.927-.928-.927-2.43 0-3.358l19-19c.928-.928 2.432-.928 3.36 0l6.334 6.331c.446.446.696 1.05.696 1.68 0 .63-.25 1.235-.696 1.68l-3.071 3.072 10.987 10.987c.927.927.927 2.43 0 3.358l-9.5 9.5c-.446.446-1.05.696-1.68.696zm-12.666-17.416c.63 0 1.233.249 1.68.693l10.986 10.99 6.142-6.142-10.987-10.987c-.446-.446-.697-1.05-.697-1.68 0-.63.251-1.235.697-1.68l3.071-3.07-2.976-2.975-15.642 15.642 2.976 2.973 3.07-3.07c.447-.445 1.05-.695 1.68-.694z",
          transform: "translate(-1020 -295) translate(735 -1) translate(285 296)"
        }
      ), /* @__PURE__ */ React26.createElement(
        "path",
        {
          d: "M44.333 102c-.618 0-1.212-.245-1.65-.68L29.368 88.07H7c-3.866 0-7-3.118-7-6.964V43.964C0 40.118 3.134 37 7 37h56c3.866 0 7 3.118 7 6.964v16.25h-4.667v-16.25c0-1.282-1.044-2.321-2.333-2.321H7c-1.289 0-2.333 1.04-2.333 2.321v37.143C4.667 82.39 5.71 83.43 7 83.43h23.333c.62 0 1.213.244 1.65.68L42 94.075V85.75c0-1.282 1.045-2.321 2.333-2.321h9.334v4.642h-7V99.68c0 1.282-1.045 2.321-2.334 2.321zM28 135H42V140H28zM28 126H42V131H28zM28 116H42V121H28zM28 107H33V112H28zM116 9H121V14H116zM97 9H111V14H97zM98 18H121V23H98z",
          transform: "translate(-1020 -295) translate(735 -1) translate(285 296)"
        }
      ), /* @__PURE__ */ React26.createElement(
        "path",
        {
          d: "M16 70c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7zm0-9.333c-1.289 0-2.333 1.044-2.333 2.333 0 1.289 1.044 2.333 2.333 2.333 1.289 0 2.333-1.044 2.333-2.333 0-1.289-1.044-2.333-2.333-2.333zM35 70c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7zm0-9.333c-1.289 0-2.333 1.044-2.333 2.333 0 1.289 1.044 2.333 2.333 2.333 1.289 0 2.333-1.044 2.333-2.333 0-1.289-1.044-2.333-2.333-2.333zM54 70c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7zm0-9.333c-1.289 0-2.333 1.044-2.333 2.333 0 1.289 1.044 2.333 2.333 2.333 1.289 0 2.333-1.044 2.333-2.333 0-1.289-1.044-2.333-2.333-2.333zM93.5 130C72.79 130 56 113.21 56 92.5S72.79 55 93.5 55 131 71.79 131 92.5c-.025 20.7-16.8 37.475-37.5 37.5zm0-70.313c-18.122 0-32.813 14.691-32.813 32.813s14.691 32.813 32.813 32.813 32.813-14.691 32.813-32.813c-.02-18.114-14.7-32.793-32.813-32.813z",
          transform: "translate(-1020 -295) translate(735 -1) translate(285 296)"
        }
      ), /* @__PURE__ */ React26.createElement(
        "path",
        {
          d: "M94 121c-15.464 0-28-12.536-28-28s12.536-28 28-28 28 12.536 28 28c-.017 15.457-12.543 27.983-28 28zm0-51.333c-12.887 0-23.333 10.446-23.333 23.333 0 12.887 10.446 23.333 23.333 23.333 12.887 0 23.333-10.446 23.333-23.333C117.32 80.12 106.881 69.68 94 69.667z",
          transform: "translate(-1020 -295) translate(735 -1) translate(285 296)"
        }
      ), /* @__PURE__ */ React26.createElement(
        "path",
        {
          d: "M115.243 119.617L119.9 119.617 119.9 129.495 115.243 129.495z",
          transform: "translate(-1020 -295) translate(735 -1) translate(285 296) rotate(-45 117.571 124.556)"
        }
      ), /* @__PURE__ */ React26.createElement(
        "path",
        {
          d: "M122.228 112.631L126.884 112.631 126.884 122.51 122.228 122.51z",
          transform: "translate(-1020 -295) translate(735 -1) translate(285 296) rotate(-45 124.556 117.57)"
        }
      )))
    ))
  );
};

// src/atoms/icons/FilterIcon.tsx
import * as React27 from "react";
import { SvgIcon as SvgIcon3 } from "@mui/material";
var FilterIcon = ({ style, sx }) => /* @__PURE__ */ React27.createElement(
  SvgIcon3,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "19",
    viewBox: "0 0 20 19",
    style,
    sx,
    stroke: "currentColor"
  },
  /* @__PURE__ */ React27.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React27.createElement("g", { fillRule: "nonzero" }, /* @__PURE__ */ React27.createElement("g", null, /* @__PURE__ */ React27.createElement("g", null, /* @__PURE__ */ React27.createElement("g", null, /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M18.29.816C18.072.313 17.611 0 17.087 0H1.325C.801 0 .34.313.122.816c-.216.499-.141 1.069.195 1.487h.001l6.258 7.737v6.028c0 .258.134.495.348.616.096.056.203.083.31.083.127 0 .254-.04.364-.117l3.946-2.795c.183-.13.292-.348.292-.581V10.04l6.26-7.737c.336-.418.41-.988.194-1.487z",
      transform: "translate(-23 -16) translate(-161 -142) translate(185 159)"
    }
  ))))))
);
FilterIcon.displayName = "FilterIcon";

// src/atoms/icons/LeadIcon.tsx
import * as React28 from "react";
var LeadIcon = ({
  width = 23,
  height = 23,
  theme
}) => /* @__PURE__ */ React28.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 23 23"
  },
  /* @__PURE__ */ React28.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React28.createElement("g", null, /* @__PURE__ */ React28.createElement("g", null, /* @__PURE__ */ React28.createElement("g", null, /* @__PURE__ */ React28.createElement("g", { transform: "translate(-109 -246) translate(109 246)" }, /* @__PURE__ */ React28.createElement(
    "path",
    {
      fill: "#19305A",
      fillRule: "nonzero",
      stroke: theme.palette.common.white,
      strokeWidth: ".5",
      d: "M12.291 4c-.484 0-.954.115-1.398.344-.164.015-.325.047-.48.094-1.58.484-2.475 2.505-1.994 4.504.048.2.165.585.26.724.18 1.361.78 2.499 1.605 3.166-.41 1.593-1.814 1.52-1.827 1.521C7.095 14.399 6 15.588 6 17.043v1.76C6 19.462 6.507 20 7.13 20h9.74c.623 0 1.13-.537 1.13-1.198v-1.758c0-1.456-1.095-2.644-2.457-2.691-.013-.001-1.422.051-1.826-1.515.264-.213.508-.477.725-.789.467-.67.772-1.505.887-2.408.033-.042.06-.09.082-.142.2-.505.301-1.044.301-1.602 0-2.149-1.535-3.897-3.42-3.897h0zm0 1.1c1.245 0 2.269 1.126 2.374 2.555-.26-.173-.565-.273-.893-.273h-2.349c-.101 0-.198-.034-.279-.098-.07-.055-.123-.128-.155-.212-.096-.254-.332-.413-.59-.395-.258.017-.476.207-.541.473-.099.402-.273.779-.507 1.11-.156-1.282.403-2.474 1.35-2.764.113-.035.232-.055.355-.061.076-.004.15-.025.218-.063.323-.18.666-.271 1.017-.271h0zm-1.703 3.115c.248.175.535.268.835.268h2.349c.248 0 .464.15.571.37-.009 1.443-.586 2.683-1.409 3.227-.026.013-.401.295-.932.295-1.112 0-2.09-1.251-2.299-2.892.366-.362.667-.793.885-1.268zm.636 5.137c.25.08.51.123.778.123.265 0 .524-.042.774-.121.15.487.415.92.758 1.264-.441.34-.977.529-1.532.529-.556 0-1.092-.19-1.534-.53.343-.345.606-.778.756-1.265h0zm-1.677 1.887c.668.645 1.543 1.008 2.455 1.008.912 0 1.786-.363 2.454-1.007.514.222.99.211 1.004.211.828 0 1.502.715 1.502 1.593v1.758c0 .054-.041.097-.092.097H7.13c-.051 0-.092-.043-.092-.097v-1.759c0-.878.674-1.592 1.502-1.592.014 0 .504-.009 1.007-.212h0z"
    }
  ), /* @__PURE__ */ React28.createElement(
    "rect",
    {
      width: "22.4",
      height: "22.4",
      x: ".3",
      y: ".3",
      stroke: "#1B325B",
      strokeWidth: ".6",
      rx: "11.2"
    }
  ))))))
);
LeadIcon.displayName = "LeadIcon";

// src/atoms/icons/LocationIcon.tsx
import * as React29 from "react";
var LocationIcon = () => /* @__PURE__ */ React29.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "39",
    height: "45",
    viewBox: "0 0 39 45"
  },
  /* @__PURE__ */ React29.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React29.createElement("g", null, /* @__PURE__ */ React29.createElement("g", null, /* @__PURE__ */ React29.createElement("g", null, /* @__PURE__ */ React29.createElement("g", { transform: "translate(-98 -215) translate(72 76) translate(27 139)" }, /* @__PURE__ */ React29.createElement("ellipse", { cx: "5.5", cy: "13.5", fill: "#EDF1FA", rx: "3.5", ry: "4.5" }), /* @__PURE__ */ React29.createElement("ellipse", { cx: "32.5", cy: "13.5", fill: "#EDF1FA", rx: "2.5", ry: "4.5" }), /* @__PURE__ */ React29.createElement("ellipse", { cx: "18.5", cy: "21.5", fill: "#EDF1FA", rx: "16.5", ry: "18.5" }), /* @__PURE__ */ React29.createElement(
    "g",
    {
      fill: "#19305A",
      fillRule: "nonzero",
      stroke: "#FFF",
      strokeWidth: "1.3"
    },
    /* @__PURE__ */ React29.createElement("path", { d: "M18.507 44.229c-.332 0-.662-.06-.974-.176-2.694-1.05-11.92-4.919-15.33-13.239-2.55-6.203-2.32-16.363-2.034-20.45.1-1.766 1.705-2.393 2.478-2.715C6 6.307 14.281 2.847 17.146 1.256c.868-.494 1.926-.494 2.794 0 2.865 1.591 11.103 5.05 14.427 6.379.773.306 2.392.949 2.492 2.715h0c.23 4.087.502 14.246-2.048 20.435-3.41 8.35-12.565 12.217-15.287 13.268-.326.119-.67.178-1.017.176h0zm0-41.338c-.16-.005-.319.036-.458.117-2.937 1.65-11.16 5.08-14.685 6.495-1.032.409-1.232.672-1.261.978-.215 3.941-.487 13.736 1.905 19.56 3.124 7.575 11.677 11.21 14.227 12.144.199.074.417.074.616 0 2.521-.934 11.117-4.569 14.155-12.144 2.392-5.839 2.134-15.619 1.905-19.56 0-.306-.23-.57-1.26-.978-3.496-1.46-11.691-4.846-14.643-6.495-.152-.089-.326-.13-.501-.117z" })
  ), /* @__PURE__ */ React29.createElement("g", { fill: "#000", fillRule: "nonzero" }, /* @__PURE__ */ React29.createElement(
    "path",
    {
      d: "M14.844 9.375c0-1.294-1.05-2.343-2.344-2.343-1.294 0-2.344 1.049-2.344 2.343s1.05 2.344 2.344 2.344c1.294-.001 2.342-1.05 2.344-2.344zm-3.906 0c0-.632.38-1.201.964-1.443s1.256-.108 1.703.339c.447.447.58 1.119.338 1.703-.241.583-.811.964-1.443.964-.863-.001-1.562-.7-1.562-1.563zM3.077 2.612c.127.175.371.213.546.086.174-.126.213-.37.086-.545l-.672-.924c-.127-.173-.37-.21-.545-.084-.174.126-.212.37-.087.544l.672.923zM.336 5.528l1.154.162c.138.02.276-.036.362-.146.086-.11.107-.258.054-.387-.052-.13-.17-.221-.307-.24L.445 4.754c-.214-.03-.411.119-.441.332-.03.214.119.411.332.441zM6.681 1.92c.102.019.207-.004.292-.064.086-.059.143-.15.161-.252L7.34.46c.024-.138-.026-.278-.133-.368-.107-.09-.254-.116-.385-.069-.131.048-.227.162-.251.3l-.205 1.144c-.018.102.005.207.064.292.06.085.15.143.252.161zM.993 3.418l.988.588c.12.071.27.074.391.005.122-.068.198-.196.2-.336.002-.14-.071-.27-.191-.34l-.988-.588c-.12-.072-.27-.074-.391-.006-.122.068-.198.197-.2.336-.002.14.071.27.191.341zM4.626 1.715c.047.21.256.342.466.295.21-.047.343-.255.296-.465l-.25-1.12C5.09.215 4.882.083 4.67.13c-.21.047-.342.255-.296.465l.25 1.12zM8.153 2.424c.088.055.194.073.295.05.101-.024.189-.086.243-.174l.625-.999c.114-.183.058-.424-.125-.538-.183-.115-.424-.059-.538.124l-.624.999c-.055.088-.073.194-.05.295.024.1.086.188.174.243zM1.5 6.742l-1.139.313c-.135.036-.24.142-.275.277-.036.136.004.28.103.378.1.098.244.136.379.098l1.139-.312c.135-.037.24-.143.275-.278.036-.136-.004-.28-.103-.378-.1-.098-.244-.135-.379-.098z",
      transform: "translate(6 9)"
    }
  ), /* @__PURE__ */ React29.createElement(
    "path",
    {
      d: "M21.875 20.313h-6.25V16.35c-.016-.416-.366-.74-.781-.726h-4.688c-.415-.014-.765.31-.781.726v3.962h-6.25v-9.594l-.781.681v10.872c-.009.634.497 1.155 1.13 1.166h18.051c.634-.01 1.14-.532 1.131-1.166V11.4l-.781-.681v9.594zm-12.5 2.343h-5.9c-.203-.01-.359-.182-.35-.384v-1.178h6.25v1.562zm5.469 0h-4.688v-6.25h4.688v6.25zm7.031-.384c.009.202-.147.374-.35.384h-5.9v-1.562h6.25v1.178zM19.14 3.711h1.954v3.197l.781.681V3.711c0-.43-.35-.78-.781-.78H19.14c-.432 0-.781.35-.782.78v.812l.782.681V3.711z",
      transform: "translate(6 9)"
    }
  ), /* @__PURE__ */ React29.createElement(
    "path",
    {
      d: "M24.866 11.23L12.756.682c-.147-.128-.365-.128-.513 0L.134 11.229c-.163.142-.18.389-.038.551.142.163.388.18.551.038L12.5 1.495l11.853 10.323c.163.142.41.125.551-.038.142-.162.125-.41-.038-.55zM6.64 16.992c.14.001.27-.073.34-.194.071-.121.071-.27 0-.392-.07-.121-.2-.196-.34-.195h-.78c-.14 0-.27.074-.34.195-.07.121-.07.27 0 .392.07.12.2.195.34.194h.78zM19.14 16.992c.14.001.27-.073.34-.194.071-.121.071-.27 0-.392-.07-.121-.2-.196-.34-.195h-.78c-.14 0-.27.074-.34.195-.07.121-.07.27 0 .392.07.12.2.195.34.194h.78zM2.748 5.561c-.113.706.006 1.429.34 2.061l.609-.532c-.473-1.096-.12-2.374.848-3.073.83-.6 1.938-.649 2.818-.125l.61-.532c-1.168-.82-2.728-.81-3.886.024-.72.518-1.202 1.302-1.339 2.177z",
      transform: "translate(6 9)"
    }
  )))))))
);

// src/atoms/icons/MenuTenant.tsx
import * as React30 from "react";
var MenuTenantIcon = () => {
  return /* @__PURE__ */ React30.createElement("svg", { x: "0px", y: "0px", viewBox: "0 0 12 16" }, /* @__PURE__ */ React30.createElement("g", null, /* @__PURE__ */ React30.createElement(
    "path",
    {
      fill: "white",
      d: "M10,0.4C8.9,0.2,7.5,0,6,0C4.5,0,3.1,0.2,2,0.4C0.7,0.8,0,1.2,0,1.8v12.3c0,0,0,0,0,0c0,0,0,0,0,0c0,0.6,0.7,1.1,2,1.4C3.1,15.8,4.5,16,6,16c1.5,0,2.9-0.2,4-0.4c1.3-0.3,2-0.8,2-1.4c0,0,0,0,0,0c0,0,0,0,0,0V1.8C12,1.2,11.3,0.8,10,0.4z M11,10c0,0.1-0.4,0.4-1.4,0.6C8.6,10.9,7.3,11,6,11c-1.3,0-2.6-0.1-3.6-0.3c-1-0.2-1.4-0.5-1.4-0.6v-3c0.3,0.1,0.6,0.2,1,0.3c1.1,0.3,2.5,0.4,4,0.4c1.5,0,2.9-0.2,4-0.4c0.4-0.1,0.7-0.2,1-0.3V10z M11,5.9c0,0.1-0.4,0.4-1.4,0.6C8.6,6.8,7.3,6.9,6,6.9c-1.3,0-2.6-0.1-3.6-0.3C1.4,6.3,1.1,6,1,5.9V3c0.3,0.1,0.6,0.2,1,0.3c1.1,0.3,2.5,0.4,4,0.4c1.5,0,2.9-0.2,4-0.4c0.4-0.1,0.7-0.2,1-0.3V5.9z M2.4,1.3C3.4,1,4.7,0.9,6,0.9c1.3,0,2.6,0.1,3.6,0.3c1,0.2,1.3,0.5,1.4,0.6c-0.1,0.1-0.4,0.4-1.4,0.6C8.6,2.6,7.3,2.8,6,2.8c-1.3,0-2.6-0.1-3.6-0.3C1.4,2.2,1.1,1.9,1,1.8C1.1,1.8,1.4,1.5,2.4,1.3z M9.6,14.7c-1,0.2-2.2,0.3-3.6,0.3c-1.3,0-2.6-0.1-3.6-0.3c-1-0.2-1.4-0.5-1.4-0.6c0,0,0,0,0,0c0,0,0,0,0,0v-3c0.3,0.1,0.6,0.2,1,0.3c1.1,0.3,2.5,0.4,4,0.4c1.5,0,2.9-0.2,4-0.4c0.4-0.1,0.7-0.2,1-0.3v3c0,0,0,0,0,0c0,0,0,0,0,0C10.9,14.2,10.6,14.5,9.6,14.7z"
    }
  )));
};

// src/atoms/icons/OpportunityIcon.tsx
import * as React31 from "react";
var OpportunityIcon = ({
  width = 23,
  height = 23
}) => /* @__PURE__ */ React31.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 23 23"
  },
  /* @__PURE__ */ React31.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React31.createElement("g", { fillRule: "nonzero" }, /* @__PURE__ */ React31.createElement("g", null, /* @__PURE__ */ React31.createElement("g", null, /* @__PURE__ */ React31.createElement("g", null, /* @__PURE__ */ React31.createElement("g", null, /* @__PURE__ */ React31.createElement("g", null, /* @__PURE__ */ React31.createElement(
    "path",
    {
      fill: "#19305A",
      d: "M11.5.221C5.281.221.222 5.281.222 11.5c0 6.22 5.06 11.278 11.278 11.278 6.219 0 11.278-5.059 11.278-11.278C22.778 5.281 17.718.221 11.5.221zm0 21.968c-5.894 0-10.689-4.795-10.689-10.69C.811 5.607 5.606.812 11.5.812S22.189 5.606 22.189 11.5 17.394 22.189 11.5 22.189z",
      transform: "translate(-201 -246) translate(109 246) translate(92)"
    }
  ), /* @__PURE__ */ React31.createElement(
    "path",
    {
      fill: "#19305A",
      d: "M11.5 2.227c-5.113 0-9.273 4.16-9.273 9.273 0 5.113 4.16 9.273 9.273 9.273 5.113 0 9.272-4.16 9.272-9.273 0-5.113-4.16-9.273-9.272-9.273zm0 17.956c-4.788 0-8.683-3.895-8.683-8.683S6.712 2.816 11.5 2.816s8.683 3.896 8.683 8.684c0 4.788-3.895 8.683-8.683 8.683z",
      transform: "translate(-201 -246) translate(109 246) translate(92)"
    }
  ), /* @__PURE__ */ React31.createElement(
    "path",
    {
      fill: "#1689CA",
      d: "M11.5 7.37h2.212c.162 0 .294-.132.294-.294 0-.163-.132-.295-.294-.295h-1.917v-2.19c0-.163-.133-.295-.295-.295-.163 0-.295.132-.295.295v2.208c-1.243.147-2.211 1.206-2.211 2.49 0 1.381 1.124 2.506 2.506 2.506 1.057 0 1.918.86 1.918 1.917s-.86 1.918-1.918 1.918H9.288c-.162 0-.294.131-.294.295 0 .162.131.294.294.294h1.917v2.19c0 .163.132.295.295.295.162 0 .295-.131.295-.295V16.2c1.243-.147 2.211-1.206 2.211-2.489 0-1.382-1.124-2.507-2.506-2.507-1.058 0-1.918-.86-1.918-1.917s.86-1.918 1.918-1.918z",
      transform: "translate(-201 -246) translate(109 246) translate(92)"
    }
  ), /* @__PURE__ */ React31.createElement(
    "path",
    {
      fill: "#19305A",
      d: "M17.297 11.205h-.638c-.163 0-.295.132-.295.294 0 .163.132.295.295.295h.638c.163 0 .295-.132.295-.295 0-.162-.132-.294-.295-.294zM6.34 11.205h-.638c-.162 0-.294.132-.294.294 0 .163.131.295.294.295h.638c.163 0 .295-.132.295-.295 0-.162-.132-.294-.295-.294z",
      transform: "translate(-201 -246) translate(109 246) translate(92)"
    }
  ))))))))
);
OpportunityIcon.displayName = "OpportunityIcon";

// src/atoms/icons/OpportunityWatermark.tsx
import * as React32 from "react";
var OpportunityWatermark = ({ style, className }) => /* @__PURE__ */ React32.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "436",
    height: "436",
    viewBox: "0 0 436 436",
    style,
    className
  },
  /* @__PURE__ */ React32.createElement("g", { fill: "none", fillRule: "evenodd", opacity: ".029" }, /* @__PURE__ */ React32.createElement("g", { fillRule: "nonzero" }, /* @__PURE__ */ React32.createElement("g", null, /* @__PURE__ */ React32.createElement("g", null, /* @__PURE__ */ React32.createElement(
    "path",
    {
      fill: "#19305A",
      d: "M218 .006C97.8.006.013 97.793.013 217.986.013 338.193 97.807 435.972 218 435.972s217.987-97.786 217.987-217.986C435.994 97.8 338.2.006 218 .006zm0 424.587c-113.92 0-206.593-92.68-206.593-206.6 0-113.92 92.674-206.594 206.593-206.594 113.92 0 206.593 92.675 206.593 206.594.008 113.92-92.674 206.6-206.593 206.6z",
      transform: "translate(-465 -466) translate(465 466)"
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      fill: "#19305A",
      d: "M218 38.775c-98.826 0-179.225 80.399-179.225 179.225S119.167 397.225 218 397.225c98.819 0 179.218-80.392 179.218-179.225 0-98.826-80.4-179.225-179.218-179.225zm0 347.05c-92.545 0-167.832-75.287-167.832-167.832C50.168 125.448 125.455 50.16 218 50.16c92.538 0 167.824 75.287 167.824 167.832 0 92.545-75.286 167.831-167.824 167.831z",
      transform: "translate(-465 -466) translate(465 466)"
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      fill: "#1689CA",
      d: "M218 138.182h42.748c3.14 0 5.694-2.553 5.694-5.693 0-3.14-2.553-5.693-5.694-5.693h-37.055v-42.34c0-3.14-2.552-5.693-5.693-5.693-3.148 0-5.693 2.553-5.693 5.693v42.684c-24.042 2.832-42.749 23.317-42.749 48.112 0 26.708 21.733 48.441 48.45 48.441 20.427 0 37.054 16.628 37.054 37.063 0 20.434-16.627 37.062-37.055 37.062h-42.755c-3.14 0-5.694 2.545-5.694 5.7 0 3.14 2.546 5.686 5.694 5.686h37.055v42.333c0 3.155 2.545 5.7 5.693 5.7 3.14 0 5.693-2.538 5.693-5.7V308.86c24.042-2.832 42.749-23.317 42.749-48.104 0-26.716-21.733-48.456-48.442-48.456-20.442 0-37.062-16.62-37.062-37.048 0-20.442 16.62-37.07 37.062-37.07z",
      transform: "translate(-465 -466) translate(465 466)"
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      fill: "#19305A",
      d: "M330.055 212.293h-12.347c-3.14 0-5.693 2.552-5.693 5.693 0 3.147 2.553 5.7 5.693 5.7h12.347c3.14 0 5.693-2.553 5.693-5.7 0-3.14-2.545-5.693-5.693-5.693zM118.27 212.293h-12.332c-3.14 0-5.693 2.552-5.693 5.693 0 3.147 2.545 5.7 5.693 5.7h12.332c3.141 0 5.694-2.553 5.694-5.7 0-3.14-2.546-5.693-5.694-5.693z",
      transform: "translate(-465 -466) translate(465 466)"
    }
  )))))
);

// src/atoms/icons/PaymentIcon.tsx
import * as React33 from "react";
var PaymentIcon = () => /* @__PURE__ */ React33.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "39",
    height: "45",
    viewBox: "0 0 39 45"
  },
  /* @__PURE__ */ React33.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React33.createElement("g", null, /* @__PURE__ */ React33.createElement("g", null, /* @__PURE__ */ React33.createElement("g", { transform: "translate(-98 -329) translate(99 329)" }, /* @__PURE__ */ React33.createElement("ellipse", { cx: "5.5", cy: "13.5", fill: "#EDF1FA", rx: "3.5", ry: "4.5" }), /* @__PURE__ */ React33.createElement("ellipse", { cx: "32.5", cy: "13.5", fill: "#EDF1FA", rx: "2.5", ry: "4.5" }), /* @__PURE__ */ React33.createElement("ellipse", { cx: "18.5", cy: "21.5", fill: "#EDF1FA", rx: "16.5", ry: "18.5" }), /* @__PURE__ */ React33.createElement(
    "g",
    {
      fill: "#19305A",
      fillRule: "nonzero",
      stroke: "#FFF",
      strokeWidth: "1.3"
    },
    /* @__PURE__ */ React33.createElement("path", { d: "M18.507 44.229c-.332 0-.662-.06-.974-.176-2.694-1.05-11.92-4.919-15.33-13.239-2.55-6.203-2.32-16.363-2.034-20.45.1-1.766 1.705-2.393 2.478-2.715C6 6.307 14.281 2.847 17.146 1.256c.868-.494 1.926-.494 2.794 0 2.865 1.591 11.103 5.05 14.427 6.379.773.306 2.392.949 2.492 2.715h0c.23 4.087.502 14.246-2.048 20.435-3.41 8.35-12.565 12.217-15.287 13.268-.326.119-.67.178-1.017.176h0zm0-41.338c-.16-.005-.319.036-.458.117-2.937 1.65-11.16 5.08-14.685 6.495-1.032.409-1.232.672-1.261.978-.215 3.941-.487 13.736 1.905 19.56 3.124 7.575 11.677 11.21 14.227 12.144.199.074.417.074.616 0 2.521-.934 11.117-4.569 14.155-12.144 2.392-5.839 2.134-15.619 1.905-19.56 0-.306-.23-.57-1.26-.978-3.496-1.46-11.691-4.846-14.643-6.495-.152-.089-.326-.13-.501-.117z" })
  ), /* @__PURE__ */ React33.createElement("g", { fill: "#000", fillRule: "nonzero" }, /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M23.787 14.318v.085c0 .775-.292 1.482-.761 1.995-.234.256-.516.467-.823.61-.01.005-.02.011-.032.011-.083.04-.171.074-.255.097-.099.034-.192.057-.291.074h-.01c-.136.028-.272.04-.412.04H2.587c-.713 0-1.36-.32-1.828-.832-.47-.513-.756-1.22-.756-1.995v-.085c0 .16.115.285.26.285h.272c.041.535.266 1.025.594 1.39.375.41.89.661 1.458.661h18.616c.562 0 1.078-.25 1.454-.661.327-.365.551-.855.593-1.39h.271c.146 0 .266-.125.266-.285z",
      transform: "translate(6 15)"
    }
  ), /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M23.787 11.89v2.428c0 .16-.12.285-.266.285h-.271c.005-.063.01-.131.01-.2V11.606h.261c.146 0 .266.125.266.285z",
      transform: "translate(6 15)"
    }
  ), /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M23.787 10.546v1.345c0-.16-.12-.285-.266-.285h-.26V3.275c0-.621-.235-1.186-.604-1.596-.376-.405-.892-.66-1.454-.66H2.587c-.567 0-1.083.255-1.458.66-.37.41-.605.975-.605 1.596v8.33h-.26c-.146 0-.26.126-.26.286V3.275c0-.781.286-1.488.755-2 .235-.257.516-.468.823-.61.01-.006.021-.012.031-.012.084-.04.172-.074.256-.097C1.967.522 2.06.5 2.16.482h.01c.136-.028.277-.04.418-.04H21.203c.708 0 1.354.32 1.823.832.47.513.761 1.22.761 2v7.271zM23.26 14.033v.37c0 .069-.005.137-.01.2H.535c-.006-.063-.01-.131-.01-.2v-.37H23.26z",
      transform: "translate(6 15)"
    }
  ), /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M.524 11.606H23.26V12.606H.524zM21.916 17.119c.084-.023.172-.06.255-.1-.083.041-.166.077-.255.1zM21.625 17.216c.099-.023.192-.054.291-.1-.094.046-.193.077-.291.1zM21.593 3.303c.297.325.485.78.485 1.282s-.188.952-.485 1.282c-.302.325-.713.53-1.172.53-.24 0-.47-.057-.677-.16-.13-.062-.255-.148-.365-.245-.109.097-.234.183-.364.245l-.016.007c-.203.096-.427.153-.662.153-.458 0-.87-.205-1.172-.535-.297-.325-.485-.775-.485-1.277 0-.501.188-.957.485-1.282l.016-.017c.301-.319.708-.513 1.156-.513.24 0 .47.057.678.154.13.068.255.148.364.245.11-.097.235-.177.365-.245.208-.097.438-.154.677-.154.453 0 .87.2 1.172.53zm-.041 1.282c0-.342-.126-.655-.334-.877-.203-.222-.485-.36-.797-.36-.167 0-.323.035-.464.103-.145.074-.276.177-.38.308l-.02.023c-.11.108-.277.096-.376-.023-.104-.125-.234-.234-.38-.308-.14-.068-.297-.102-.464-.102-.307 0-.583.13-.787.347l-.015.012c-.203.222-.328.535-.328.877 0 .342.125.65.328.872.208.222.49.365.802.365.162 0 .312-.034.453-.103l.011-.006c.146-.074.276-.176.38-.308l.026-.022c.104-.103.27-.091.37.022.104.132.235.24.38.308.141.068.297.109.464.109.312 0 .594-.143.797-.365.208-.223.334-.53.334-.872zM11.83 6.705c.146 0 .266.125.266.285 0 .16-.12.29-.266.29H2.994c-.146 0-.26-.13-.26-.29 0-.16.114-.285.26-.285h8.836zM11.83 8.465c.146 0 .266.132.266.292 0 .153-.12.284-.266.284H8.996c-.14 0-.26-.13-.26-.284 0-.16.12-.292.26-.292h2.834zM8.548 10.13c.14 0 .26.13.26.284 0 .16-.12.291-.26.291H2.994c-.146 0-.26-.131-.26-.29 0-.154.114-.286.26-.286h5.554zM8.12 8.465c.146 0 .266.132.266.292 0 .153-.12.284-.265.284H6.875c-.146 0-.26-.13-.26-.284 0-.16.114-.292.26-.292h1.246zM5.938 8.465c.14 0 .26.132.26.292 0 .153-.12.284-.26.284H2.994c-.146 0-.26-.13-.26-.284 0-.16.114-.292.26-.292h2.944zM5.834 2.733v2.753c0 .085-.032.165-.084.222-.052.062-.13.096-.209.096H3.025c-.083 0-.156-.034-.208-.096-.052-.057-.084-.137-.084-.222V2.733c0-.091.032-.17.084-.228.052-.057.125-.097.208-.097h2.516c.079 0 .157.04.21.097.051.057.083.137.083.228zM5.313 5.23V2.984H3.255v2.245h2.058zM2.16.482c-.099.024-.193.054-.291.1.093-.046.192-.076.291-.1zM1.869.556c-.084.024-.172.06-.256.1.084-.04.167-.076.256-.1z",
      transform: "translate(6 15)"
    }
  ), /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M.524 14.403c0 .068.005.137.01.2h-.27c-.146 0-.26-.125-.26-.285V11.89c0-.16.114-.285.26-.285h.26v2.797z",
      transform: "translate(6 15)"
    }
  ))))))
);

// src/atoms/icons/PiggyBank.tsx
import * as React34 from "react";
import { SvgIcon as SvgIcon4 } from "@mui/material";
var PiggyBank = (props) => /* @__PURE__ */ React34.createElement(
  SvgIcon4,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    ...props
  },
  /* @__PURE__ */ React34.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React34.createElement("g", { fill: "#000", fillRule: "nonzero" }, /* @__PURE__ */ React34.createElement("g", null, /* @__PURE__ */ React34.createElement("g", null, /* @__PURE__ */ React34.createElement(
    "path",
    {
      d: "M29.504 14.694l-2.828-.557c-.551-1.087-1.348-2.03-2.327-2.755.178-.613.14-.686.14-4.047 0-1.015-.822-1.837-1.836-1.837h-.612c-2.467.002-4.547 1.838-4.855 4.286h-1.329c-.305-1.43-1.578-2.446-3.04-2.423-1.463.022-2.705 1.076-2.966 2.515-3.63.536-6.417 3.495-6.735 7.15-.751-.239-1.266-.931-1.28-1.72 0-.338-.273-.612-.612-.612-1.267 0-.557 3.135 1.837 3.612.182 2.592 1.617 4.933 3.845 6.27l.423 4.285c.031.314.296.553.612.551h3.673c.316.002.581-.237.613-.55l.306-3.123h5.51l.306 3.122c.032.314.297.553.612.551h3.674c.315.002.58-.237.612-.55l.429-4.286c1.292-.758 2.335-1.878 3-3.22 2.295-.564 2.62-.521 2.687-1.066l.613-4.898c.053-.321-.154-.628-.472-.698zm-7.463-7.96h.612c.338 0 .612.275.612.613v3.061c0 1.353-1.096 2.45-2.449 2.45-1.352 0-2.449-1.097-2.449-2.45 0-2.029 1.645-3.673 3.674-3.673zm-9.184 1.837c1.015 0 1.837.823 1.837 1.837 0 1.015-.822 1.837-1.837 1.837-1.014 0-1.837-.822-1.837-1.837 0-1.014.823-1.837 1.837-1.837zm15.361 11.137c-1.983.49-2.16.502-2.326.643-.276.22-.435 1.065-1.537 2.167-2.253 2.253-1.635-.545-2.253 5.645h-2.565l-.313-3.122c-.031-.314-.296-.553-.612-.551-6.961 0-7.034-.153-7.194.465-.042.153 0-.453-.342 3.208H8.51c-.428-4.285-.386-4.028-.453-4.187-.063-.121-.153-.226-.263-.307-5.608-3.06-4.151-11.498 2.094-12.55.318 1.34 1.059 1.126-.092 1.126-.338 0-.612.274-.612.612 0 .338.274.612.612.612h6.122c.339 0 .613-.274.613-.612 0-.338-.274-.612-.613-.612-1.187 0-.349.19-.06-1.225h1.34c.252 1.464 1.36 2.632 2.808 2.96 1.449.329 2.952-.248 3.81-1.46 1.898 1.562 1.653 2.64 2.345 2.786l2.547.502-.49 3.9z",
      transform: "translate(-80 -325) translate(80 325)"
    }
  ), /* @__PURE__ */ React34.createElement(
    "path",
    {
      d: "M23.265 14.694c-1.836 0-2.4 2.449-1.224 2.449.338 0 .612-.274.612-.612 0-.339.274-.613.612-.613.338 0 .613.274.613.613 0 .338.274.612.612.612 1.17 0 .612-2.45-1.225-2.45zM15.918 6.122V3.673c0-.338-.274-.612-.612-.612-.338 0-.612.274-.612.612v2.45c0 .338.274.612.612.612.338 0 .612-.274.612-.613zM11.02 6.735v-2.45c0-.337-.274-.612-.612-.612-.338 0-.612.275-.612.613v2.449c0 .338.274.612.612.612.338 0 .612-.274.612-.612zM13.47 4.286V.612c0-.338-.275-.612-.613-.612-.338 0-.612.274-.612.612v3.674c0 .338.274.612.612.612.338 0 .612-.274.612-.612z",
      transform: "translate(-80 -325) translate(80 325)"
    }
  )))))
);
PiggyBank.displayName = "PiggyBank";

// src/atoms/icons/SalesFunnelIcon.tsx
import * as React35 from "react";
var SalesFunnelIcon = (props) => {
  return /* @__PURE__ */ React35.createElement(
    "svg",
    {
      style: props.style,
      width: "57px",
      height: "65px",
      viewBox: "0 0 57 65",
      version: "1.1"
    },
    /* @__PURE__ */ React35.createElement("title", null, "Group"),
    /* @__PURE__ */ React35.createElement("desc", null, "Created with Sketch."),
    /* @__PURE__ */ React35.createElement(
      "g",
      {
        id: "Page-2",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      },
      /* @__PURE__ */ React35.createElement(
        "g",
        {
          id: "Artboard",
          transform: "translate(-110.000000, -84.000000)",
          fill: "#000000",
          fillRule: "nonzero"
        },
        /* @__PURE__ */ React35.createElement("g", { id: "Group", transform: "translate(110.000000, 84.000000)" }, /* @__PURE__ */ React35.createElement(
          "path",
          {
            d: "M47.4,30.3 C47.7,30.6 47.9,31 47.9,31.3 L49.4,31.3 C49.4,30.5 49,29.7 48.4,29.1 C48,28.7 47.4,28.5 46.8,28.4 L46.8,26.7 L45.3,26.7 L45.3,28.4 C44.7,28.5 44.1,28.8 43.7,29.1 C43,29.7 42.7,30.4 42.7,31.3 C42.7,32.1 43.1,32.9 43.7,33.5 C44.3,34 45.2,34.3 46,34.3 C46.5,34.3 47,34.5 47.4,34.8 C47.7,35.1 47.9,35.5 47.9,35.8 C47.9,36.2 47.7,36.6 47.4,36.8 C46.7,37.4 45.4,37.4 44.7,36.8 C44.4,36.5 44.2,36.1 44.2,35.8 L42.7,35.8 C42.7,36.6 43.1,37.4 43.7,38 C44.1,38.4 44.7,38.6 45.3,38.8 L45.3,40.5 L46.8,40.5 L46.8,38.8 C47.4,38.7 47.9,38.4 48.4,38 C49.1,37.4 49.4,36.7 49.4,35.8 C49.4,35 49,34.2 48.4,33.6 C47.8,33.1 46.9,32.8 46.1,32.8 C45.6,32.8 45.1,32.6 44.7,32.3 C44.4,32 44.2,31.6 44.2,31.3 C44.2,31 44.4,30.5 44.7,30.3 C45.4,29.7 46.7,29.7 47.4,30.3 Z",
            id: "Path"
          }
        ), /* @__PURE__ */ React35.createElement(
          "path",
          {
            d: "M46.6,23 L51.5,16.6 C51.7,16.4 51.7,16.1 51.6,15.8 C51.5,15.5 51.2,15.4 50.9,15.4 L30,15.4 C29.6,15.4 29.2,15.7 29.2,16.2 C29.2,16.6 29.5,17 30,17 L49.4,17 L44.7,23.1 C39.5,23.8 35.5,28.2 35.5,33.6 C35.5,34.1 35.5,34.6 35.6,35 L30.8,41.3 C30,42.3 29.6,43.6 29.6,44.9 L29.6,59.7 L22.5,62.7 L22.5,44.9 C22.5,43.6 22.1,42.4 21.3,41.3 L2.6,16.9 L11.2,16.9 C11.6,16.9 12,16.6 12,16.1 C12,15.7 11.7,15.3 11.2,15.3 L1.1,15.3 C0.8,15.3 0.6,15.5 0.4,15.7 C0.3,16 0.3,16.3 0.5,16.5 L20,42.3 C20.6,43.1 20.9,44 20.9,45 L20.9,63.9 C20.9,64.2 21,64.4 21.2,64.5 C21.3,64.6 21.5,64.6 21.6,64.6 C21.7,64.6 21.8,64.6 21.9,64.5 L30.5,60.9 C30.8,60.8 31,60.5 31,60.2 L31,44.9 C31,43.9 31.3,43 31.9,42.2 L36,36.9 C37.4,41.1 41.4,44.2 46.1,44.2 C52,44.2 56.7,39.4 56.7,33.6 C56.7,27.9 52.2,23.3 46.6,23 Z M46.1,42.7 C41.1,42.7 37,38.6 37,33.6 C37,28.6 41.1,24.5 46.1,24.5 C51.1,24.5 55.2,28.6 55.2,33.6 C55.2,38.6 51.1,42.7 46.1,42.7 Z",
            id: "Shape"
          }
        ), /* @__PURE__ */ React35.createElement(
          "polygon",
          {
            id: "Path",
            points: "11.3 19.5 16 24.2 20.7 19.5 19.6 18.4 16.7 21.3 16.7 13.7 15.2 13.7 15.2 21.3 12.3 18.4"
          }
        ), /* @__PURE__ */ React35.createElement(
          "rect",
          {
            id: "Rectangle",
            x: "15.2",
            y: "10.2",
            width: "1.5",
            height: "1.5"
          }
        ), /* @__PURE__ */ React35.createElement(
          "rect",
          {
            id: "Rectangle",
            x: "15.2",
            y: "7.2",
            width: "1.5",
            height: "1.5"
          }
        ), /* @__PURE__ */ React35.createElement(
          "polygon",
          {
            id: "Path",
            points: "29.3 12.7 28.2 11.7 25.3 14.6 25.3 6.9 23.8 6.9 23.8 14.6 20.9 11.7 19.9 12.7 24.6 17.4"
          }
        ), /* @__PURE__ */ React35.createElement(
          "rect",
          {
            id: "Rectangle",
            x: "23.8",
            y: "3.4",
            width: "1.5",
            height: "1.5"
          }
        ), /* @__PURE__ */ React35.createElement(
          "rect",
          {
            id: "Rectangle",
            x: "23.8",
            y: "0.4",
            width: "1.5",
            height: "1.5"
          }
        ))
      )
    )
  );
};

// src/atoms/icons/SalesTeamIcon.tsx
import * as React36 from "react";
var SalesTeamIcon = (props) => {
  return /* @__PURE__ */ React36.createElement("svg", { style: props.style, width: "47", height: "47", viewBox: "0 0 47 47" }, /* @__PURE__ */ React36.createElement("g", { fill: "none" }, /* @__PURE__ */ React36.createElement(
    "path",
    {
      fill: "#1689CA",
      stroke: "#1689CA",
      d: "M22.5 44.819C10.193 44.819.181 34.807.181 22.5.181 10.193 10.193.181 22.5.181c12.307 0 22.319 10.012 22.319 22.319 0 12.307-10.012 22.319-22.319 22.319zm0-43.549c-11.706 0-21.23 9.524-21.23 21.23 0 11.706 9.524 21.23 21.23 21.23 11.707 0 21.23-9.524 21.23-21.23 0-11.706-9.523-21.23-21.23-21.23z",
      transform: "translate(1 1)"
    }
  ), /* @__PURE__ */ React36.createElement("g", { fill: "#000" }, /* @__PURE__ */ React36.createElement(
    "path",
    {
      d: "M20.962 9.188l-1.84-1.027c-.175-.098-.4-.049-.518.117-.527.738-1.487 1.197-2.505 1.197-1.018 0-1.978-.459-2.504-1.197-.114-.159-.326-.213-.501-.126l-1.805.895c-.383.19-.621.555-.621.952v6.15c0 .223.179.403.399.403H21.13c.22 0 .4-.18.4-.402V10.11c0-.379-.211-.724-.568-.923zM16.1 7.593c1.784 0 3.234-1.45 3.234-3.23v-.942c0-1.78-1.451-3.23-3.234-3.23s-3.234 1.45-3.234 3.23v.942c0 1.781 1.45 3.23 3.234 3.23zM8.62 10.304L7.144 9.48c-.176-.099-.4-.049-.517.117-.408.571-1.153.926-1.944.926-.79 0-1.536-.355-1.943-.926-.114-.16-.326-.213-.501-.126l-1.448.717c-.334.166-.541.486-.541.834v5.128c0 .222.179.402.4.402h8.066c.221 0 .4-.18.4-.402v-5.037c0-.334-.186-.637-.496-.81zM4.682 9.068c1.474 0 2.672-1.197 2.672-2.67v-.755c0-1.472-1.198-2.67-2.672-2.67-1.473 0-2.671 1.198-2.671 2.67V6.4c0 1.472 1.199 2.669 2.671 2.669zM31.454 10.304l-1.476-.823c-.176-.098-.399-.05-.518.117-.408.571-1.153.926-1.944.926-.79 0-1.535-.355-1.943-.926-.114-.16-.327-.212-.5-.126l-1.448.717c-.335.166-.542.486-.542.834v5.128c0 .222.18.402.4.402h8.067c.221 0 .4-.18.4-.402v-5.037c0-.334-.185-.637-.496-.81zM27.517 9.068c1.473 0 2.673-1.197 2.673-2.67v-.755c0-1.472-1.199-2.67-2.673-2.67-1.473 0-2.672 1.198-2.672 2.67V6.4c0 1.472 1.199 2.669 2.672 2.669z",
      transform: "translate(1 1) translate(6.136 14.318)"
    }
  ))));
};

// src/atoms/icons/ServiceIcon.tsx
import * as React37 from "react";
var ServiceIcon = ({ width = 23, height = 23 }) => /* @__PURE__ */ React37.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 23 23"
  },
  /* @__PURE__ */ React37.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React37.createElement("g", { fillRule: "nonzero" }, /* @__PURE__ */ React37.createElement("g", null, /* @__PURE__ */ React37.createElement("g", null, /* @__PURE__ */ React37.createElement("g", null, /* @__PURE__ */ React37.createElement("g", null, /* @__PURE__ */ React37.createElement("g", { fill: "#19305A" }, /* @__PURE__ */ React37.createElement("g", null, /* @__PURE__ */ React37.createElement(
    "path",
    {
      d: "M11.5.221C5.281.221.222 5.281.222 11.5c0 6.22 5.06 11.278 11.278 11.278 6.219 0 11.278-5.059 11.278-11.278C22.778 5.281 17.718.221 11.5.221zm0 21.968c-5.894 0-10.689-4.795-10.689-10.69C.811 5.607 5.606.812 11.5.812S22.189 5.606 22.189 11.5 17.394 22.189 11.5 22.189z",
      transform: "translate(-340 -246) translate(109 246) translate(231)"
    }
  ), /* @__PURE__ */ React37.createElement(
    "path",
    {
      d: "M11.5 2.227c-5.113 0-9.273 4.16-9.273 9.273 0 5.113 4.16 9.273 9.273 9.273 5.113 0 9.272-4.16 9.272-9.273 0-5.113-4.16-9.273-9.272-9.273zm0 17.956c-4.788 0-8.683-3.895-8.683-8.683S6.712 2.816 11.5 2.816s8.683 3.896 8.683 8.684c0 4.788-3.895 8.683-8.683 8.683z",
      transform: "translate(-340 -246) translate(109 246) translate(231)"
    }
  ), /* @__PURE__ */ React37.createElement(
    "path",
    {
      d: "M17.297 11.205h-.638c-.163 0-.295.132-.295.294 0 .163.132.295.295.295h.638c.163 0 .295-.132.295-.295 0-.162-.132-.294-.295-.294zM6.34 11.205h-.638c-.162 0-.294.132-.294.294 0 .163.131.295.294.295h.638c.163 0 .295-.132.295-.295 0-.162-.132-.294-.295-.294z",
      transform: "translate(-340 -246) translate(109 246) translate(231)"
    }
  ))), /* @__PURE__ */ React37.createElement("g", { fill: "#0288CD" }, /* @__PURE__ */ React37.createElement(
    "path",
    {
      d: "M2.53 11.691h3.13c.154 0 .278-.125.278-.278V7.63c1.39-.7 2.263-2.126 2.253-3.681C8.181 2.21 7.094.66 5.464.057c-.086-.032-.182-.02-.257.033-.075.052-.12.138-.12.23v3.308H3.14L3.1.275C3.1.185 3.056.103 2.984.052 2.912 0 2.819-.014 2.734.014 1.079.588-.023 2.16 0 3.912-.008 5.466.864 6.89 2.252 7.588v3.825c0 .153.124.278.278.278zM.556 3.907C.542 2.54 1.318 1.287 2.548.692l.038 3.225c0 .153.124.278.278.278H5.37c.154 0 .279-.125.279-.278V.744c1.21.61 1.977 1.846 1.988 3.202.011 1.402-.809 2.677-2.088 3.25-.102.044-.167.144-.168.254v3.684H2.81V7.411c0-.11-.066-.21-.167-.255C1.362 6.584.544 5.308.556 3.906z",
      transform: "translate(-340 -246) translate(109 246) translate(231) translate(7.393 5.75)"
    }
  ))))))))
);
ServiceIcon.displayName = "ServiceIcon";

// src/atoms/icons/ValidationAsteriskIcon.tsx
import * as React38 from "react";
var ValidationAsteriskIcon = (props) => {
  const { color = "red" } = props;
  return /* @__PURE__ */ React38.createElement("svg", { x: "0px", y: "-200px", width: "0.5em", height: "0.5em", viewBox: "0 0 128 128" }, /* @__PURE__ */ React38.createElement("g", null, /* @__PURE__ */ React38.createElement(
    "path",
    {
      fill: color,
      d: "M110.1,16.4L75.8,56.8l0.3,1l50.6-10.2v32.2l-50.9-8.9l-0.3,1l34.7,39.1l-28.3,16.5L63.7,78.2L63,78.5   l-18.5,49L17.2,111l34.1-39.8v-0.6l-50,9.2V47.6l49.3,9.9l0.3-0.6L17.2,16.7L45.5,0.5l17.8,48.7H64L82.1,0.5L110.1,16.4z"
    }
  )));
};

// src/atoms/icons/ScheduleIcon.tsx
import * as React39 from "react";
function ScheduleIcon() {
  return /* @__PURE__ */ React39.createElement(
    "svg",
    {
      width: "52",
      height: "37",
      viewBox: "0 0 52 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M41.6456 6.42385V10.2431C41.6456 10.2431 1.8149 10.1443 1.00001 10.2431V6.42385C0.998926 6.07008 1.0678 5.71958 1.20268 5.39253C1.33756 5.06548 1.53579 4.76833 1.78594 4.51818C2.0361 4.26802 2.33325 4.0698 2.6603 3.93492C2.98735 3.80004 3.33784 3.73116 3.69161 3.73225H38.954C39.3078 3.73116 39.6583 3.80004 39.9853 3.93492C40.3124 4.0698 40.6095 4.26802 40.8597 4.51818C41.1098 4.76833 41.308 5.06548 41.4429 5.39253C41.5778 5.71958 41.6467 6.07008 41.6456 6.42385Z",
        fill: "#005AA3",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M32.6571 32.9034H3.69161C3.33745 32.9034 2.98677 32.8335 2.65968 32.6977C2.33258 32.5619 2.03549 32.3629 1.78545 32.1121C1.5354 31.8613 1.33731 31.5636 1.20253 31.2361C1.06775 30.9086 0.99893 30.5577 1.00001 30.2036V10.2429C1.82313 10.1442 41.6456 10.2429 41.6456 10.2429V30.2036C41.6467 30.5577 41.5779 30.9086 41.4431 31.2361C41.3083 31.5636 41.1102 31.8613 40.8602 32.1121C40.6101 32.3629 40.313 32.5619 39.9859 32.6977C39.6588 32.8335 39.3082 32.9034 38.954 32.9034",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M32.6571 32.9034H3.69161C3.33745 32.9034 2.98677 32.8335 2.65968 32.6977C2.33258 32.5619 2.03549 32.3629 1.78545 32.1121C1.5354 31.8613 1.33731 31.5636 1.20253 31.2361C1.06775 30.9086 0.99893 30.5577 1.00001 30.2036V10.2429C1.82313 10.1442 41.6456 10.2429 41.6456 10.2429V30.2036C41.6467 30.5577 41.5779 30.9086 41.4431 31.2361C41.3083 31.5636 41.1102 31.8613 40.8602 32.1121C40.6101 32.3629 40.313 32.5619 39.9859 32.6977C39.6588 32.8335 39.3082 32.9034 38.954 32.9034",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M41.8183 16.1948H41.6125C41.2125 16.1948 40.8882 16.5191 40.8882 16.9192V18.1292C40.8882 18.5292 41.2125 18.8535 41.6125 18.8535H41.8183C42.2184 18.8535 42.5427 18.5292 42.5427 18.1292V16.9192C42.5427 16.5191 42.2184 16.1948 41.8183 16.1948Z",
        fill: "white",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M41.6456 10.2429H1C1.81489 10.1442 41.6456 10.2429 41.6456 10.2429Z",
        fill: "white",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M4.09473 14.7954H9.16514",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M13.9229 14.7954H18.9933",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M23.6436 14.7954H28.714",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M33.4722 14.7954H38.5426",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M4.09473 21.2563H9.16514",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M13.9229 21.2563H18.9933",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M23.6436 21.2563H28.714",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M4.09473 27.7266H9.16514",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M13.9229 27.7266H18.9933",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M23.6436 27.7266H28.714",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M33.4722 27.7266H38.5426",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M12.0707 2.44872C12.0707 1.64863 11.4221 1.00003 10.622 1.00003C9.82195 1.00003 9.17334 1.64863 9.17334 2.44872V5.00039C9.17334 5.80047 9.82195 6.44907 10.622 6.44907C11.4221 6.44907 12.0707 5.80047 12.0707 5.00039V2.44872Z",
        fill: "white",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M33.4716 2.44869C33.4716 1.6486 32.823 1 32.0229 1C31.2228 1 30.5742 1.6486 30.5742 2.44869V5.00036C30.5742 5.80044 31.2228 6.44904 32.0229 6.44904C32.823 6.44904 33.4716 5.80044 33.4716 5.00036V2.44869Z",
        fill: "white",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M48.3216 18.1131L48.315 18.1082C48.0183 17.89 47.601 17.9537 47.3828 18.2503L46.1637 19.9081C45.9456 20.2048 46.0092 20.6221 46.3059 20.8402L46.3125 20.8451C46.6091 21.0633 47.0265 20.9996 47.2446 20.703L48.4637 19.0452C48.6819 18.7485 48.6182 18.3312 48.3216 18.1131Z",
        fill: "white",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M37.1061 20.8405L37.1128 20.8357C37.4094 20.6175 37.4731 20.2002 37.2549 19.9035L36.0358 18.2457C35.8177 17.9491 35.4003 17.8855 35.1037 18.1036L35.097 18.1085C34.8004 18.3266 34.7368 18.744 34.9549 19.0406L36.174 20.6984C36.3922 20.9951 36.8095 21.0587 37.1061 20.8405Z",
        fill: "white",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M41.6457 36.2044C46.6099 36.2044 50.6342 32.1802 50.6342 27.216C50.6342 22.2518 46.6099 18.2275 41.6457 18.2275C36.6815 18.2275 32.6572 22.2518 32.6572 27.216C32.6572 32.1802 36.6815 36.2044 41.6457 36.2044Z",
        fill: "#005AA3",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M41.6453 33.8255C45.2957 33.8255 48.2549 30.8662 48.2549 27.2158C48.2549 23.5654 45.2957 20.6062 41.6453 20.6062C37.9949 20.6062 35.0356 23.5654 35.0356 27.2158C35.0356 30.8662 37.9949 33.8255 41.6453 33.8255Z",
        fill: "white",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M46.3955 27.2161H48.2558",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M35.0356 27.216H36.8959",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M41.6455 22.4664V20.6062",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M41.6455 33.8173V31.957",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement("path", { d: "M41.6455 24.7467V27.216H44.9133", fill: "white" }),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M41.6455 24.7467V27.216H44.9133",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M43.0868 14.6885H40.3459C40.0049 14.6885 39.7285 14.9649 39.7285 15.3058V16.2195C39.7285 16.5604 40.0049 16.8368 40.3459 16.8368H43.0868C43.4278 16.8368 43.7042 16.5604 43.7042 16.2195V15.3058C43.7042 14.9649 43.4278 14.6885 43.0868 14.6885Z",
        fill: "white",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  );
}

// src/atoms/icons/ActivityIcon.tsx
import * as React40 from "react";
function ActivityIcon(props) {
  const { variant = "small" } = props;
  const [width, height] = React40.useMemo(() => {
    switch (variant) {
      case "item-icon":
        return [14, 17.2];
      case "extra-small":
        return [20, 24.5];
      case "small":
        return [27, 34];
      case "medium":
        return [51, 62];
      case "large":
        return [70, 62];
    }
  }, [variant]);
  return /* @__PURE__ */ React40.createElement(
    "svg",
    {
      width,
      height,
      viewBox: "0 0 27 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        d: "M19.9079 6.58304H18.6401H15.5921H11.9029H8.71496C8.19899 6.58304 7.67934 6.5683 7.16339 6.58304H7.14128C7.49509 7.0511 7.8526 7.51548 8.20641 7.98352C8.53811 6.95895 8.8698 5.93439 9.20516 4.90983C9.29361 4.63341 9.38206 4.36069 9.4742 4.08427C9.12039 4.35332 8.76288 4.62605 8.40907 4.89507H10.8857C11.4828 4.89507 11.9914 4.39015 11.9914 3.78943C11.9914 3.66412 11.9987 3.53881 12.0135 3.41351C11.9987 3.51302 11.9877 3.60884 11.9729 3.70835C12.0061 3.47985 12.0651 3.25872 12.1535 3.04128L12.043 3.30664C12.1056 3.15921 12.1793 3.01548 12.2678 2.87911C12.2715 2.87174 12.3415 2.75749 12.3489 2.76118C12.3525 2.76118 12.1646 2.98599 12.2641 2.87174C12.3231 2.8054 12.3783 2.73906 12.441 2.67641C12.4963 2.62113 12.5589 2.56585 12.6179 2.51425C12.6879 2.45528 12.7948 2.41843 12.5258 2.58428C12.5589 2.56217 12.5921 2.53637 12.6253 2.51425C12.7653 2.41843 12.9164 2.34103 13.0712 2.27469L12.8059 2.38526C13.0196 2.2968 13.2408 2.23784 13.4729 2.20467C13.3734 2.21941 13.2776 2.23046 13.1781 2.24521C13.4177 2.21572 13.6535 2.21572 13.8894 2.24521C13.7899 2.23046 13.6941 2.21941 13.5946 2.20467C13.8231 2.23783 14.0442 2.2968 14.2617 2.38526L13.9963 2.27469C14.1437 2.33735 14.2875 2.41105 14.4238 2.49951C14.4312 2.50319 14.5454 2.57322 14.5418 2.58059C14.5418 2.58427 14.3169 2.39631 14.4312 2.49582C14.4975 2.55479 14.5639 2.61007 14.6265 2.67272C14.6818 2.72801 14.7371 2.79066 14.7887 2.84963C14.8477 2.91966 14.8808 3.02285 14.7187 2.75749C14.7408 2.79066 14.7666 2.82383 14.7887 2.857C14.8808 2.99705 14.9619 3.14816 15.0282 3.30295L14.9177 3.03759C15.0061 3.25135 15.0651 3.47248 15.0983 3.70467C15.0835 3.60516 15.0725 3.50934 15.0577 3.40983C15.0725 3.53514 15.0798 3.66044 15.0798 3.78575C15.0798 4.3828 15.5848 4.89138 16.1855 4.89138H18.64C18.2862 4.62234 17.9287 4.34961 17.5749 4.08059C17.9103 5.1162 18.2457 6.14818 18.5811 7.18379C18.6658 7.44915 18.7543 7.71451 18.8391 7.97619C19.016 8.52533 19.613 8.93808 20.199 8.75012C20.7482 8.57322 21.1609 7.97983 20.973 7.39015C20.6413 6.36559 20.3096 5.34102 19.9742 4.31646C19.8858 4.04004 19.7973 3.76732 19.7052 3.49091C19.5541 3.02653 19.1413 2.68011 18.64 2.68011H16.1855L17.2911 3.78575C17.2911 3.05973 17.0847 2.29678 16.6719 1.69605C16.1965 1.00683 15.5663 0.516687 14.7813 0.21814C13.3697 -0.31626 11.6117 0.159172 10.6682 1.33853C10.1044 2.04986 9.78002 2.87905 9.78002 3.79309L10.8857 2.68746H8.40899C7.90407 2.68746 7.49502 3.03389 7.34386 3.49825C7.00847 4.53387 6.6731 5.56584 6.33769 6.60146C6.25293 6.86682 6.16447 7.13217 6.07971 7.39386C5.8549 8.08308 6.45563 8.79433 7.14484 8.79433H8.41262H11.4606H15.1498H18.3377C18.8537 8.79433 19.3696 8.80539 19.8893 8.79433H19.9114C20.49 8.79433 21.0429 8.28573 21.0171 7.6887C20.9839 7.09164 20.5269 6.58306 19.9077 6.58306L19.9079 6.58304Z",
        fill: "#19305A"
      }
    ),
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        d: "M24.7887 9.14802V11.1161V15.804V21.4539V26.2487C24.7887 26.9784 24.7924 27.7045 24.7887 28.4342C24.7887 28.589 24.7777 28.7438 24.7592 28.9023C24.774 28.8028 24.785 28.707 24.7998 28.6075C24.7556 28.917 24.6745 29.2192 24.5529 29.5104C24.5897 29.4219 24.6266 29.3335 24.6634 29.245C24.5786 29.4367 24.4828 29.6209 24.3649 29.7978C24.3538 29.8163 24.2727 29.9563 24.2543 29.9563C24.2728 29.9563 24.457 29.7057 24.3096 29.8826C24.2433 29.9637 24.1732 30.0374 24.0995 30.1111C24.0258 30.1848 23.9484 30.2548 23.871 30.3212C23.801 30.3802 23.6573 30.4575 23.9447 30.2659C23.8968 30.2954 23.8526 30.3322 23.8084 30.3617C23.6278 30.4834 23.4362 30.5865 23.2371 30.6713C23.3256 30.6345 23.414 30.5976 23.5025 30.5608C23.2113 30.6824 22.9128 30.7635 22.5996 30.8077C22.6991 30.7929 22.7949 30.7819 22.8944 30.7671C22.6106 30.804 22.3305 30.7966 22.0467 30.7966H20.7753H16.4706H11.1708H6.6413C5.95208 30.7966 5.26664 30.8003 4.57742 30.7966C4.42262 30.7966 4.26783 30.7856 4.11304 30.7671C4.21255 30.7819 4.30837 30.7929 4.40788 30.8077C4.0983 30.7635 3.79609 30.6824 3.50496 30.5608C3.59342 30.5976 3.68187 30.6345 3.77032 30.6713C3.57867 30.5865 3.3944 30.4907 3.2175 30.3728C3.19907 30.3617 3.05902 30.2806 3.05902 30.2622C3.05902 30.2807 3.30963 30.4649 3.13273 30.3175C3.05165 30.2512 2.97794 30.1811 2.90423 30.1074C2.83052 30.0337 2.7605 29.9563 2.69416 29.8789C2.63519 29.8089 2.55779 29.6652 2.74944 29.9526C2.71995 29.9047 2.6831 29.8605 2.65361 29.8163C2.53199 29.6357 2.4288 29.444 2.34403 29.245C2.38088 29.3335 2.41774 29.4219 2.45459 29.5104C2.33297 29.2192 2.25189 28.9207 2.20766 28.6075C2.2224 28.707 2.23346 28.8028 2.2482 28.9023C2.21134 28.6075 2.21872 28.3089 2.21872 28.0141V26.6505V21.9846V16.2831V11.3925C2.21872 10.648 2.21503 9.90351 2.21872 9.15903C2.21872 9.00423 2.22977 8.84944 2.2482 8.69097C2.23346 8.79048 2.2224 8.8863 2.20766 8.98581C2.25189 8.67622 2.33297 8.37402 2.45459 8.08289C2.41774 8.17134 2.38088 8.25979 2.34403 8.34825C2.42879 8.1566 2.52462 7.97233 2.64255 7.79542C2.65361 7.77699 2.73469 7.63694 2.75312 7.63694C2.73469 7.63694 2.55042 7.88756 2.69783 7.71066C2.76417 7.62958 2.8342 7.55586 2.90791 7.48216C2.98162 7.40845 3.05902 7.33842 3.13641 7.27208C3.20644 7.21311 3.35017 7.13572 3.0627 7.32736C3.11061 7.29788 3.15484 7.26102 3.19906 7.23154C3.37965 7.10992 3.57129 7.00673 3.77031 6.92195C3.68186 6.95881 3.59341 6.99567 3.50496 7.03252C3.79611 6.91089 4.09464 6.82981 4.40788 6.78558C4.30837 6.80033 4.21255 6.81138 4.11304 6.82612C4.55898 6.77084 5.02337 6.79664 5.4693 6.79664H7.34153H7.79116C7.43735 6.32858 7.07984 5.8642 6.72603 5.39616C6.50858 6.06324 6.29114 6.73403 6.07369 7.40108C5.84888 8.0903 6.44961 8.80156 7.13882 8.80156H8.40661H11.4546H15.1437H18.3317C18.8477 8.80156 19.3636 8.81261 19.8833 8.80156H19.9054C20.5983 8.80156 21.1954 8.09023 20.9705 7.40108C20.7531 6.73401 20.5356 6.06321 20.3182 5.39616C19.9644 5.86422 19.6069 6.3286 19.2531 6.79664H22.1904C22.4263 6.79664 22.6548 6.79664 22.8907 6.82612C22.7912 6.81138 22.6954 6.80033 22.5959 6.78558C22.9054 6.82981 23.2076 6.91089 23.4988 7.03252C23.4103 6.99566 23.3219 6.9588 23.2334 6.92195C23.4251 7.00672 23.6093 7.10254 23.7862 7.22048C23.8047 7.23154 23.9447 7.31262 23.9447 7.33104C23.9447 7.31262 23.6941 7.12834 23.871 7.27576C23.9521 7.3421 24.0258 7.41212 24.0995 7.48584C24.1732 7.55955 24.2432 7.63694 24.3096 7.71433C24.3686 7.78436 24.4459 7.9281 24.2543 7.64062C24.2838 7.68853 24.3206 7.73276 24.3501 7.77698C24.4717 7.95757 24.5749 8.14922 24.6597 8.34824L24.5491 8.08288C24.6708 8.37404 24.7518 8.67256 24.7961 8.9858C24.7813 8.88629 24.7703 8.79047 24.7555 8.69096C24.7777 8.84207 24.785 8.99686 24.7887 9.14796C24.7924 9.72658 25.2936 10.2794 25.8943 10.2536C26.4914 10.2278 27.0037 9.76711 27 9.14796C26.9852 7.12829 25.6253 5.30027 23.672 4.75116C23.1412 4.60374 22.5995 4.58163 22.054 4.58163H20.4435H19.253C18.5602 4.58163 17.9631 5.29295 18.1879 5.98211C18.4054 6.64918 18.6228 7.31998 18.8403 7.98702C19.1941 7.51897 19.5516 7.05459 19.9054 6.58655H18.6376H15.5897H11.9005H8.71249C8.19652 6.58655 7.67687 6.57181 7.16092 6.58655H7.13881C7.49261 7.05461 7.85013 7.51899 8.20394 7.98702C8.42139 7.31995 8.63883 6.64915 8.85627 5.98211C9.08109 5.29289 8.48035 4.58163 7.79114 4.58163H6.10688C5.52825 4.58163 4.94227 4.55215 4.36364 4.589C2.90049 4.67377 1.62159 5.40721 0.781344 6.60126C0.254317 7.34945 0.00370657 8.28924 0 9.19586V11.1971V15.2438V20.1713V24.7524V27.8261V28.4158C0.00368548 29.5435 0.40909 30.5792 1.12774 31.4379C1.96435 32.4404 3.27641 32.9969 4.56629 33.0042H5.04172H8.07491H12.7039H17.5688H21.247C22.0799 33.0042 22.9497 33.0595 23.7568 32.8052C24.4349 32.5915 25.0504 32.234 25.5664 31.7475C26.0898 31.261 26.4509 30.6566 26.7089 29.9969C26.9227 29.4551 26.989 28.8617 26.989 28.2831V25.9391V21.6934V16.7585V12.2953V9.52749V9.14051C26.989 8.56189 26.4804 8.00907 25.8834 8.03488C25.2937 8.06805 24.7888 8.52873 24.7888 9.14793L24.7887 9.14802Z",
        fill: "#19305A"
      }
    ),
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        d: "M5.34735 14.9519H6.97635H10.8683H15.5931H19.6656C20.329 14.9519 20.9924 14.9667 21.6521 14.9519H21.6816C22.2602 14.9519 22.813 14.4433 22.7872 13.8463C22.7614 13.2455 22.3007 12.7407 21.6816 12.7407H20.0526H16.1607H11.4359H7.36335C6.69996 12.7407 6.03654 12.7259 5.37683 12.7407H5.34735C4.76873 12.7407 4.2159 13.2493 4.24171 13.8463C4.26753 14.4433 4.72452 14.9519 5.34735 14.9519Z",
        fill: "#19305A"
      }
    ),
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        d: "M5.34735 20.9371H6.97635H10.8683H15.5931H19.6656C20.329 20.9371 20.9924 20.9518 21.6521 20.9371H21.6816C22.2602 20.9371 22.813 20.4285 22.7872 19.8314C22.7614 19.2307 22.3007 18.7258 21.6816 18.7258H20.0526H16.1607H11.4359H7.36335C6.69996 18.7258 6.03654 18.711 5.37683 18.7258H5.34735C4.76873 18.7258 4.2159 19.2344 4.24171 19.8314C4.26751 20.4322 4.72452 20.9371 5.34735 20.9371Z",
        fill: "#19305A"
      }
    ),
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        d: "M5.34735 26.9228H9.13971H15.1397H16.5218C17.1004 26.9228 17.6532 26.4142 17.6274 25.8172C17.6016 25.2164 17.1409 24.7115 16.5218 24.7115H12.7294H6.72943H5.34735C4.76873 24.7115 4.2159 25.2202 4.24171 25.8172C4.26751 26.4179 4.72452 26.9228 5.34735 26.9228Z",
        fill: "#19305A"
      }
    )
  );
}

// src/atoms/icons/PaymentIconV2.tsx
import * as React41 from "react";
function PaymentIconV2() {
  return /* @__PURE__ */ React41.createElement(
    "svg",
    {
      width: "45",
      height: "29",
      viewBox: "0 0 45 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        d: "M7.88127 28.344H3.32119C2.70557 28.344 2.11517 28.0994 1.67986 27.6641C1.24455 27.2288 1 26.6384 1 26.0228V3.32119C1 2.70557 1.24455 2.11517 1.67986 1.67986C2.11517 1.24455 2.70557 1 3.32119 1H41.9584C42.574 1 43.1644 1.24455 43.5997 1.67986C44.035 2.11517 44.2796 2.70557 44.2796 3.32119V26.0228C44.2796 26.6384 44.035 27.2288 43.5997 27.6641C43.1644 28.0994 42.574 28.344 41.9584 28.344H14.211",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        d: "M7.88127 28.344H3.32119C2.70557 28.344 2.11517 28.0994 1.67986 27.6641C1.24455 27.2288 1 26.6384 1 26.0228V3.32119C1 2.70557 1.24455 2.11517 1.67986 1.67986C2.11517 1.24455 2.70557 1 3.32119 1H41.9584C42.574 1 43.1644 1.24455 43.5997 1.67986C44.035 2.11517 44.2796 2.70557 44.2796 3.32119V26.0228C44.2796 26.6384 44.035 27.2288 43.5997 27.6641C43.1644 28.0994 42.574 28.344 41.9584 28.344H14.211",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        d: "M12.0378 28.3359H10.1035",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        d: "M44.2796 5.32129H1V12.5647H44.2796V5.32129Z",
        fill: "#005AA3",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        d: "M36.5749 24.8706C38.9843 24.8706 40.9375 22.9174 40.9375 20.508C40.9375 18.0987 38.9843 16.1455 36.5749 16.1455C34.1656 16.1455 32.2124 18.0987 32.2124 20.508C32.2124 22.9174 34.1656 24.8706 36.5749 24.8706Z",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        d: "M30.4104 24.8706C32.8197 24.8706 34.7729 22.9174 34.7729 20.508C34.7729 18.0987 32.8197 16.1455 30.4104 16.1455C28.001 16.1455 26.0479 18.0987 26.0479 20.508C26.0479 22.9174 28.001 24.8706 30.4104 24.8706Z",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        d: "M4.25146 17.9727H9.28072",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        d: "M4.25146 21.0596H12.0382",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  );
}

// src/atoms/icons/ServiceIconV2.tsx
import * as React42 from "react";
function ServiceIconV2() {
  return /* @__PURE__ */ React42.createElement(
    "svg",
    {
      width: "39",
      height: "42",
      viewBox: "0 0 39 42",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        d: "M24.4104 28.1873L30.7731 22.0551C31.2105 21.6375 31.7954 21.41 32.4 21.4224C33.0046 21.4347 33.5797 21.6859 33.9997 22.121V22.121C34.4173 22.5583 34.6448 23.1433 34.6325 23.7479C34.6201 24.3525 34.369 24.9276 33.9339 25.3476L25.2994 33.6529C24.5972 34.3303 23.6575 34.7056 22.6818 34.6982H13.183L12.681 35.1756L11.0347 36.7478L4.80371 30.2781",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        d: "M24.4104 28.1873L30.7731 22.0551C31.2105 21.6375 31.7954 21.41 32.4 21.4224C33.0046 21.4347 33.5797 21.6859 33.9997 22.121V22.121C34.4173 22.5583 34.6448 23.1433 34.6325 23.7479C34.6201 24.3525 34.369 24.9276 33.9339 25.3476L25.2994 33.6529C24.5972 34.3303 23.6575 34.7056 22.6818 34.6982H13.183L12.681 35.1756L11.0347 36.7478L4.80371 30.2781",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        d: "M5.0498 30.7644L8.79501 27.1673C9.51438 26.4745 10.3687 25.9371 11.3047 25.5888C12.2408 25.2404 13.2385 25.0885 14.2358 25.1425L22.7057 25.3071C22.9705 25.3114 23.2319 25.3678 23.475 25.4731C23.718 25.5785 23.9379 25.7306 24.1221 25.921C24.3063 26.1113 24.4512 26.336 24.5486 26.5824C24.6459 26.8287 24.6938 27.0918 24.6894 27.3567V27.546C24.6748 28.1963 24.4099 28.8159 23.9499 29.2758C23.49 29.7358 22.8704 30.0007 22.2201 30.0153L17.199 30.147",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        d: "M5.0498 30.7644L8.79501 27.1673C9.51438 26.4745 10.3687 25.9371 11.3047 25.5888C12.2408 25.2404 13.2385 25.0885 14.2358 25.1425L22.7057 25.3071C22.9705 25.3114 23.2319 25.3678 23.475 25.4731C23.718 25.5785 23.9379 25.7306 24.1221 25.921C24.3063 26.1113 24.4512 26.336 24.5486 26.5824C24.6459 26.8287 24.6938 27.0918 24.6894 27.3567V27.546C24.6748 28.1963 24.4099 28.8159 23.9499 29.2758C23.49 29.7358 22.8704 30.0007 22.2201 30.0153L17.199 30.147",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        d: "M4.21882 35.1763L1.29674 32.2543C1.20266 32.1602 1.12803 32.0486 1.07712 31.9257C1.0262 31.8029 1 31.6712 1 31.5382C1 31.4051 1.0262 31.2734 1.07712 31.1506C1.12803 31.0277 1.20266 30.9161 1.29674 30.822L3.61794 28.5008C3.71196 28.4068 3.8236 28.3321 3.94648 28.2812C4.06935 28.2303 4.20104 28.2041 4.33405 28.2041C4.46705 28.2041 4.59874 28.2303 4.72162 28.2812C4.84449 28.3321 4.95613 28.4068 5.05016 28.5008L13.2813 36.732C13.3752 36.8254 13.4496 36.9363 13.5004 37.0585C13.5512 37.1807 13.5774 37.3117 13.5774 37.444C13.5774 37.5764 13.5512 37.7074 13.5004 37.8296C13.4496 37.9518 13.3752 38.0627 13.2813 38.156L10.9601 40.4772C10.8668 40.571 10.7559 40.6455 10.6337 40.6963C10.5115 40.7471 10.3805 40.7733 10.2482 40.7733C10.1158 40.7733 9.9848 40.7471 9.86261 40.6963C9.74043 40.6455 9.62948 40.571 9.53616 40.4772L5.42057 36.3616",
        fill: "#005AA3"
      }
    ),
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        d: "M4.21882 35.1763L1.29674 32.2543C1.20266 32.1602 1.12803 32.0486 1.07712 31.9257C1.0262 31.8029 1 31.6712 1 31.5382C1 31.4051 1.0262 31.2734 1.07712 31.1506C1.12803 31.0277 1.20266 30.9161 1.29674 30.822L3.61794 28.5008C3.71196 28.4068 3.8236 28.3321 3.94648 28.2812C4.06935 28.2303 4.20104 28.2041 4.33405 28.2041C4.46705 28.2041 4.59874 28.2303 4.72162 28.2812C4.84449 28.3321 4.95613 28.4068 5.05016 28.5008L13.2813 36.732C13.3752 36.8254 13.4496 36.9363 13.5004 37.0585C13.5512 37.1807 13.5774 37.3117 13.5774 37.444C13.5774 37.5764 13.5512 37.7074 13.5004 37.8296C13.4496 37.9518 13.3752 38.0627 13.2813 38.156L10.9601 40.4772C10.8668 40.571 10.7559 40.6455 10.6337 40.6963C10.5115 40.7471 10.3805 40.7733 10.2482 40.7733C10.1158 40.7733 9.9848 40.7471 9.86261 40.6963C9.74043 40.6455 9.62948 40.571 9.53616 40.4772L5.42057 36.3616",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        d: "M26.2047 13.997V9.77444H23.8011C23.5989 8.93196 23.2715 8.12456 22.8299 7.37917L24.5255 5.67531L21.5458 2.69562L19.8419 4.39125C19.0994 3.94016 18.2913 3.60696 17.4467 3.40351V1H13.2241V3.40351C12.3794 3.60696 11.5714 3.94016 10.8288 4.39125L9.12495 2.69562L6.13703 5.67531L7.84089 7.37917C7.39062 8.12311 7.05485 8.93057 6.8449 9.77444H4.44141V13.997H6.8449C7.0563 14.843 7.39196 15.653 7.84089 16.4005L6.13703 18.0962L9.12495 21.0841L10.8288 19.3802C11.5728 19.8305 12.3802 20.1663 13.2241 20.3762V22.7797H17.4467V20.3762C18.2905 20.1663 19.098 19.8305 19.8419 19.3802L21.5458 21.0841L24.5255 18.0962L22.8299 16.4005C23.2788 15.653 23.6144 14.843 23.8258 13.997H26.2047ZM15.3066 16.7792C14.0127 16.7792 12.7716 16.2663 11.8551 15.353C10.9386 14.4396 10.4216 13.2002 10.4173 11.9063C10.4107 11.2601 10.5324 10.619 10.7752 10.0201C11.0179 9.42117 11.377 8.87633 11.8317 8.41707C12.2864 7.95781 12.8276 7.59325 13.424 7.34445C14.0205 7.09566 14.6603 6.96757 15.3066 6.96761C15.9528 6.96757 16.5927 7.09566 17.1891 7.34445C17.7856 7.59325 18.3268 7.95781 18.7814 8.41707C19.2361 8.87633 19.5952 9.42117 19.838 10.0201C20.0808 10.619 20.2024 11.2601 20.1959 11.9063C20.1915 13.2002 19.6745 14.4396 18.758 15.353C17.8416 16.2663 16.6004 16.7792 15.3066 16.7792V16.7792Z",
        fill: "#005AA3",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        d: "M38.469 8.45723V6.21012H37.1931C37.0865 5.76213 36.9086 5.33416 36.6663 4.94252L37.5718 4.03709L35.9996 2.4567L35.0942 3.3539C34.6957 3.11944 34.2662 2.94211 33.8184 2.8271V1.55127H31.5795V2.8518C31.1316 2.96681 30.7021 3.14414 30.3036 3.37859L29.4147 2.4567L27.7684 4.03709L28.6739 4.94252C28.4316 5.33416 28.2537 5.76213 28.1471 6.21012H26.9453V8.45723H28.2211C28.3278 8.90522 28.5057 9.3332 28.7479 9.72483L27.8425 10.6303L29.4311 12.2107L30.3283 11.3135C30.7268 11.5479 31.1563 11.7252 31.6042 11.8402V13.1161H33.843V11.8402C34.2909 11.7252 34.7204 11.5479 35.1189 11.3135L36.0243 12.2107L37.6047 10.6303L36.6993 9.72483C36.9415 9.3332 37.1194 8.90522 37.2261 8.45723H38.469ZM32.7071 9.93061C32.366 9.93062 32.0281 9.86328 31.713 9.73246C31.3979 9.60165 31.1117 9.40992 30.8708 9.16829C30.63 8.92665 30.4391 8.63984 30.3093 8.32432C30.1795 8.00879 30.1132 7.67075 30.1143 7.32956C30.1143 6.6419 30.3875 5.98241 30.8737 5.49616C31.36 5.00991 32.0195 4.73674 32.7071 4.73674C33.3948 4.73674 34.0543 5.00991 34.5405 5.49616C35.0268 5.98241 35.3 6.6419 35.3 7.32956C35.301 7.67075 35.2348 8.00879 35.105 8.32432C34.9751 8.63984 34.7843 8.92665 34.5435 9.16829C34.3026 9.40992 34.0164 9.60165 33.7013 9.73246C33.3862 9.86328 33.0483 9.93062 32.7071 9.93061V9.93061Z",
        fill: "#005AA3",
        stroke: "#005AA3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        d: "M10.129 38.2463C10.6336 38.2463 11.0427 37.8372 11.0427 37.3326C11.0427 36.828 10.6336 36.4189 10.129 36.4189C9.62439 36.4189 9.21533 36.828 9.21533 37.3326C9.21533 37.8372 9.62439 38.2463 10.129 38.2463Z",
        fill: "#005AA3",
        stroke: "#005AA3",
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  );
}

// src/atoms/icons/AttachFileFilled.tsx
import * as React43 from "react";
function AttachFileFilled(props) {
  const { variant } = props;
  const [width, height] = React43.useMemo(() => {
    switch (variant) {
      case "small":
        return [8, 17];
      case "medium":
        return [14, 22];
    }
  }, [variant]);
  return /* @__PURE__ */ React43.createElement(
    "svg",
    {
      width,
      height,
      viewBox: "0 0 11 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React43.createElement(
      "path",
      {
        d: "M9.5 5V16.5C9.5 18.71 7.71 20.5 5.5 20.5C3.29 20.5 1.5 18.71 1.5 16.5V4C1.5 2.62 2.62 1.5 4 1.5C5.38 1.5 6.5 2.62 6.5 4V14.5C6.5 15.05 6.05 15.5 5.5 15.5C4.95 15.5 4.5 15.05 4.5 14.5V5H3V14.5C3 15.88 4.12 17 5.5 17C6.88 17 8 15.88 8 14.5V4C8 1.79 6.21 0 4 0C1.79 0 0 1.79 0 4V16.5C0 19.54 2.46 22 5.5 22C8.54 22 11 19.54 11 16.5V5H9.5Z",
        fill: "#19305A"
      }
    )
  );
}

// src/atoms/icons/InfoIcon.tsx
import { useTheme as useTheme3 } from "@mui/material";
import * as React44 from "react";
function InfoIcon(props) {
  const { width = "10", height = "10", ...rest } = props;
  const theme = useTheme3();
  return /* @__PURE__ */ React44.createElement(
    "svg",
    {
      width,
      height,
      viewBox: "0 0 10 10",
      fill: "none",
      ...rest,
      focusable: "false",
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React44.createElement(
      "path",
      {
        d: "M4.5 2.5H5.5V3.5H4.5V2.5ZM4.5 4.5H5.5V7.5H4.5V4.5ZM5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0ZM5 9C2.795 9 1 7.205 1 5C1 2.795 2.795 1 5 1C7.205 1 9 2.795 9 5C9 7.205 7.205 9 5 9Z",
        fill: props.color || theme.palette.common.black,
        fillOpacity: "0.54"
      }
    )
  );
}

// src/atoms/icons/ActivitySummaryIcon.tsx
import * as React45 from "react";
function ActivitySummaryIcon() {
  return /* @__PURE__ */ React45.createElement(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 20 30",
      role: "img",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React45.createElement(
      "path",
      {
        d: "M15.4827 5.12014H14.4967H12.126H9.25668H6.77713C6.37583 5.12014 5.97166 5.10868 5.57036 5.12014H5.55316C5.82834 5.48419 6.10641 5.84537 6.3816 6.2094C6.63958 5.41252 6.89757 4.61564 7.1584 3.81875C7.2272 3.60376 7.29599 3.39165 7.36766 3.17666C7.09247 3.38591 6.81441 3.59804 6.53922 3.80728H8.46551C8.92989 3.80728 9.32545 3.41456 9.32545 2.94734C9.32545 2.84987 9.33119 2.75241 9.34265 2.65495C9.33119 2.73235 9.32259 2.80688 9.31112 2.88427C9.33692 2.70655 9.38278 2.53456 9.45158 2.36544L9.36559 2.57183C9.41432 2.45717 9.47165 2.34537 9.54044 2.23931C9.54331 2.23358 9.59777 2.14471 9.6035 2.14758C9.60637 2.14758 9.46018 2.32244 9.53757 2.23358C9.58344 2.18198 9.62643 2.13038 9.67517 2.08165C9.71816 2.03866 9.76689 1.99566 9.81276 1.95553C9.86722 1.90966 9.95035 1.881 9.7411 2.00999C9.76689 1.9928 9.79269 1.97273 9.81849 1.95553C9.92742 1.881 10.0449 1.8208 10.1653 1.76921L9.95895 1.8552C10.1252 1.7864 10.2972 1.74054 10.4778 1.71474C10.4004 1.72621 10.3259 1.73481 10.2485 1.74627C10.4348 1.72334 10.6182 1.72334 10.8017 1.74627C10.7243 1.73481 10.6498 1.72621 10.5724 1.71474C10.7501 1.74054 10.9221 1.7864 11.0912 1.8552L10.8848 1.76921C10.9995 1.81794 11.1113 1.87526 11.2174 1.94406C11.2231 1.94693 11.312 2.00139 11.3091 2.00712C11.3091 2.00999 11.1342 1.8638 11.2231 1.94119C11.2747 1.98706 11.3263 2.03005 11.375 2.07879C11.418 2.12178 11.461 2.17051 11.5011 2.21638C11.547 2.27084 11.5728 2.3511 11.4467 2.14471C11.4639 2.17051 11.4839 2.19631 11.5011 2.22211C11.5728 2.33104 11.6359 2.44857 11.6875 2.56896L11.6015 2.36257C11.6703 2.52883 11.7161 2.70082 11.7419 2.88141C11.7305 2.80401 11.7219 2.72948 11.7104 2.65209C11.7219 2.74955 11.7276 2.84701 11.7276 2.94447C11.7276 3.40884 12.1203 3.80441 12.5875 3.80441H14.4966C14.2215 3.59515 13.9434 3.38303 13.6682 3.17379C13.9291 3.97927 14.1899 4.78192 14.4508 5.5874C14.5167 5.79378 14.5855 6.00017 14.6514 6.2037C14.789 6.63081 15.2534 6.95184 15.7092 6.80565C16.1363 6.66806 16.4573 6.20653 16.3111 5.74789C16.0532 4.95101 15.7952 4.15413 15.5343 3.35725C15.4655 3.14226 15.3967 2.93014 15.3251 2.71515C15.2075 2.35397 14.8865 2.08453 14.4966 2.08453H12.5875L13.4475 2.94447C13.4475 2.37979 13.287 1.78639 12.9659 1.31915C12.5961 0.78309 12.106 0.401868 11.4954 0.169664C10.3975 -0.24598 9.03018 0.1238 8.29636 1.04108C7.85778 1.59433 7.60551 2.23926 7.60551 2.95018L8.46545 2.09024H6.53916C6.14645 2.09024 5.82829 2.35969 5.71072 2.72086C5.44987 3.52634 5.18902 4.32899 4.92815 5.13447C4.86222 5.34086 4.79342 5.54725 4.7275 5.75078C4.55264 6.28684 5.01988 6.84004 5.55593 6.84004H6.54199H8.91261H11.782H14.2615C14.6628 6.84004 15.0641 6.84864 15.4683 6.84004H15.4855C15.9355 6.84004 16.3655 6.44446 16.3454 5.9801C16.3196 5.51572 15.9642 5.12016 15.4826 5.12016L15.4827 5.12014Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React45.createElement(
      "path",
      {
        d: "M19.2801 7.11427V8.64498V12.2912V16.6855V20.4148C19.2801 20.9824 19.283 21.5471 19.2801 22.1147C19.2801 22.2351 19.2715 22.3555 19.2572 22.4787C19.2687 22.4013 19.2773 22.3268 19.2887 22.2494C19.2543 22.4902 19.1913 22.7252 19.0967 22.9517C19.1253 22.8829 19.154 22.8141 19.1827 22.7453C19.1167 22.8943 19.0422 23.0377 18.9505 23.1753C18.9419 23.1896 18.8788 23.2985 18.8645 23.2985C18.8788 23.2985 19.0221 23.1036 18.9075 23.2412C18.8559 23.3042 18.8014 23.3616 18.7441 23.4189C18.6867 23.4762 18.6266 23.5307 18.5664 23.5823C18.5119 23.6282 18.4001 23.6884 18.6237 23.5393C18.5864 23.5622 18.552 23.5909 18.5176 23.6138C18.3772 23.7084 18.2281 23.7887 18.0733 23.8546C18.1421 23.826 18.2109 23.7973 18.2797 23.7686C18.0533 23.8632 17.8211 23.9263 17.5774 23.9607C17.6548 23.9492 17.7294 23.9406 17.8068 23.9291C17.586 23.9578 17.3682 23.9521 17.1475 23.9521H16.1585H12.8105H8.6884H5.16546C4.6294 23.9521 4.09627 23.9549 3.56021 23.9521C3.43982 23.9521 3.31942 23.9435 3.19903 23.9291C3.27643 23.9406 3.35096 23.9492 3.42835 23.9607C3.18757 23.9263 2.95252 23.8632 2.72608 23.7686C2.79488 23.7973 2.86368 23.826 2.93247 23.8546C2.78341 23.7887 2.64009 23.7142 2.5025 23.6224C2.48816 23.6138 2.37924 23.5508 2.37924 23.5364C2.37924 23.5508 2.57416 23.6941 2.43657 23.5794C2.37351 23.5278 2.31617 23.4734 2.25885 23.416C2.20152 23.3587 2.14705 23.2985 2.09545 23.2383C2.04959 23.1839 1.9894 23.0721 2.13845 23.2957C2.11552 23.2584 2.08685 23.224 2.06392 23.1896C1.96933 23.0491 1.88907 22.9001 1.82313 22.7453C1.8518 22.8141 1.88046 22.8829 1.90913 22.9517C1.81453 22.7252 1.75147 22.493 1.71707 22.2494C1.72853 22.3268 1.73713 22.4013 1.7486 22.4787C1.71993 22.2494 1.72567 22.0172 1.72567 21.7879V20.7273V17.0983V12.6638V8.85996C1.72567 8.28092 1.7228 7.70188 1.72567 7.12284C1.72567 7.00244 1.73427 6.88205 1.7486 6.75879C1.73713 6.83619 1.72853 6.91071 1.71707 6.98811C1.75147 6.74732 1.81453 6.51227 1.90913 6.28584C1.88046 6.35464 1.85179 6.42343 1.82313 6.49223C1.88906 6.34317 1.96359 6.19985 2.05532 6.06225C2.06392 6.04792 2.12698 5.93899 2.14131 5.93899C2.12698 5.93899 1.98366 6.13392 2.09832 5.99633C2.14991 5.93326 2.20438 5.87593 2.26171 5.8186C2.31904 5.76128 2.37923 5.70681 2.43943 5.65521C2.4939 5.60935 2.60569 5.54915 2.3821 5.69821C2.41936 5.67528 2.45376 5.64661 2.48816 5.62368C2.62862 5.52908 2.77767 5.44882 2.93247 5.38289C2.86367 5.41155 2.79487 5.44022 2.72608 5.46888C2.95253 5.37429 3.18472 5.31123 3.42835 5.27683C3.35095 5.28829 3.27643 5.29689 3.19903 5.30836C3.54588 5.26536 3.90707 5.28542 4.2539 5.28542H5.71008H6.05979C5.78461 4.92138 5.50654 4.5602 5.23135 4.19617C5.06223 4.715 4.89311 5.23673 4.72398 5.75555C4.54913 6.2916 5.01636 6.8448 5.55242 6.8448H6.53847H8.9091H11.7785H14.258C14.6593 6.8448 15.0606 6.8534 15.4648 6.8448H15.482C16.0209 6.8448 16.4853 6.29155 16.3104 5.75555C16.1413 5.23671 15.9722 4.71498 15.803 4.19617C15.5279 4.56021 15.2498 4.92139 14.9746 5.28542H17.2592C17.4427 5.28542 17.6204 5.28542 17.8039 5.30836C17.7265 5.29689 17.6519 5.28829 17.5746 5.27683C17.8153 5.31122 18.0504 5.37429 18.2768 5.46888C18.208 5.44022 18.1392 5.41155 18.0704 5.38289C18.2195 5.44882 18.3628 5.52335 18.5004 5.61508C18.5147 5.62368 18.6237 5.68674 18.6237 5.70107C18.6237 5.68674 18.4287 5.54341 18.5663 5.65807C18.6294 5.70967 18.6867 5.76413 18.7441 5.82147C18.8014 5.8788 18.8559 5.93899 18.9075 5.99919C18.9533 6.05365 19.0135 6.16545 18.8645 5.94185C18.8874 5.97912 18.916 6.01352 18.939 6.04791C19.0336 6.18837 19.1138 6.33743 19.1798 6.49222L19.0938 6.28584C19.1884 6.51229 19.2514 6.74448 19.2858 6.98811C19.2744 6.91071 19.2658 6.83618 19.2543 6.75879C19.2715 6.87631 19.2772 6.99671 19.2801 7.11423C19.283 7.56427 19.6728 7.99425 20.14 7.97417C20.6044 7.9541 21.0029 7.59579 21 7.11423C20.9885 5.54337 19.9308 4.12158 18.4115 3.6945C17.9987 3.57984 17.5774 3.56264 17.1531 3.56264H15.9005H14.9746C14.4357 3.56264 13.9713 4.11589 14.1462 4.6519C14.3153 5.17073 14.4844 5.69246 14.6535 6.21128C14.9287 5.84723 15.2068 5.48605 15.482 5.12202H14.4959H12.1253H9.25592H6.77638C6.37507 5.12202 5.9709 5.11055 5.5696 5.12202H5.5524C5.82759 5.48606 6.10566 5.84725 6.38084 6.21128C6.54997 5.69244 6.71909 5.17071 6.88821 4.6519C7.06307 4.11584 6.59583 3.56264 6.05978 3.56264H4.74979C4.29975 3.56264 3.84399 3.53971 3.39394 3.56837C2.25594 3.6343 1.26124 4.20476 0.607712 5.13347C0.197802 5.71539 0.00288289 6.44633 0 7.15149V8.70798V11.8554V15.6879V19.251V21.6417V22.1003C0.00286648 22.9774 0.318181 23.783 0.877131 24.4509C1.52782 25.2305 2.54832 25.6634 3.55156 25.6691H3.92134H6.28048H9.88084H13.6647H16.5254C17.1732 25.6691 17.8498 25.7121 18.4775 25.5143C19.0049 25.3481 19.4836 25.07 19.885 24.6916C20.292 24.3133 20.5729 23.8431 20.7736 23.33C20.9399 22.9087 20.9914 22.4471 20.9914 21.9971V20.174V16.8718V13.0335V9.56215V7.40942V7.10844C20.9914 6.6584 20.5959 6.22842 20.1315 6.2485C19.6729 6.2743 19.2802 6.63261 19.2802 7.1142L19.2801 7.11427Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React45.createElement(
      "path",
      {
        d: "M4.15896 11.6302H5.42596H8.45299H12.1278H15.2953C15.8113 11.6302 16.3273 11.6417 16.8404 11.6302H16.8633C17.3134 11.6302 17.7434 11.2347 17.7233 10.7703C17.7032 10.3031 17.3449 9.91037 16.8633 9.91037H15.5963H12.5693H8.89447H5.72696C5.21098 9.91037 4.69499 9.8989 4.18189 9.91037H4.15896C3.70892 9.91037 3.27894 10.3059 3.29902 10.7703C3.31909 11.2347 3.67453 11.6302 4.15896 11.6302Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React45.createElement(
      "path",
      {
        d: "M4.15896 16.2855H5.42596H8.45299H12.1278H15.2953C15.8113 16.2855 16.3273 16.297 16.8404 16.2855H16.8633C17.3134 16.2855 17.7434 15.8899 17.7233 15.4256C17.7032 14.9583 17.3449 14.5656 16.8633 14.5656H15.5963H12.5693H8.89447H5.72696C5.21098 14.5656 4.69499 14.5542 4.18189 14.5656H4.15896C3.70892 14.5656 3.27894 14.9612 3.29902 15.4256C3.31908 15.8928 3.67453 16.2855 4.15896 16.2855Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React45.createElement(
      "path",
      {
        d: "M4.15896 20.9398H7.10857H11.7752H12.8502C13.3002 20.9398 13.7302 20.5443 13.7101 20.0799C13.6901 19.6127 13.3317 19.22 12.8502 19.22H9.90057H5.23391H4.15896C3.70892 19.22 3.27894 19.6156 3.29902 20.0799C3.31908 20.5472 3.67453 20.9398 4.15896 20.9398Z",
        fill: "white"
      }
    )
  );
}

// src/atoms/icons/VolumeUp.tsx
import * as React46 from "react";
function VolumeUp() {
  return /* @__PURE__ */ React46.createElement(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React46.createElement(
      "path",
      {
        d: "M0.25 4.75035V9.25035H3.25L7 13.0004V1.00035L3.25 4.75035H0.25ZM10.375 7.00035C10.375 5.67285 9.61 4.53285 8.5 3.97785V10.0154C9.61 9.46785 10.375 8.32785 10.375 7.00035ZM8.5 0.422852V1.96785C10.6675 2.61285 12.25 4.62285 12.25 7.00035C12.25 9.37785 10.6675 11.3879 8.5 12.0329V13.5779C11.5075 12.8954 13.75 10.2104 13.75 7.00035C13.75 3.79035 11.5075 1.10535 8.5 0.422852Z",
        fill: "#1565c0"
      }
    )
  );
}

// src/atoms/icons/LinkArrowIcon.tsx
import * as React47 from "react";
function LinkArrowIcon() {
  return /* @__PURE__ */ React47.createElement(
    "svg",
    {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React47.createElement(
      "path",
      {
        id: "Path",
        d: "M3.00245 0.705078V1.85035H6.95967L0 8.48718L0.84669 9.2946L7.80636 2.65776V6.43143H9.00734V0.705078H3.00245Z",
        fill: "#005AA3"
      }
    )
  );
}

// src/atoms/icons/CallTrackingIcon.tsx
import * as React48 from "react";
function CallTrackingIcon() {
  return /* @__PURE__ */ React48.createElement(
    "svg",
    {
      width: "14",
      height: "18",
      viewBox: "0 0 14 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React48.createElement(
      "path",
      {
        d: "M6.98929 5.07129C5.74262 5.07129 4.52395 5.44097 3.48739 6.13358C2.45083 6.82619 1.64292 7.81062 1.16584 8.96239C0.688766 10.1142 0.563941 11.3815 0.807153 12.6042C1.05037 13.827 1.65069 14.9501 2.53222 15.8316C3.41374 16.7131 4.53688 17.3135 5.75959 17.5567C6.9823 17.7999 8.24967 17.6751 9.40144 17.198C10.5532 16.7209 11.5376 15.913 12.2303 14.8764C12.9229 13.8399 13.2925 12.6212 13.2925 11.3745C13.2925 7.88475 10.4212 5.07129 6.98929 5.07129ZM6.98929 15.7729C6.13599 15.7729 5.30185 15.5199 4.59236 15.0458C3.88287 14.5717 3.32989 13.8979 3.00334 13.1096C2.6768 12.3212 2.59136 11.4537 2.75783 10.6168C2.9243 9.77993 3.3352 9.01119 3.93858 8.40781C4.54195 7.80444 5.3107 7.39354 6.1476 7.22707C6.9845 7.0606 7.85198 7.14603 8.64032 7.47258C9.42867 7.79912 10.1025 8.3521 10.5765 9.0616C11.0506 9.77109 11.3036 10.6052 11.3036 11.4585C11.3059 12.0258 11.1959 12.5879 10.9799 13.1124C10.7639 13.637 10.4462 14.1136 10.0451 14.5148C9.64408 14.9159 9.16758 15.2338 8.6431 15.4499C8.11863 15.6661 7.55656 15.7763 6.98929 15.7742V15.7729Z",
        fill: "#1565c0"
      }
    ),
    /* @__PURE__ */ React48.createElement(
      "path",
      {
        d: "M13.4326 1.91891C11.5837 0.758401 9.32881 0 6.98935 0C4.64989 0 2.39505 0.758401 0.546126 1.91891C0.291422 2.11298 0.111755 2.38925 0.0376429 2.70077C-0.0364688 3.0123 -0.000455015 3.33987 0.139567 3.62785L1.03603 5.26681C1.24663 5.60275 1.72254 5.74336 2.00248 5.47677C2.54902 5.07085 3.09555 4.64966 3.71143 4.38435C3.77393 4.35301 3.82662 4.3051 3.86376 4.24586C3.9009 4.18662 3.92105 4.11832 3.92203 4.04841V3.08196C3.92203 2.94135 3.99201 2.80137 4.13199 2.80137C5.02718 2.46544 5.98154 2.32547 6.94736 2.32547H7.08733C8.05378 2.32547 9.00624 2.46544 9.9027 2.80137C10.0427 2.80137 10.1127 2.94135 10.1127 3.08196V4.04841C10.1099 4.11908 10.1286 4.18894 10.1661 4.24887C10.2037 4.30879 10.2585 4.356 10.3233 4.38435C10.9391 4.66429 11.4857 5.07085 12.0322 5.47677C12.3122 5.75736 12.7881 5.61675 12.9987 5.26681L13.8951 3.62785C14.1191 3.08196 13.9931 2.32547 13.4326 1.91891Z",
        fill: "#1565c0"
      }
    ),
    /* @__PURE__ */ React48.createElement(
      "path",
      {
        d: "M6.98904 13.7134C8.27336 13.7134 9.31451 12.6723 9.31451 11.388C9.31451 10.1036 8.27336 9.0625 6.98904 9.0625C5.70472 9.0625 4.66357 10.1036 4.66357 11.388C4.66357 12.6723 5.70472 13.7134 6.98904 13.7134Z",
        fill: "#1565c0"
      }
    )
  );
}

// src/atoms/icons/OpenNewFieldIcon.tsx
import * as React49 from "react";
function OpenNewFieldIcon() {
  return /* @__PURE__ */ React49.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "14",
      viewBox: "0 -2 14 18",
      fill: "none"
    },
    /* @__PURE__ */ React49.createElement(
      "path",
      {
        d: "M14.25 14.25H3.75V3.75H9V2.25H3.75C2.9175 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.9175 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V9H14.25V14.25ZM10.5 2.25V3.75H13.1925L5.82 11.1225L6.8775 12.18L14.25 4.8075V7.5H15.75V2.25H10.5Z",
        fill: "#1565c0"
      }
    )
  );
}

// src/atoms/icons/BadgeIcon.tsx
import * as React50 from "react";
function BadgeIcon() {
  return /* @__PURE__ */ React50.createElement(
    "svg",
    {
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React50.createElement(
      "path",
      {
        d: "M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z",
        fill: "#0E283F",
        fillOpacity: 0.85
      }
    )
  );
}

// src/atoms/icons/TrashIcon.tsx
import * as React51 from "react";
var TrashIcon = () => /* @__PURE__ */ React51.createElement(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 6 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React51.createElement(
    "path",
    {
      d: "M10 23C10 24.1 10.9 25 12 25H20C21.1 25 22 24.1 22 23V11H10V23ZM23 8H19.5L18.5 7H13.5L12.5 8H9V10H23V8Z",
      fill: "#A62E18"
    }
  )
);

// src/atoms/icons/PlusIcon.tsx
import * as React52 from "react";
var PlusIcon = () => /* @__PURE__ */ React52.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React52.createElement(
    "path",
    {
      d: "M10 1.66797C5.40002 1.66797 1.66669 5.4013 1.66669 10.0013C1.66669 14.6013 5.40002 18.3346 10 18.3346C14.6 18.3346 18.3334 14.6013 18.3334 10.0013C18.3334 5.4013 14.6 1.66797 10 1.66797ZM14.1667 10.8346H10.8334V14.168H9.16669V10.8346H5.83335V9.16797H9.16669V5.83464H10.8334V9.16797H14.1667V10.8346Z",
      fill: "#1565c0"
    }
  )
);

// src/atoms/icons/PlusIconDisabled.tsx
import * as React53 from "react";
var PlusIconDisabled = () => /* @__PURE__ */ React53.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React53.createElement(
    "path",
    {
      d: "M9.99999 1.66797C5.39999 1.66797 1.66666 5.4013 1.66666 10.0013C1.66666 14.6013 5.39999 18.3346 9.99999 18.3346C14.6 18.3346 18.3333 14.6013 18.3333 10.0013C18.3333 5.4013 14.6 1.66797 9.99999 1.66797ZM14.1667 10.8346H10.8333V14.168H9.16666V10.8346H5.83332V9.16797H9.16666V5.83464H10.8333V9.16797H14.1667V10.8346Z",
      fill: "#091B2A",
      fillOpacity: "0.38"
    }
  )
);

// src/atoms/icons/CustomFieldsIcon.tsx
import * as React54 from "react";
function CustomFieldsIcon(props) {
  const { variant = "small" } = props;
  const [width, height] = React54.useMemo(() => {
    switch (variant) {
      case "small":
        return [33, 30];
      case "large":
        return [70, 62];
    }
  }, [variant]);
  return /* @__PURE__ */ React54.createElement(
    "svg",
    {
      fill: "none",
      width,
      height,
      viewBox: "0 0 70 62",
      style: {
        flexGrow: 0,
        flexShrink: 0
      }
    },
    /* @__PURE__ */ React54.createElement(
      "path",
      {
        d: "M39.0634 38.735L26.8602 31.6964V17.5586L13.4301 9.85547L0 17.6103V47.2105L25.6338 61.9996L39.0639 54.2456L39.0634 38.735ZM24.4063 31.6894L14.6569 37.319V26.0711L24.4063 20.4415V31.6894ZM25.6333 45.0731L15.8923 39.4483L25.641 33.8202L35.3834 39.4449L25.6333 45.0731ZM13.4301 12.6894L23.0363 18.3902L13.4204 23.9421L3.67944 18.3181L13.4301 12.6894ZM2.45248 45.7937V20.4417L12.2032 26.0713V40.2042L24.4063 47.1997V58.4582L2.45248 45.7937ZM26.8599 58.4577V47.2084L36.6105 41.5816V52.8295L26.8599 58.4577Z",
        fill: "#19305A"
      }
    ),
    /* @__PURE__ */ React54.createElement(
      "path",
      {
        d: "M69.1421 7.75191L55.7083 0L30.0781 14.8088V30.3168L55.7119 45.1073L69.1415 37.3738V7.75191H69.1421ZM33.7583 15.5157L55.6352 2.87441L65.4613 8.46103L43.5303 21.1208L33.7583 15.5157ZM32.5313 17.6417L42.2807 23.2727V34.5283L32.5313 28.8994V17.6417ZM45.9721 36.6503L45.9834 36.6432H45.9806L54.4853 31.7332V41.5659L45.9721 36.6503ZM66.6894 35.937L56.9387 41.5659V27.4837L44.7356 34.5287V23.2723L66.6901 10.5893L66.6894 35.937Z",
        fill: "#19305A"
      }
    )
  );
}

// src/atoms/CardFooterCollapse/styling.ts
import { lighten } from "@mui/material";
var getStyles2 = (props, theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    flexFlow: "row no-wrap",
    fontSize: "14px",
    lineHeight: "40px",
    cursor: "pointer",
    transition: "all 0.25s",
    "&:hover": {
      backgroundColor: lighten(
        props.backgroundColorClosed ?? theme.palette.common.white,
        0.5
      )
    }
  },
  contents: {
    display: "flex",
    justifyContent: "space-between",
    flexFlow: "row no-wrap",
    fontSize: "14px",
    lineHeight: "40px",
    cursor: "pointer",
    transition: "all 0.25s",
    "&:hover": {
      backgroundColor: "#f7f7f7"
    }
  },
  contentsClosed: { opacity: 1 },
  contentsOpen: {
    opacity: props.showHeadContentsWhenOpen ? 1 : 0
  },
  footerClosed: {
    backgroundColor: props.backgroundColorClosed ? props.backgroundColorClosed : "transparent",
    borderTop: "1px solid #dddddd"
  },
  footerOpen: {
    backgroundColor: props.backgroundColorOpen ? props.backgroundColorOpen : "transparent",
    borderTop: "1px solid #dddddd",
    boxShadow: props.variant === "drawer" ? "1px 4px 4px 0px #dddddd" : "none"
  }
});

// src/atoms/CardFooterCollapse/CardFooterCollapse.tsx
import { Box as Box5, Collapse, useTheme as useTheme4 } from "@mui/material";
var CardFooterCollapse = (props) => {
  const { children, className, dataTestId, headContents, style } = props;
  const [open, setOpen] = useState4(false);
  const handleClick = useCallback7(() => setOpen(!open), [open]);
  const styles8 = getStyles2(props, useTheme4());
  return /* @__PURE__ */ React55.createElement(Box5, { className, style }, /* @__PURE__ */ React55.createElement(
    Box5,
    {
      sx: {
        ...styles8.root,
        ...open ? styles8.footerOpen : styles8.footerClosed
      },
      px: 2,
      onClick: handleClick,
      "data-testid": "card-footer-collapse-toggle",
      "data-test-id": dataTestId ?? "cardFooterCollapseToggle"
    },
    /* @__PURE__ */ React55.createElement(
      Box5,
      {
        component: "span",
        sx: {
          ...styles8.contents,
          ...open ? styles8.contentsOpen : styles8.contentsClosed
        }
      },
      headContents
    ),
    /* @__PURE__ */ React55.createElement(
      Chevron,
      {
        open,
        dataTestId: dataTestId ? `${dataTestId}Chevron` : "cardFooterCollapseChevron"
      }
    )
  ), /* @__PURE__ */ React55.createElement(Collapse, { in: open, unmountOnExit: true }, children));
};
CardFooterCollapse.displayName = "CardFooterCollapse";

// src/atoms/CardListViewPicker/CardListViewPicker.tsx
import * as React56 from "react";

// src/atoms/CardListViewPicker/useStyles.ts
var getStyles3 = (theme) => ({
  root: {
    padding: theme.spacing(1),
    fontSize: "12px",
    minWidth: "unset"
  },
  outlined: {
    padding: theme.spacing(0.9),
    backgroundColor: theme.palette.common.white
  },
  rightButton: {
    borderRadius: "0 4px 4px 0"
  },
  leftButton: {
    borderRadius: "4px 0 0 4px"
  },
  middleButton: {
    borderRadius: "0 0 0 0"
  }
});

// src/atoms/CardListViewPicker/CardListViewPicker.tsx
import { useTheme as useTheme5, buttonClasses, Button as Button7, Box as Box6 } from "@mui/material";
import { List as ListIcon, ViewStream as CardIcon } from "@mui/icons-material";
var CardListViewPicker = ({ mode, cardClickCallback, listClickCallback }) => {
  const { leftButton, rightButton, ...styles8 } = getStyles3(useTheme5());
  return /* @__PURE__ */ React56.createElement(Box6, { ml: 1, display: "flex" }, /* @__PURE__ */ React56.createElement(LightTooltip, { title: "Card view allows you to work records more efficiently with less clicks" }, /* @__PURE__ */ React56.createElement(
    Button7,
    {
      disableElevation: true,
      disableFocusRipple: true,
      disableRipple: true,
      disableTouchRipple: true,
      color: "primary",
      variant: mode === "card" ? "contained" : "outlined",
      onClick: cardClickCallback,
      sx: {
        ...styles8.root,
        ...leftButton,
        [`&.${buttonClasses.outlined}`]: { ...styles8.outlined }
      },
      "data-test-id": `cardViewBtn`
    },
    /* @__PURE__ */ React56.createElement(CardIcon, { fontSize: "small" })
  )), /* @__PURE__ */ React56.createElement(LightTooltip, { title: "List view allows you to quickly view information on large numbers of records and make bulk updates" }, /* @__PURE__ */ React56.createElement(
    Button7,
    {
      disableElevation: true,
      disableFocusRipple: true,
      disableRipple: true,
      disableTouchRipple: true,
      color: "primary",
      variant: mode === "list" ? "contained" : "outlined",
      onClick: listClickCallback,
      sx: {
        ...styles8.root,
        ...rightButton,
        [`&.${buttonClasses.outlined}`]: styles8.outlined
      },
      "data-test-id": `listViewBtn`
    },
    /* @__PURE__ */ React56.createElement(ListIcon, { fontSize: "small" })
  )));
};
CardListViewPicker.displayName = "CardListViewPicker";

// src/atoms/CollectionPage/CollectionPage.tsx
import * as React57 from "react";

// src/atoms/CollectionPage/styling.ts
import { styled as styled8, Box as Box7 } from "@mui/material";
var ActionBar = styled8(Box7)({
  height: "60px",
  boxShadow: "0 2px 4px 0 rgba(202, 202, 202, 0.5)",
  backgroundColor: "#f9f9f9",
  borderTop: "solid 1px #979797"
});
var Container3 = styled8(Box7)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  display: "block",
  /* border: 'solid 1px purple', */
  flexBasis: "100%",
  justifyContent: "center"
}));
var Heading = styled8("h3")(({ theme }) => ({
  fontSize: "15px",
  margin: "0",
  padding: theme.spacing(1.5)
}));
var PagedContent = styled8(Box7)(({ theme }) => ({
  /* border: 'solid 1px green', */
  display: "block",
  /* flex-direction: 'column', */
  margin: "0 auto",
  padding: theme.spacing(1.5)
}));

// src/atoms/CollectionPage/CollectionPage.tsx
var CollectionPage = (props) => {
  return /* @__PURE__ */ React57.createElement(Container3, null, props.title && /* @__PURE__ */ React57.createElement(Heading, null, props.title), /* @__PURE__ */ React57.createElement(ActionBar, null), /* @__PURE__ */ React57.createElement(PagedContent, null, props.children));
};

// src/atoms/ContentCentered/ContentCentered.styled.tsx
import { styled as styled9, Box as Box8 } from "@mui/material";
var ContentCentered = styled9(Box8)(
  {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start"
  },
  (props) => ({
    ...props.alignItems && {
      alignItems: props.alignItems
    }
  })
);

// src/atoms/CustomizedTreeView/CustomizedTreeview.tsx
import * as React64 from "react";
import { useCallback as useCallback9, useEffect as useEffect3, useState as useState6 } from "react";

// src/atoms/CustomizedTreeView/MinusSquare.tsx
import { SvgIcon as SvgIcon5 } from "@mui/material";
import * as React58 from "react";
var MinusSquare = (props) => {
  return /* @__PURE__ */ React58.createElement(
    SvgIcon5,
    {
      fontSize: "inherit",
      style: { width: 20, height: 20 },
      viewBox: "0 0 20 20",
      ...props
    },
    /* @__PURE__ */ React58.createElement(
      "path",
      {
        d: "M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM14.1667 10.8333H5.83333V9.16667H14.1667V10.8333Z",
        fill: "#091B2A",
        fillOpacity: "0.56"
      }
    )
  );
};

// src/atoms/CustomizedTreeView/CloseSquare.tsx
import { SvgIcon as SvgIcon6 } from "@mui/material";
import * as React59 from "react";
var CloseSquare = (props) => {
  return /* @__PURE__ */ React59.createElement(
    SvgIcon6,
    {
      className: "close",
      fontSize: "inherit",
      style: { width: 14, height: 14 },
      ...props
    },
    /* @__PURE__ */ React59.createElement("path", { d: "M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" })
  );
};

// src/atoms/CustomizedTreeView/styling.ts
var styles5 = {
  root: {
    flexGrow: 1
  }
};
var customizedTreeViewIconStyles = {
  root: {
    color: "#005aa3"
  }
};
var customizedTreeViewIconButtonStyles = {
  root: {
    padding: 0,
    margin: 0
  }
};
var customizedTreeViewTreeItemStyles = {
  root: {
    lineHeight: "20px"
  }
};

// src/atoms/CustomizedTreeView/PlusSquare.tsx
import { SvgIcon as SvgIcon7 } from "@mui/material";
import * as React60 from "react";
var PlusSquare = (props) => {
  return /* @__PURE__ */ React60.createElement(
    SvgIcon7,
    {
      fontSize: "inherit",
      style: { width: 20, height: 20 },
      viewBox: "0 0 20 20",
      ...props
    },
    /* @__PURE__ */ React60.createElement(
      "path",
      {
        d: "M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM14.1667 10.8333H10.8333V14.1667H9.16667V10.8333H5.83333V9.16667H9.16667V5.83333H10.8333V9.16667H14.1667V10.8333Z",
        fill: "#091B2A",
        fillOpacity: "0.56"
      }
    )
  );
};

// src/atoms/CustomizedTreeView/StyledTreeItem.tsx
import { alpha, styled as styled10 } from "@mui/material";
import * as React63 from "react";
import { useState as useState5, useCallback as useCallback8 } from "react";

// src/atoms/CustomizedTreeView/TransitionComponent.tsx
import * as React61 from "react";
import { Collapse as Collapse2 } from "@mui/material";
import { useSpring, a } from "@react-spring/web";
var TransitionComponent = (props) => {
  const style = useSpring({
    from: { opacity: 0, transform: "translate3d(20px,0,0)" },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`
    }
  });
  return /* @__PURE__ */ React61.createElement(a.div, { style }, /* @__PURE__ */ React61.createElement(Collapse2, { ...props }));
};

// src/atoms/CustomizedTreeView/TreeItemLabel.tsx
import { useTheme as useTheme6 } from "@mui/material";
import * as React62 from "react";
var TreeItemLabel = (props) => {
  const theme = useTheme6();
  return /* @__PURE__ */ React62.createElement(React62.Fragment, null, props.checkbox && props.checkbox(props.item), props.label, props.buttons && /* @__PURE__ */ React62.createElement(
    "span",
    {
      style: {
        marginLeft: theme.spacing(3.2),
        visibility: props.isHovered && !props.item["systemCreated"] ? "visible" : "hidden"
      }
    },
    props.buttons(props.item)
  ));
};

// src/atoms/CustomizedTreeView/StyledTreeItem.tsx
import { TreeItem, treeItemClasses } from "@mui/x-tree-view";
var StyledTreeItemPrimitive = styled10(TreeItem)(
  ({ theme }) => ({
    [`& .${treeItemClasses.content}`]: {
      lineHeight: 32
    },
    [`& .${treeItemClasses.label}`]: {
      verticalAlign: "middle",
      lineHeight: "30px",
      "&:hover": {
        backgroundColor: "transparent",
        color: theme.palette.text.primary
      }
    },
    [`& .${treeItemClasses.iconContainer}`]: {
      lineHeight: "30px",
      "& .close": {
        opacity: 0.3
      }
    },
    [`& .${treeItemClasses.group}`]: {
      marginLeft: theme.spacing(0.7),
      paddingLeft: theme.spacing(1.8),
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`
    }
  })
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
);
function StyledTreeItem(props) {
  const [isHovered, setIsHovered] = useState5(false);
  const handleMouseOver = useCallback8(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      setIsHovered(true);
    },
    []
  );
  const handleMouseOut = useCallback8(
    (event) => {
      event.stopPropagation();
      setIsHovered(false);
    },
    []
  );
  const { buttons, checkbox, item, id, ...rest } = props;
  return /* @__PURE__ */ React63.createElement(
    StyledTreeItemPrimitive,
    {
      ...rest,
      TransitionComponent,
      onMouseOut: handleMouseOut,
      onMouseOver: handleMouseOver,
      onDrag: (event) => event.preventDefault(),
      sx: props.item["systemCreated"] ? styles6.rootLabelTransparent : styles6.rootLabel,
      label: /* @__PURE__ */ React63.createElement(TreeItemLabel, { ...props, label: props.label, isHovered })
    }
  );
}
var styles6 = {
  rootLabel: {
    "&:hover": {
      backgroundColor: "#edf6ff",
      cursor: "pointer"
    }
  },
  rootLabelTransparent: {
    "&:hover": {}
  }
};

// src/atoms/CustomizedTreeView/CustomizedTreeview.tsx
import { Person as PersonIcon } from "@mui/icons-material";
import { TreeView } from "@mui/x-tree-view";
var CustomizedTreeView = (props) => {
  const [expanded, setExpanded] = useState6([]);
  const onNodeToggle = useCallback9(
    (_3, nodes) => setExpanded(nodes),
    []
  );
  useEffect3(() => {
    if (props.expanded) {
      setExpanded(props.expanded);
    }
  }, [props.expanded]);
  const itemsToStyledTreeItems = useCallback9(() => {
    const iter = (item) => {
      const childItems = props.items.filter(
        (c) => c[props.parentIdPropName] === (item ? item[props.idPropName] : null)
      );
      return childItems.map((c) => {
        const id = c[props.idPropName].toString();
        const label = c[props.labelPropName].toString();
        const defaultChildrenCheck = props.items.some(
          (child) => child[props.parentIdPropName] === c[props.idPropName]
        );
        const hasChildren = props?.customCheckHasChildrenFn ? props?.customCheckHasChildrenFn(c) || defaultChildrenCheck : defaultChildrenCheck;
        return /* @__PURE__ */ React64.createElement(
          StyledTreeItem,
          {
            buttons: props.buttons,
            checkbox: props.checkbox,
            id,
            item: c,
            key: id,
            label,
            nodeId: id,
            onDrag: (event) => event.stopPropagation(),
            expandIcon: hasChildren ? /* @__PURE__ */ React64.createElement(PlusSquare, null) : void 0,
            collapseIcon: hasChildren ? /* @__PURE__ */ React64.createElement(MinusSquare, null) : void 0
          },
          !!props.subItems && !!c[props.subItems.collectionName] && /* @__PURE__ */ React64.createElement(React64.Fragment, null, c[props.subItems.collectionName].map((s) => {
            if (!props.subItems) return;
            const id2 = s[props.subItems.itemId].toString();
            const label2 = s[props.subItems.itemLabel].toString();
            return /* @__PURE__ */ React64.createElement(
              StyledTreeItem,
              {
                buttons: props.subItems.buttons,
                checkbox: props.checkbox,
                icon: /* @__PURE__ */ React64.createElement(PersonIcon, null),
                id: id2,
                item: s,
                key: id2,
                label: label2,
                nodeId: id2,
                onDrag: (event) => event.stopPropagation()
              }
            );
          })),
          iter(c)
        );
      });
    };
    return iter();
  }, [props]);
  return /* @__PURE__ */ React64.createElement(
    TreeView,
    {
      sx: styles5.root,
      defaultEndIcon: /* @__PURE__ */ React64.createElement(CloseSquare, null),
      disableSelection: true,
      defaultExpanded: props.defaultExpanded,
      expanded,
      onNodeToggle
    },
    itemsToStyledTreeItems()
  );
};

// src/atoms/DataItem/DataItem.tsx
import {
  Grid,
  Typography as Typography4,
  useTheme as useTheme7
} from "@mui/material";
import * as React65 from "react";
var getStyles4 = (props, theme) => ({
  fieldName: {
    color: theme.palette.text.primary,
    fontFamily: "Source Sans Pro Semibold"
  },
  root: {
    color: theme.palette.text.primary,
    marginTop: `${props.mt ?? 0}px`
  }
});
var DataItem = (props) => {
  const {
    children,
    isEmpty = false,
    title,
    lg = false,
    md = false,
    sm = false,
    xs = false,
    className,
    style,
    textAlign
  } = props;
  const styles8 = getStyles4(props, useTheme7());
  return /* @__PURE__ */ React65.createElement(
    Grid,
    {
      sx: className || styles8.root,
      item: true,
      xs,
      sm,
      md,
      lg,
      style
    },
    /* @__PURE__ */ React65.createElement(Typography4, { sx: styles8.fieldName }, title),
    /* @__PURE__ */ React65.createElement(Typography4, { textAlign }, isEmpty ? /* @__PURE__ */ React65.createElement(React65.Fragment, null, "\u2014") : children)
  );
};
DataItem.displayName = "DataItem";

// src/atoms/DatePicker/DatePicker.tsx
import * as React66 from "react";

// src/atoms/DatePicker/DatePicker.styled.ts
import { styled as styled11 } from "@mui/material";
var DatePickerStyled = styled11(CalendarDatePicker, {
  name: "CalendarDatePicker"
})`
  .calendar-button-link {
    color: red;
  }
`;

// src/atoms/DatePicker/DatePicker.tsx
import { useTheme as useTheme8, Stack as Stack3, Typography as Typography5 } from "@mui/material";
function DatePicker(props) {
  const { canUpdate, label, value, onChange, format: format2 } = props;
  const theme = useTheme8();
  return /* @__PURE__ */ React66.createElement(Stack3, null, /* @__PURE__ */ React66.createElement(Typography5, { variant: "caption", color: theme.palette.text.primary }, label), /* @__PURE__ */ React66.createElement(
    DatePickerStyled,
    {
      clearable: true,
      disablePast: true,
      disabled: !canUpdate,
      value,
      onAccept: onChange,
      format: format2
    }
  ));
}

// src/atoms/DeleteConfirmationPopup/DeleteConfirmationPopup.tsx
import * as React67 from "react";
import { useState as useState9 } from "react";

// src/atoms/DeleteConfirmationPopup/hooks/useHandlers.ts
import { useCallback as useCallback11 } from "react";

// src/hooks/useIsUnmounted.ts
import { useCallback as useCallback10, useLayoutEffect, useRef } from "react";
function useIsUnmounted() {
  const rIsUnmounted = useRef("mounting");
  useLayoutEffect(() => {
    rIsUnmounted.current = "mounted";
    return () => void (rIsUnmounted.current = "unmounted");
  }, []);
  return useCallback10(() => rIsUnmounted.current !== "mounted", []);
}

// src/hooks/useMonitorElementWidth.ts
import { useEffect as useEffect4, useMemo as useMemo7, useRef as useRef2, useState as useState7 } from "react";
import * as _ from "lodash";
function useMonitorElementWidth(delay = 100) {
  const ref = useRef2(null);
  const [width, setWidth] = useState7();
  const debounced = useMemo7(
    () => _.debounce(() => setWidth(ref.current?.offsetWidth), delay),
    [delay]
  );
  useEffect4(() => {
    debounced();
    window.addEventListener("resize", debounced);
    return () => {
      window.removeEventListener("resize", debounced);
      debounced.flush();
    };
  }, [debounced]);
  return [ref, width];
}

// src/hooks/UseResize.ts
import { debounce as debounce2 } from "lodash";
import { useEffect as useEffect5, useState as useState8, useMemo as useMemo8 } from "react";
var useResize = (ref) => {
  const [width, setWidth] = useState8();
  const [height, setHeight] = useState8();
  const marginToNextElement = 20;
  const handleResize = useMemo8(
    () => debounce2(() => {
      if (ref.current) {
        setWidth(ref.current.offsetWidth);
        setHeight(ref.current.offsetHeight);
      }
    }, 100),
    [ref]
  );
  useEffect5(() => {
    if (ref.current) {
      setWidth(ref.current.offsetWidth + marginToNextElement);
      setHeight(ref.current.offsetHeight);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize, ref]);
  return { width, height, marginToNextElement };
};

// src/atoms/DeleteConfirmationPopup/hooks/useHandlers.ts
function useHandlers(props) {
  const { onDeleteClick, deleteActive, setConfirm, setDeleting } = props;
  const isUnmounted = useIsUnmounted();
  const handleChange = useCallback11(
    (event) => setConfirm(event.target.value),
    [setConfirm]
  );
  const handleKeyPress = useCallback11(
    (event) => event.key === "Enter" && deleteActive && onDeleteClick(),
    [deleteActive, onDeleteClick]
  );
  const handleDeleteClick = useCallback11(async () => {
    if (deleteActive) {
      setConfirm("");
      setDeleting(true);
      await onDeleteClick();
      if (isUnmounted()) return;
      setDeleting(false);
    }
  }, [deleteActive, isUnmounted, onDeleteClick, setConfirm, setDeleting]);
  return {
    handleKeyPress,
    handleDeleteClick,
    handleChange
  };
}

// src/atoms/DeleteConfirmationPopup/hooks/useData.ts
import { useMemo as useMemo9 } from "react";
function useData(props) {
  const { recordCount, deleting, confirm } = props;
  const deleteConfirmed = useMemo9(() => {
    return confirm.toLowerCase() === "delete";
  }, [confirm]);
  const title = recordCount ? `Delete ${recordCount} ${recordCount > 1 ? "Records" : "Record"}` : `Delete Record`;
  const deleteActive = deleteConfirmed && !deleting;
  return {
    deleteConfirmed,
    title,
    deleteActive
  };
}

// src/atoms/DeleteConfirmationPopup/DeleteConfirmationPopup.tsx
import {
  Box as Box9,
  Button as Button8,
  CircularProgress as CircularProgress3,
  Dialog as Dialog2,
  DialogActions as DialogActions2,
  DialogContent as DialogContent2,
  DialogContentText as DialogContentText2,
  DialogTitle as DialogTitle2,
  Stack as Stack4,
  TextField as TextField2,
  Typography as Typography6,
  useTheme as useTheme9
} from "@mui/material";
function DeleteConfirmationPopup(props) {
  const { recordCount, onCancelClick, open, description } = props;
  const [confirm, setConfirm] = useState9("");
  const [deleting, setDeleting] = useState9(false);
  const { title, deleteActive } = useData({ recordCount, deleting, confirm });
  const { handleKeyPress, handleDeleteClick, handleChange } = useHandlers({
    ...props,
    deleteActive,
    setConfirm,
    setDeleting
  });
  const descriptionText = description || "You will permanently lose these records and it cannot be undone.";
  const theme = useTheme9();
  return /* @__PURE__ */ React67.createElement(Dialog2, { open }, /* @__PURE__ */ React67.createElement(DialogTitle2, null, /* @__PURE__ */ React67.createElement(Stack4, { alignItems: "center" }, /* @__PURE__ */ React67.createElement(DeleteIcon, null)), /* @__PURE__ */ React67.createElement(Typography6, { textAlign: "center", fontSize: 24 }, title)), /* @__PURE__ */ React67.createElement(DialogContent2, { dividers: true }, /* @__PURE__ */ React67.createElement(
    Stack4,
    {
      alignItems: "center",
      bgcolor: "#f7f7f7",
      mx: -2.4,
      my: -1.6,
      px: 2.4,
      py: 1.6
    },
    deleting ? /* @__PURE__ */ React67.createElement(Stack4, { alignItems: "center", justifyContent: "center", direction: "row" }, /* @__PURE__ */ React67.createElement(CircularProgress3, null)) : /* @__PURE__ */ React67.createElement(React67.Fragment, null, /* @__PURE__ */ React67.createElement(DialogContentText2, { textAlign: "center" }, descriptionText, /* @__PURE__ */ React67.createElement("br", null), "Type \u201CDelete\u201D to confirm"), /* @__PURE__ */ React67.createElement("br", null), /* @__PURE__ */ React67.createElement(Box9, { bgcolor: theme.palette.common.white }, /* @__PURE__ */ React67.createElement(
      TextField2,
      {
        value: confirm,
        onChange: handleChange,
        onKeyPress: handleKeyPress,
        autoFocus: true,
        size: "small"
      }
    )))
  )), /* @__PURE__ */ React67.createElement(DialogActions2, null, /* @__PURE__ */ React67.createElement(Stack4, { padding: 2, direction: "row", spacing: 1 }, /* @__PURE__ */ React67.createElement(
    Button8,
    {
      onClick: onCancelClick,
      disabled: deleting,
      color: "primary",
      variant: "outlined"
    },
    "Cancel"
  ), /* @__PURE__ */ React67.createElement(
    Button8,
    {
      onClick: handleDeleteClick,
      disabled: !deleteActive,
      color: "primary",
      variant: "contained"
    },
    "Confirm"
  ))));
}

// src/atoms/Dialog/Dialog.tsx
import * as React68 from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import {
  Dialog as MuiDialog,
  DialogTitle as DialogTitle3,
  IconButton as IconButton2,
  Typography as Typography7
} from "@mui/material";
var styles7 = {
  close: {
    position: "absolute",
    top: "5px",
    right: "5px"
  }
};
var Dialog3 = (props) => {
  const {
    children,
    dataTestId,
    onClose,
    open,
    title,
    width,
    titleStyle,
    hideClose = false
  } = props;
  return /* @__PURE__ */ React68.createElement(
    MuiDialog,
    {
      open,
      onClose,
      fullWidth: true,
      maxWidth: width ? width : "md"
    },
    /* @__PURE__ */ React68.createElement(DialogTitle3, { sx: titleStyle }, /* @__PURE__ */ React68.createElement(Typography7, { display: "inline", variant: "h6" }, /* @__PURE__ */ React68.createElement("b", null, title)), !hideClose && /* @__PURE__ */ React68.createElement(
      IconButton2,
      {
        onClick: onClose,
        color: "inherit",
        sx: styles7.close,
        size: "large",
        "data-test-id": dataTestId ? `${dataTestId}-close-button` : "dialog-close-button"
      },
      /* @__PURE__ */ React68.createElement(CloseIcon, { fontSize: "inherit" })
    )),
    children
  );
};
Dialog3.displayName = "Dialog";

// src/atoms/Dialog/DialogBody.tsx
import * as React69 from "react";
import { useTheme as useTheme10, DialogContent as DialogContent3 } from "@mui/material";
var getStyles5 = (theme) => ({
  root: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1)
  }
});
var DialogBody = (props) => {
  const { children } = props;
  const styles8 = getStyles5(useTheme10());
  return /* @__PURE__ */ React69.createElement(DialogContent3, { sx: styles8.root }, children);
};
DialogBody.displayName = "DialogBody";

// src/atoms/Dialog/DialogForm.tsx
import * as React70 from "react";
import {
  Button as Button9,
  DialogActions as DialogActions3,
  DialogContent as DialogContent4,
  useTheme as useTheme11
} from "@mui/material";
var getStyles6 = (theme) => ({
  actions: {
    padding: theme.spacing(1.5)
  },
  saveBtn: {
    marginLeft: theme.spacing(1)
  }
});
var DialogForm = (props) => {
  const {
    children,
    disableSave,
    onClose,
    onSave,
    primaryBtnLabel = "Save",
    secondaryBtnLabel = "Cancel"
  } = props;
  const styles8 = getStyles6(useTheme11());
  return /* @__PURE__ */ React70.createElement(React70.Fragment, null, /* @__PURE__ */ React70.createElement(DialogContent4, null, children), /* @__PURE__ */ React70.createElement(DialogActions3, { sx: styles8.actions, disableSpacing: true }, /* @__PURE__ */ React70.createElement(
    Button9,
    {
      onClick: onClose,
      variant: "outlined",
      "data-test-id": "dialog-secondary-button"
    },
    secondaryBtnLabel
  ), /* @__PURE__ */ React70.createElement(
    Button9,
    {
      sx: styles8.saveBtn,
      color: "primary",
      disabled: disableSave,
      onClick: onSave,
      variant: "contained",
      "data-test-id": "dialog-primary-button"
    },
    primaryBtnLabel
  )));
};
DialogForm.displayName = "DialogForm";

// src/atoms/DropDown/DropDown.tsx
import * as React71 from "react";
import { styled as styled12 } from "@mui/material";
var DropDownPrimitive = styled12("select", {
  name: "DropDown",
  slot: "Root",
  skipSx: true,
  skipVariantsResolver: true,
  shouldForwardProp: (prop) => prop !== "weight"
})(({ theme, weight }) => ({
  width: !!weight ? weight : "50%",
  height: "35px",
  background: theme.palette.common.white,
  color: "gray",
  paddingLeft: theme.spacing(0.5),
  fontSize: "14px",
  border: "none",
  marginLeft: theme.spacing(1),
  " option": {
    color: theme.palette.common.black,
    background: theme.palette.common.white,
    display: "flex",
    whiteSpace: "pre",
    minHeight: "20px",
    padding: `0px ${theme.spacing(0.2)} ${theme.spacing(0.1)}`
  }
}));
var DropDown = (props) => {
  const { className = "", style, data, onChange, value, ...select } = props;
  return /* @__PURE__ */ React71.createElement(
    DropDownPrimitive,
    {
      ...select,
      style,
      className,
      data,
      onChange,
      value
    },
    /* @__PURE__ */ React71.createElement("option", { disabled: true, value: "Empty" }, "-- select an option --"),
    data.map((e, key) => {
      return /* @__PURE__ */ React71.createElement("option", { key, value: e.value }, e.name);
    })
  );
};

// src/atoms/DropDownButton/DropDownButton.tsx
import * as React72 from "react";
import { ArrowDropDown } from "@mui/icons-material";
import { Button as Button11, ButtonGroup, Menu } from "@mui/material";

// src/atoms/DropDownButton/ArrowButton.styled.ts
import { Button as Button10, styled as styled13 } from "@mui/material";
var ArrowButton = styled13(Button10, {
  name: "ArrowButton",
  slot: "Root",
  skipSx: true
})(({ theme, open }) => ({
  minWidth: "unset",
  padding: theme.spacing(0.5),
  backgroundColor: open ? "#1565c0" : theme.palette.primary.main
}));

// src/atoms/DropDownButton/DropDownButton.tsx
function DropDownButton(props) {
  const { label, children, testId, disabled, disableElevation = true } = props;
  const [anchor, setAnchor] = React72.useState(null);
  const onOpen = React72.useCallback((e) => {
    setAnchor(e.currentTarget.parentElement);
  }, []);
  const onClose = React72.useCallback(() => setAnchor(null), []);
  const open = Boolean(anchor);
  return /* @__PURE__ */ React72.createElement(React72.Fragment, null, /* @__PURE__ */ React72.createElement(
    ButtonGroup,
    {
      variant: "contained",
      "data-test-id": testId,
      disableElevation
    },
    /* @__PURE__ */ React72.createElement(
      Button11,
      {
        size: "small",
        onClick: onOpen,
        disabled,
        sx: { whiteSpace: "nowrap" },
        "data-test-id": `${testId}-dropDownBtn-main`
      },
      label
    ),
    /* @__PURE__ */ React72.createElement(
      ArrowButton,
      {
        open,
        size: "small",
        onClick: onOpen,
        disabled,
        "data-test-id": `${testId}-dropDownBtn-arrow`
      },
      /* @__PURE__ */ React72.createElement(ArrowDropDown, { fontSize: "small" })
    )
  ), /* @__PURE__ */ React72.createElement(
    Menu,
    {
      open,
      anchorEl: anchor,
      onClick: onClose,
      onClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      }
    },
    children
  ));
}

// src/atoms/ExternalLink/ExternalLink.tsx
import * as React73 from "react";

// src/atoms/ExternalLink/LinkWithArrow.styled.ts
import { styled as styled14 } from "@mui/material";
var LinkWithArrow = styled14("a", {
  name: "LinkWithArrow",
  slot: "Root",
  skipSx: true,
  shouldForwardProp: (prop) => prop !== "fontSize",
  skipVariantsResolver: true
})`
  display: inline-flex;
  font-size: ${(props) => props.fontSize ? `${props.fontSize}px` : "inherit"};
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  > img {
    content: ${(props) => props.icon ? `url(${props.icon})` : `url('/static-assets/icons/arrow-northeast.svg')`};
    margin-right: auto;
  }
`;

// src/atoms/ExternalLink/ExternalLink.tsx
function ExternalLink(props) {
  const { fontSize, href, label, icon, dataTestId } = props;
  return /* @__PURE__ */ React73.createElement(
    LinkWithArrow,
    {
      icon,
      fontSize,
      target: "_blank",
      rel: "noreferrer",
      href,
      "data-test-id": dataTestId
    },
    label,
    " \xA0 ",
    /* @__PURE__ */ React73.createElement("img", null)
  );
}

// src/atoms/FormSection/FormSection.tsx
import * as React74 from "react";

// src/atoms/FormSection/useStyles.ts
var getStyles7 = (theme, props) => ({
  additionalContentForm: {
    paddingLeft: theme.spacing(3.2),
    paddingTop: theme.spacing(2),
    "&  .Mui-GridItem": {
      paddingTop: theme.spacing(2)
    }
  },
  sectionSpacing: {
    maxWidth: props.maxWidth ?? "470px"
  }
});

// src/atoms/FormSection/FormSection.tsx
import { useTheme as useTheme12, Typography as Typography8, Grid as Grid2, Box as Box10 } from "@mui/material";
function FormSection(props) {
  const {
    additionalContent,
    label,
    children,
    spacing,
    flexDirection = "row",
    maxWidth = "470px",
    paddingBottom = 4
  } = props;
  const theme = useTheme12();
  const styles8 = getStyles7(theme, { maxWidth });
  return /* @__PURE__ */ React74.createElement(React74.Fragment, null, /* @__PURE__ */ React74.createElement(
    Box10,
    {
      sx: {
        marginBottom: theme.spacing(1.6),
        display: "flex",
        flexDirection: "column"
      }
    },
    /* @__PURE__ */ React74.createElement(Typography8, { variant: "h6" }, label)
  ), /* @__PURE__ */ React74.createElement(
    Grid2,
    {
      container: true,
      spacing: spacing ? spacing : 2,
      sx: styles8.sectionSpacing,
      justifyContent: "space-between",
      flexDirection,
      paddingBottom
    },
    additionalContent && /* @__PURE__ */ React74.createElement(Box10, { sx: styles8.additionalContentForm }, additionalContent),
    children
  ));
}

// src/atoms/Masonry/Masonry.tsx
import * as React75 from "react";

// src/atoms/Masonry/useMasonry.ts
import { useEffect as useEffect6, useMemo as useMemo10, useState as useState11 } from "react";
function useMasonry(params) {
  const { children, gutter = 0, itemWidth } = params;
  const columnWidth = itemWidth + gutter;
  const containerStyle = useMemo10(
    () => !!gutter ? { "--gutter": `${gutter}px` } : void 0,
    [gutter]
  );
  const [containerRef, containerWidth] = useMonitorElementWidth();
  const [columnCount, setColumnCount] = useState11(1);
  const childrenCols = useMemo10(() => {
    const split = [];
    children.map((item, i) => {
      const idx = i % columnCount;
      if (!split[idx]) split[idx] = [];
      split[idx].push(item);
    });
    return split;
  }, [children, columnCount]);
  useEffect6(() => {
    if (!!containerWidth && !!columnWidth) {
      const possibleColumns = Math.floor(containerWidth / columnWidth);
      setColumnCount(Math.max(possibleColumns, 1));
    }
  }, [columnWidth, containerWidth]);
  return {
    containerRef,
    containerStyle,
    childrenCols
  };
}

// src/atoms/Masonry/Masonry.tsx
import { Box as Box11 } from "@mui/material";
function Masonry(props) {
  const { sx } = props;
  const { containerRef, containerStyle, childrenCols } = useMasonry(props);
  return /* @__PURE__ */ React75.createElement(
    Box11,
    {
      component: "div",
      sx,
      ref: containerRef,
      className: `masonry-container`,
      style: containerStyle
    },
    childrenCols.map((col, i) => /* @__PURE__ */ React75.createElement("div", { key: i }, col))
  );
}

// src/atoms/Modal/Modal.tsx
import * as React76 from "react";
import { useCallback as useCallback13 } from "react";

// src/atoms/Modal/useStyles.ts
var modalStyles = (theme, customContinerWidth) => ({
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  container: {
    width: customContinerWidth || "50vw",
    p: 0
  },
  header: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.divider}`,
    p: "16px"
  },
  title: {
    color: theme.palette.text.primary
  },
  backIcon: {
    color: theme.palette.action.active,
    cursor: "pointer",
    marginRight: theme.spacing(1)
  },
  close: {
    color: theme.palette.action.active,
    cursor: "pointer",
    borderRadius: "100px"
  },
  content: {
    p: "16px",
    maxHeight: "60vh",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "16px",
      backgroundColor: theme.palette.common.white
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: theme.palette.common.white
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#babac0",
      borderRadius: "16px",
      border: "4px solid theme.palette.primary.contrastText"
    },
    "&::-webkit-scrollbar-button": {
      display: "none"
    }
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    p: "16px"
  },
  save: {
    marginLeft: theme.spacing(12),
    maxHeight: "36px"
  }
});

// src/atoms/Modal/Modal.tsx
import {
  ArrowBack as ArrowBackIcon,
  Close as CloseIcon2
} from "@mui/icons-material";
import {
  Button as Button12,
  Dialog as Dialog4,
  DialogContent as DialogContent5,
  DialogTitle as DialogTitle4,
  IconButton as IconButton3,
  Stack as Stack5,
  Typography as Typography9,
  useTheme as useTheme13
} from "@mui/material";
var ActionModal = (props) => {
  const {
    open,
    actionBtnLabel,
    backIcon = false,
    actionBtn = true,
    title,
    onClose,
    children,
    disableBackdropClick,
    ondAddNote,
    onGoBack,
    customContinerWidth = "50vw",
    disableActionBtn = false
  } = props;
  const handleOnClose = useCallback13(
    (_3, reason) => {
      if (disableBackdropClick && reason === "backdropClick") return;
      onClose();
    },
    [disableBackdropClick, onClose]
  );
  const styles8 = modalStyles(useTheme13(), customContinerWidth);
  return /* @__PURE__ */ React76.createElement(
    Dialog4,
    {
      scroll: "paper",
      open,
      onClose: handleOnClose,
      sx: styles8.modal,
      maxWidth: false
    },
    /* @__PURE__ */ React76.createElement(DialogTitle4, { sx: { p: 0 } }, /* @__PURE__ */ React76.createElement(Stack5, { sx: styles8.header, direction: "row" }, /* @__PURE__ */ React76.createElement(Stack5, { direction: "row", alignItems: "center" }, backIcon && /* @__PURE__ */ React76.createElement(
      IconButton3,
      {
        onClick: onGoBack,
        size: "medium",
        sx: styles8.backIcon,
        "data-testid": "action-modal-back-icon"
      },
      /* @__PURE__ */ React76.createElement(ArrowBackIcon, { fontSize: "medium" })
    ), title && /* @__PURE__ */ React76.createElement(Typography9, { variant: "h6", sx: styles8.title }, title)), /* @__PURE__ */ React76.createElement(Stack5, { direction: "row", alignItems: "center", gap: 0.8 }, actionBtn && actionBtnLabel && /* @__PURE__ */ React76.createElement(
      Button12,
      {
        sx: styles8.save,
        color: "primary",
        variant: "contained",
        onClick: ondAddNote,
        size: "medium",
        "data-testid": "action-modal-action-btn",
        disabled: disableActionBtn
      },
      actionBtnLabel
    ), /* @__PURE__ */ React76.createElement(
      IconButton3,
      {
        onClick: onClose,
        size: "medium",
        sx: styles8.close,
        "data-testid": "action-modal-close-btn"
      },
      /* @__PURE__ */ React76.createElement(CloseIcon2, { fontSize: "medium" })
    )))),
    /* @__PURE__ */ React76.createElement(DialogContent5, { dividers: true, sx: styles8.container }, children)
  );
};

// src/atoms/Modal/ModalForm.tsx
import * as React77 from "react";
import { Box as Box12, Button as Button13, useTheme as useTheme14 } from "@mui/material";
var ActionModalForm = (props) => {
  const { children, onSave, disableSave = false, primaryBtnLabel } = props;
  const styles8 = modalStyles(useTheme14());
  return /* @__PURE__ */ React77.createElement(React77.Fragment, null, /* @__PURE__ */ React77.createElement(Box12, { sx: styles8.content }, children), /* @__PURE__ */ React77.createElement(Box12, { sx: styles8.footer }, /* @__PURE__ */ React77.createElement(
    Button13,
    {
      sx: styles8.save,
      color: "primary",
      variant: "contained",
      onClick: onSave,
      disabled: disableSave,
      "data-testid": "modal-form-save-button"
    },
    primaryBtnLabel
  )));
};

// src/atoms/OverflowDetector/OverflowDetector.tsx
import * as React78 from "react";
import { useCallback as useCallback14, useEffect as useEffect7, useRef as useRef3 } from "react";
import { Box as Box13 } from "@mui/material";
var getStyles8 = (props) => ({
  root: {
    border: props.devMode ? "dashed 1px magenta" : "none",
    overflow: "hidden",
    transition: "height 0.25s"
  }
});
var OverflowDetector = (props) => {
  const {
    open,
    children,
    closedHeight,
    className = {},
    onOverflowChange = () => {
    },
    onTransitionEnd = () => {
    }
  } = props;
  const outerRef = useRef3(null);
  const innerRef = useRef3(null);
  const { height } = useResize(innerRef);
  const elementHeight = open ? innerRef.current ? `${innerRef.current.scrollHeight}px` : "auto" : `${closedHeight}px`;
  const calcOverflow = useCallback14(() => {
    const element = outerRef.current;
    const hasOverflow = element ? closedHeight < element.scrollHeight : true;
    onOverflowChange(hasOverflow);
  }, [closedHeight, onOverflowChange]);
  useEffect7(() => calcOverflow(), [calcOverflow, children, height]);
  const handleTransition = useCallback14(() => {
    calcOverflow();
    onTransitionEnd();
  }, [calcOverflow, onTransitionEnd]);
  const styles8 = getStyles8(props);
  return /* @__PURE__ */ React78.createElement(
    Box13,
    {
      ref: outerRef,
      sx: { ...styles8.root, ...className },
      onTransitionEnd: handleTransition,
      style: {
        height: elementHeight
      }
    },
    /* @__PURE__ */ React78.createElement("div", { ref: innerRef }, children)
  );
};
OverflowDetector.displayName = "OverflowDetector";

// src/atoms/Pagination.tsx
import * as React79 from "react";
import { Pagination as MuiPagination } from "@mui/material";
var Pagination = ({ page, pages, onChangePage }) => pages > 1 ? /* @__PURE__ */ React79.createElement(
  MuiPagination,
  {
    page,
    count: pages,
    onChange: onChangePage,
    color: "primary",
    style: { marginLeft: "auto" }
  }
) : null;
Pagination.displayName = "Pagination";
var Pagination_default = React79.memo(Pagination);

// src/atoms/PhoneLink/PhoneLink.tsx
import { Box as Box14 } from "@mui/material";
import * as React80 from "react";
import { useMemo as useMemo11 } from "react";
var PhoneLink = (props) => {
  const {
    includeExtInLink = true,
    phone,
    phoneExt,
    dataTestId,
    icon,
    sx
  } = props;
  const href = useMemo11(
    () => `tel:${phone?.replace(/[^\d]/g, "")}${includeExtInLink && phoneExt ? `,${phoneExt}` : ""}`,
    [includeExtInLink, phone, phoneExt]
  );
  return !!phone ? /* @__PURE__ */ React80.createElement(Box14, { sx }, /* @__PURE__ */ React80.createElement("a", { href, "data-test-id": dataTestId }, icon && /* @__PURE__ */ React80.createElement("span", null, icon), `${phone} ${phoneExt ? ` x${phoneExt}` : ""}`)) : /* @__PURE__ */ React80.createElement(React80.Fragment, null, "\u2014");
};
PhoneLink.displayName = "PhoneLink";

// src/atoms/SearchField/SearchField.tsx
import * as React81 from "react";
import { useState as useState12, useCallback as useCallback15, useEffect as useEffect8 } from "react";

// src/atoms/SearchField/styling.ts
var getSearchBarStyles = (theme) => ({
  searchIcon: {
    color: "#cbcbcb"
  },
  searchTextField: {
    "&::focus": {
      backgroundColor: theme.palette.common.white
    }
  },
  searchTextFieldInput: {
    backgroundColor: theme.palette.common.white,
    fontFamily: "Source Sans Pro Semibold",
    fontSize: "14px",
    color: "#848282"
  },
  searchAdornment: {
    cursor: "pointer"
  }
});
var getTextFieldStyles = (theme) => ({
  searchIcon: {
    color: "#cbcbcb"
  },
  searchTextField: {
    "&::focus": {
      backgroundColor: theme.palette.common.white
    }
  },
  searchTextFieldInput: {
    backgroundColor: theme.palette.common.white,
    fontFamily: "Source Sans Pro Semibold",
    fontSize: "14px",
    color: "#848282"
  },
  searchAdornment: {
    cursor: "pointer"
  }
});
var getInputStyles = (theme) => ({
  searchIcon: {
    color: "#cbcbcb"
  },
  searchTextField: {
    "&::focus": {
      backgroundColor: theme.palette.common.white
    }
  },
  searchTextFieldInput: {
    backgroundColor: theme.palette.common.white,
    fontFamily: "Source Sans Pro Semibold",
    fontSize: "14px",
    color: "#848282"
  },
  searchAdornment: {
    cursor: "pointer"
  }
});

// src/atoms/SearchField/SearchField.tsx
import { TextField as TextField3, useTheme as useTheme15, IconButton as IconButton4, InputAdornment } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import * as _2 from "lodash";
var SearchField = (props) => {
  const {
    delayTimeMS = 1e3,
    onChange,
    onChangeRaw,
    text,
    variant = "standard"
  } = props;
  const styles8 = getSearchBarStyles(useTheme15());
  const textFieldStyles = getTextFieldStyles(useTheme15());
  const inputStyles = getInputStyles(useTheme15());
  const [userQuery, setUserQuery] = useState12(text ? text : "");
  const updateQuery = () => onChange && onChange(userQuery);
  const delayedQuery = useCallback15(_2.debounce(updateQuery, delayTimeMS), [
    userQuery
  ]);
  const handleChange = (e) => {
    if (onChangeRaw) {
      onChangeRaw(e);
    } else {
      setUserQuery(e.target.value);
    }
  };
  useEffect8(() => {
    delayedQuery();
    return delayedQuery.cancel;
  }, [userQuery, delayedQuery]);
  return /* @__PURE__ */ React81.createElement(
    TextField3,
    {
      value: userQuery,
      autoFocus: true,
      sx: { ...textFieldStyles, ...styles8.searchTextField },
      variant,
      fullWidth: true,
      margin: variant === "outlined" ? "dense" : "normal",
      onChange: handleChange,
      placeholder: props.placeHolderText,
      spellCheck: false,
      type: "search",
      InputProps: {
        sx: {
          ...variant === "standard" && inputStyles,
          ...styles8.searchTextFieldInput
        },
        inputProps: {
          maxLength: 30
        },
        startAdornment: /* @__PURE__ */ React81.createElement(InputAdornment, { position: "start", sx: styles8.searchAdornment }, /* @__PURE__ */ React81.createElement(IconButton4, { size: "small" }, /* @__PURE__ */ React81.createElement(
          SearchIcon,
          {
            sx: styles8.searchIcon,
            style: { cursor: "pointer" }
          }
        )))
      }
    }
  );
};
SearchField.displayName = "SearchField";

// src/atoms/SearchHelperPopup/SearchHelperPopup.tsx
import * as React82 from "react";

// src/atoms/SearchHelperPopup/hooks/useData.ts
import { useState as useState13 } from "react";
function useData2() {
  const [anchorEl, setAnchorEl] = useState13(null);
  const open = Boolean(anchorEl);
  return {
    open,
    anchorEl,
    setAnchorEl
  };
}

// src/atoms/SearchHelperPopup/hooks/useHandlers.ts
import { useCallback as useCallback16 } from "react";
function useHandlers2(props) {
  const { setAnchorEl } = props;
  const handlePopoverOpen = useCallback16(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl]
  );
  const handlePopoverClose = useCallback16(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);
  return {
    handlePopoverClose,
    handlePopoverOpen
  };
}

// src/atoms/SearchHelperPopup/SearchHelperPopup.tsx
import { Alert, Box as Box15, Grid as Grid3, Link as Link2, Popover as Popover2 } from "@mui/material";
function SearchHelperPopup(props) {
  const { isLocationSearch } = props;
  const { open, anchorEl, setAnchorEl } = useData2();
  const { handlePopoverClose, handlePopoverOpen } = useHandlers2({
    setAnchorEl
  });
  return /* @__PURE__ */ React82.createElement(React82.Fragment, null, /* @__PURE__ */ React82.createElement(Alert, { severity: "info" }, "We made some improvements to the search. View", " ", /* @__PURE__ */ React82.createElement(
    Link2,
    {
      href: "#",
      underline: "always",
      onClick: handlePopoverOpen,
      style: { fontFamily: "Source Sans Pro Semibold" },
      "data-test-id": "search-helper-link"
    },
    "Search Tips"
  ), " ", "to learn how to get better results."), /* @__PURE__ */ React82.createElement(
    Popover2,
    {
      id: "search-helper-popover",
      open,
      anchorEl,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      onClose: handlePopoverClose,
      disableRestoreFocus: true
    },
    /* @__PURE__ */ React82.createElement(Box15, { p: 1, width: "457px" }, /* @__PURE__ */ React82.createElement(Grid3, { container: true, direction: "column", style: { fontSize: "14px" } }, /* @__PURE__ */ React82.createElement(
      Grid3,
      {
        item: true,
        sx: {
          padding: (theme) => `${theme.spacing(1)} 0px ${theme.spacing(1)} 0px`
        }
      },
      "Search Tips"
    ), /* @__PURE__ */ React82.createElement(Grid3, { container: true, item: true, direction: "row" }, /* @__PURE__ */ React82.createElement(
      Grid3,
      {
        container: true,
        item: true,
        direction: "column",
        xs: 3,
        style: { fontFamily: "Source Sans Pro Semibold" }
      },
      /* @__PURE__ */ React82.createElement(Grid3, { item: true }, "Customer Name:"),
      /* @__PURE__ */ React82.createElement(Grid3, { item: true }, "Phone:"),
      /* @__PURE__ */ React82.createElement(Grid3, { item: true }, "Address:"),
      /* @__PURE__ */ React82.createElement(Grid3, { item: true }, "Email:"),
      /* @__PURE__ */ React82.createElement(Grid3, { item: true }, "Location Code:"),
      /* @__PURE__ */ React82.createElement(Grid3, { item: true }, "Operators:")
    ), /* @__PURE__ */ React82.createElement(Grid3, { container: true, item: true, direction: "column", xs: 9 }, /* @__PURE__ */ React82.createElement(Grid3, { item: true }, isLocationSearch ? 'Use full name, "Jonathan Solomon Trapp"' : 'Use only last name, "Solomon"'), /* @__PURE__ */ React82.createElement(Grid3, { item: true }, "Use xxx-xxx-xxxx format"), /* @__PURE__ */ React82.createElement(Grid3, { item: true }, 'Use number and street, "382 West 15th Ave"'), /* @__PURE__ */ React82.createElement(Grid3, { item: true }, "Use address@domain.com format"), /* @__PURE__ */ React82.createElement(Grid3, { item: true }, "Search using an exact bill-to location code"), /* @__PURE__ */ React82.createElement(Grid3, { item: true }, 'Use "OR" to increase search results, "John OR Smith"')))))
  ));
}

// src/atoms/SideDrawer/SideDrawer.tsx
import * as React83 from "react";
import { Box as Box16, Drawer, IconButton as IconButton5, Typography as Typography10 } from "@mui/material";
import {
  Close as CloseIcon3,
  KeyboardArrowLeft as KeyboardArrowLeftIcon
} from "@mui/icons-material";
var SideDrawer = (props) => {
  const {
    open,
    title,
    onClose,
    children,
    dataTestId,
    disableBackdropClick,
    headerWithoutClose,
    tidalThemeActive,
    noTextTransform = false,
    titleVariant,
    titleWeight
  } = props;
  const handleOnClose = React83.useCallback(
    (_3, reason) => {
      if (disableBackdropClick && reason === "backdropClick") return;
      onClose();
    },
    [disableBackdropClick, onClose]
  );
  return /* @__PURE__ */ React83.createElement(
    Drawer,
    {
      open,
      onClose: handleOnClose,
      variant: "temporary",
      anchor: "right",
      ModalProps: {
        sx: {
          zIndex: (theme) => theme.zIndex.modal
        }
      },
      PaperProps: {
        sx: {
          display: "block",
          width: props?.width ? `${props.width}px` : 550,
          overflow: props?.overflow ?? "auto"
        }
      }
    },
    title && /* @__PURE__ */ React83.createElement(React83.Fragment, null, headerWithoutClose ? /* @__PURE__ */ React83.createElement(
      Box16,
      {
        sx: {
          width: "100%",
          display: "flex",
          alignItems: "center",
          fontSize: "14px",
          padding: (theme) => `${theme.spacing(1.1)} ${theme.spacing(2)}`,
          fontFamily: "Source Sans Pro Bold",
          height: props?.tidalThemeActive ? "56px" : "74px"
        }
      },
      /* @__PURE__ */ React83.createElement(
        LinkButton,
        {
          onClick: onClose,
          dataTestId: dataTestId ? `${dataTestId}-sliderHeadingLinkArraowLeft` : "sliderHeadingLinkArraowLeft"
        },
        /* @__PURE__ */ React83.createElement(
          Typography10,
          {
            id: "sliderHeading",
            sx: {
              color: "#1565c0",
              fontSize: tidalThemeActive ? 24 : 14,
              fontWeight: "500",
              lineHeight: "24px",
              letterSpace: "0.4px",
              display: "flex",
              alignItems: "center",
              gap: 0.5
            }
          },
          /* @__PURE__ */ React83.createElement(KeyboardArrowLeftIcon, { sx: { fontSize: 20 } }),
          title
        )
      )
    ) : /* @__PURE__ */ React83.createElement(
      Box16,
      {
        sx: {
          width: "100%",
          display: "flex",
          alignItems: "center",
          fontSize: "14px",
          padding: (theme) => `${theme.spacing(1.1)} ${theme.spacing(2)}`,
          textTransform: props?.tidalThemeActive ? "capitalize" : "uppercase",
          fontFamily: "Source Sans Pro Bold",
          height: props?.tidalThemeActive ? "56px" : "74px",
          borderBottom: props?.tidalThemeActive ? "none" : (theme) => `1px solid ${theme.palette.divider}`
        }
      },
      title && // TODO remove this when tidal is adopted
      /* @__PURE__ */ React83.createElement(
        Typography10,
        {
          fontWeight: titleWeight ? titleWeight : tidalThemeActive ? void 0 : "800",
          variant: titleVariant ? titleVariant : tidalThemeActive ? "h6" : "body1",
          sx: { textTransform: noTextTransform ? "none" : "initial" },
          id: "sliderHeading"
        },
        title
      ),
      !tidalThemeActive && /* @__PURE__ */ React83.createElement(
        IconButton5,
        {
          onClick: onClose,
          color: "inherit",
          sx: {
            minWidth: "unset",
            marginLeft: "auto"
          },
          "data-test-id": dataTestId ? `${dataTestId}-closeSideDrawerButton` : "closeSideDrawerButton"
        },
        /* @__PURE__ */ React83.createElement(CloseIcon3, { fontSize: "inherit" })
      )
    )),
    children
  );
};

// src/atoms/SideDrawer/SideDrawerForm.tsx
import * as React84 from "react";

// src/atoms/SideDrawer/useStyles.ts
var getDrawerStyles = (props) => ({
  modal: { zIndex: (theme) => theme.zIndex.modal },
  drawer: {
    display: "block",
    width: props?.width ? `${props.width}px` : 550,
    overflow: props?.overflow ?? "auto"
  },
  header: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    padding: (theme) => `${theme.spacing(1.1)} ${theme.spacing(2)}`,
    textTransform: props?.tidalThemeActive ? "capitalize" : "uppercase",
    height: props?.tidalThemeActive ? "56px" : "74px",
    borderBottom: props?.tidalThemeActive ? "none" : (theme) => `1px solid ${theme.palette.divider}`
  },
  headerWithoutBack: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    padding: (theme) => `${theme.spacing(1.1)} ${theme.spacing(2)}`,
    height: props?.tidalThemeActive ? "56px" : "74px"
  },
  close: {
    minWidth: "unset",
    marginLeft: "auto"
  }
});
var getFormStyles = (props) => ({
  container: {
    overflowY: "auto",
    width: "100%",
    bottom: props && props.containerBottom ? props.containerBottom : "78px",
    top: props && props.containerTop ? props.containerTop : props?.tidalMode ? "60px" : "73px",
    position: "absolute"
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: (theme) => props?.tidalThemeActive ? theme.spacing(2.125) : theme.spacing(1.7),
    height: "78px",
    position: "absolute",
    width: "100%",
    bottom: 0,
    borderTop: props?.tidalMode ? "none" : (theme) => `1px solid ${theme.palette.divider}`,
    left: 0
  },
  close: {
    lineHeight: "unset",
    height: props?.actionButtonHeight || "initial",
    textTransform: props?.noTextTransform ? "none" : "initial"
  },
  save: {
    lineHeight: "unset",
    height: props?.actionButtonHeight || "100%",
    marginLeft: (theme) => theme.spacing(1.2)
  }
});

// src/atoms/SideDrawer/SideDrawerForm.tsx
import { Box as Box17, Button as Button14, Divider, Typography as Typography11 } from "@mui/material";
function SideDrawerForm(props) {
  const {
    onSave,
    onCancel,
    disableCancel = false,
    disableSave = false,
    primaryBtnLabel = "Save",
    secondaryBtnLabel = "Cancel",
    padding,
    footer,
    sx,
    saveBtnDataTestId,
    cancelBtnDataTestId,
    containerTop,
    containerBottom,
    tidalThemeActive,
    containerStyle,
    cancelBtnVariant,
    noTextTransform,
    tidalMode,
    actionButtonHeight,
    saveBtnDisableInfo
  } = props;
  const styles8 = getFormStyles({
    containerTop,
    containerBottom,
    tidalThemeActive,
    tidalMode,
    noTextTransform,
    actionButtonHeight
  });
  return /* @__PURE__ */ React84.createElement(React84.Fragment, null, /* @__PURE__ */ React84.createElement(
    Box17,
    {
      padding,
      left: 0,
      sx: { ...styles8.container, ...containerStyle, ...sx }
    },
    props.children
  ), !!footer && /* @__PURE__ */ React84.createElement(React84.Fragment, null, !tidalMode && /* @__PURE__ */ React84.createElement(Divider, null), footer), /* @__PURE__ */ React84.createElement(Box17, { sx: styles8.footer }, onCancel ? /* @__PURE__ */ React84.createElement(
    Button14,
    {
      variant: cancelBtnVariant || tidalMode ? "text" : "outlined",
      onClick: onCancel,
      "data-test-id": cancelBtnDataTestId ? cancelBtnDataTestId : "sideDrawerCloseBtn",
      disabled: disableCancel,
      sx: styles8.close
    },
    secondaryBtnLabel
  ) : null, onSave && /* @__PURE__ */ React84.createElement(LightTooltip, { title: saveBtnDisableInfo || "" }, /* @__PURE__ */ React84.createElement(Typography11, { component: "span" }, /* @__PURE__ */ React84.createElement(
    Button14,
    {
      sx: styles8.save,
      color: "primary",
      variant: "contained",
      onClick: onSave,
      disabled: disableSave,
      "data-test-id": saveBtnDataTestId ? saveBtnDataTestId : ""
    },
    primaryBtnLabel
  )))));
}

// src/atoms/SimpleAccordion/SimpleAccordion.tsx
import {
  Accordion as MuiAccordion,
  styled as styled15,
  accordionClasses
} from "@mui/material";
var SimpleAccordion = styled15(MuiAccordion)({
  boxShadow: "none",
  "&:not(:last-child)": {
    borderBottom: 0
  },
  "::before": { display: "none" },
  [`&.${accordionClasses.expanded}`]: { margin: "auto" }
});

// src/atoms/SimpleAccordion/SimpleAccordionSummary.tsx
import {
  AccordionSummary as MuiAccordionSummary,
  accordionSummaryClasses,
  styled as styled16
} from "@mui/material";
var SimpleAccordionSummary = styled16(MuiAccordionSummary)(() => ({
  flexDirection: "row-reverse",
  padding: 0,
  minHeight: "unset",
  [`&.${accordionSummaryClasses.expanded}`]: {
    minHeight: "unset"
  },
  [`& .${accordionSummaryClasses.content}`]: {
    margin: "0",
    [`&.${accordionSummaryClasses.expanded}`]: {
      margin: "0"
    }
  },
  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    marginLeft: "-8px",
    transform: "rotate(0deg)",
    [`&.${accordionSummaryClasses.expanded}`]: {
      transform: "rotate(180deg)"
    }
  },
  expanded: {}
}));

// src/atoms/SimpleAccordion/SimpleAccordionDetail.tsx
import {
  AccordionDetails as MuiAccordionDetails,
  styled as styled17
} from "@mui/material";
var SimpleAccordionDetails = styled17(MuiAccordionDetails)(() => ({
  padding: 0
}));

// src/atoms/SimpleAccordion/SimpleAccordionNoRotateSummary.tsx
import {
  AccordionSummary as MuiAccordionSummary2,
  accordionSummaryClasses as accordionSummaryClasses2,
  styled as styled18
} from "@mui/material";
var SimpleAccordionNoRotateSummary = styled18(MuiAccordionSummary2)(
  () => ({
    flexDirection: "row-reverse",
    padding: 0,
    minHeight: "unset",
    [`&.${accordionSummaryClasses2.expanded}`]: {
      minHeight: "unset"
    },
    [`& .${accordionSummaryClasses2.content}`]: {
      margin: "0",
      [`&.${accordionSummaryClasses2.expanded}`]: {
        margin: "0"
      }
    },
    [`& .${accordionSummaryClasses2.expandIconWrapper}`]: {
      marginLeft: "-8px",
      [`&.${accordionSummaryClasses2.expanded}`]: {
        transform: "translateY(-50%) rotate(45deg)"
      }
    },
    expanded: {}
  })
);

// src/atoms/TablePagination/TablePagination.tsx
import * as React85 from "react";
import { TablePagination as MuiTablePagination } from "@mui/material";
var TablePagination = ({
  page,
  perPage,
  resultCount,
  onChange,
  className,
  style,
  sx
}) => {
  return /* @__PURE__ */ React85.createElement(
    MuiTablePagination,
    {
      sx,
      page,
      rowsPerPage: perPage,
      rowsPerPageOptions: [perPage],
      count: resultCount,
      onPageChange: onChange,
      component: "div",
      className,
      style
    }
  );
};
TablePagination.displayName = "TablePagination";
var TablePagination_default = React85.memo(TablePagination);

// src/atoms/TablePagination/useTablePagination.ts
import { useState as useState14, useCallback as useCallback18 } from "react";
var useTablePagination = () => {
  const [page, setPage] = useState14(0);
  const onChangePage = useCallback18(
    (_e, newPage) => setPage(newPage),
    []
  );
  return { page, onChangePage };
};

// src/atoms/TablePagination/TablePaginationProgress.tsx
import * as React86 from "react";
import {
  useTheme as useTheme16,
  TableRow,
  TableCell,
  Box as Box18,
  LinearProgress
} from "@mui/material";
var getStyles9 = (theme) => ({
  pagination: { marginLeft: "auto" },
  resultContainer: {
    fontSize: "14px",
    marginRight: theme.spacing(2)
  },
  resultLabel: {
    fontFamily: "Source Sans Pro Bold",
    marginRight: theme.spacing(1)
  },
  resultCount: {
    color: theme.palette.text.primary
  }
});
var TablePaginationProgress = ({ colSpan, loading, pageCount, ...props }) => {
  const theme = useTheme16();
  const styles8 = getStyles9(theme);
  return /* @__PURE__ */ React86.createElement(TableRow, null, /* @__PURE__ */ React86.createElement(TableCell, { colSpan }, /* @__PURE__ */ React86.createElement(Box18, { display: "flex", alignItems: "center", minHeight: "12px" }, /* @__PURE__ */ React86.createElement(Box18, { sx: styles8.resultContainer }, /* @__PURE__ */ React86.createElement("span", { style: styles8.resultLabel }, "Results"), /* @__PURE__ */ React86.createElement("span", { style: styles8.resultCount }, props.resultCount, " Found")), loading && /* @__PURE__ */ React86.createElement(LinearProgress, { color: "primary", style: { flexGrow: 1 } }), pageCount > 1 && /* @__PURE__ */ React86.createElement(TablePagination_default, { ...props, style: styles8.pagination }))));
};
TablePaginationProgress.displayName = "TablePaginationProgress";

// src/atoms/Tabs/Tab.tsx
import * as React87 from "react";
import { Tab as MuiTab } from "@mui/material";
var Tab = (props) => /* @__PURE__ */ React87.createElement(MuiTab, { id: `tab-${props.value}`, ...props });
Tab.displayName = "Tab";

// src/atoms/Tabs/TabPanel.tsx
import * as React88 from "react";
import { Box as Box19 } from "@mui/material";
var TabPanel = ({
  value,
  tab,
  children,
  sx,
  ...rest
}) => /* @__PURE__ */ React88.createElement(
  Box19,
  {
    id: `tabPanel-${value}`,
    "aria-labelledby": `tab-${value}`,
    role: "tabpanel",
    hidden: value !== tab,
    sx,
    ...rest
  },
  value === tab && children
);
TabPanel.displayName = "TabPanel";

// src/atoms/Tabs/HugeTabs.styled.ts
import { Tabs, tabsClasses, styled as styled19 } from "@mui/material";
var HugeTabs = styled19(Tabs, {
  slot: "Root",
  skipSx: true,
  name: "HugeTabs"
})({
  minHeight: "72px",
  [`& .${tabsClasses.flexContainer}`]: {
    minHeight: "72px"
  }
});

// src/atoms/ToggleButtons/ToggleButtons.tsx
import * as React89 from "react";
import { useCallback as useCallback19 } from "react";

// src/atoms/ToggleButtons/styling.ts
var getToggleButtonStyles = (theme) => ({
  backgroundColor: theme.palette.common.white,
  borderColor: "#19305a",
  borderRadius: 4,
  border: "solid 1px",
  color: theme.palette.text.primary,
  height: 40,
  padding: "0 30px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#f7f7f7"
  },
  transition: "all .5s",
  "&$selected": {
    backgroundColor: theme.palette.primary.light,
    borderColor: theme.palette.primary.light,
    border: `solid 1px ${theme.palette.primary.light} #`,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: "#003272"
    }
  }
});

// src/atoms/ToggleButtons/ToggleButtons.tsx
import { useTheme as useTheme17, ToggleButtonGroup } from "@mui/material";
var ToggleButtons = (props) => {
  const theme = useTheme17();
  const handleToggleButtonClick = useCallback19(
    (_event, value) => {
      if (value) {
        props.onChange(value);
      }
    },
    [props]
  );
  const modifyChildren = (child) => {
    const props2 = {
      sx: getToggleButtonStyles(theme)
    };
    return React89.cloneElement(child, props2);
  };
  return /* @__PURE__ */ React89.createElement(
    ToggleButtonGroup,
    {
      value: props.initialValue,
      exclusive: true,
      onChange: handleToggleButtonClick
    },
    React89.Children.map(props.children, (child) => modifyChildren(child))
  );
};
ToggleButtons.displayName = "ToggleButtons";

// src/atoms/Tooltip/Tooltip.tsx
import * as React90 from "react";
import {
  styled as styled20,
  Tooltip as Tooltip2,
  tooltipClasses as tooltipClasses2
} from "@mui/material";
var WWMTooltip = styled20(({ className, ...props }) => /* @__PURE__ */ React90.createElement(Tooltip2, { ...props, classes: { popper: className } }))(({ theme }) => ({
  [`& .${tooltipClasses2.arrow}`]: {
    color: theme.palette.background.paper
  },
  [`& .${tooltipClasses2.tooltip}`]: {
    color: "#666",
    backgroundColor: theme.palette.common.white,
    border: "solid 1px #ddd",
    boxShadow: "5px 5px 5px 0px rgba(0,0,0,0.16)",
    fontSize: "14px",
    fontFamily: "Source Sans Pro Semibold",
    padding: theme.spacing(1.5)
  }
}));

// src/atoms/ValidationAlert/ValidationAlert.tsx
import * as React91 from "react";
import { styled as styled21 } from "@mui/material";
var ValidationAlertPrimitive = styled21("div")({
  color: "rgb(165, 39, 39)"
});
ValidationAlertPrimitive.displayName = "Text";
var ValidationAlert = (props) => {
  const { children = "", className = "", style, ...label } = props;
  return /* @__PURE__ */ React91.createElement(ValidationAlertPrimitive, { ...label, style, className }, children);
};

// src/atoms/ValidationErrors/MuiValidationIcon.tsx
import * as React92 from "react";
function MuiValidationIcon(props) {
  const { showError } = props;
  return /* @__PURE__ */ React92.createElement(
    "span",
    {
      "aria-hidden": "true",
      className: `MuiInputLabel-asterisk MuiFormLabel-asterisk ${showError ? "Mui-error" : ""} css-1976edk-MuiFormLabel-asterisk`
    },
    " *"
  );
}

// src/atoms/AdditionalInfoListItem.tsx
import * as React94 from "react";
import { useCallback as useCallback20, useEffect as useEffect9, useRef as useRef4, useState as useState15 } from "react";

// src/atoms/InfoTooltip.tsx
import * as React93 from "react";
import {
  InfoOutlined as InfoIconOutlined,
  Info as InfoIcon2
} from "@mui/icons-material";
var InfoTooltip = (props) => {
  const {
    infoText,
    tooltipPlacement,
    iconType = "outlined",
    sx,
    style,
    arrow,
    tooltipWidth,
    tooltipShadow,
    fontSize,
    background,
    color,
    iconColor
  } = props;
  const iconProps = {
    color: iconColor ? iconColor : "primary",
    sx: {
      fontSize: fontSize || "small",
      ...sx
    }
  };
  return /* @__PURE__ */ React93.createElement(
    LightTooltip,
    {
      style,
      title: infoText,
      placement: tooltipPlacement,
      enterTouchDelay: 0,
      arrow,
      tooltipWidth,
      tooltipShadow,
      background,
      color
    },
    iconType == "outlined" ? /* @__PURE__ */ React93.createElement(InfoIconOutlined, { ...iconProps }) : /* @__PURE__ */ React93.createElement(InfoIcon2, { ...iconProps })
  );
};

// src/atoms/AdditionalInfoListItem.tsx
import { Grid as Grid4, Typography as Typography12, useTheme as useTheme18 } from "@mui/material";
function AdditionalInfoListItem(props) {
  const { title, subtitle, toolTipInfoText, clampLines } = props;
  const ref = useRef4(null);
  const valueRef = useRef4(null);
  const [state, setState] = useState15(() => ({
    open: false,
    overflow: false,
    valueOpen: false,
    valueOverflow: false
  }));
  const { open, valueOpen } = state;
  const onOpen = useCallback20(
    () => setState((s) => ({ ...s, open: s.overflow })),
    []
  );
  const onClose = useCallback20(
    () => setState((s) => ({ ...s, open: false })),
    []
  );
  const onValueOpen = useCallback20(
    () => setState((s) => ({ ...s, valueOpen: s.valueOverflow })),
    []
  );
  const onValueClose = useCallback20(
    () => setState((s) => ({ ...s, valueOpen: false })),
    []
  );
  useEffect9(() => {
    const e = ref.current;
    if (e) {
      const overX = e.offsetWidth < e.scrollWidth;
      const overY = e.offsetHeight < e.scrollHeight;
      const overflow = overX || overY;
      setState((s) => ({ ...s, overflow }));
    }
  }, []);
  useEffect9(() => {
    const e = valueRef.current;
    if (!e || !clampLines) return;
    const measure = () => {
      const overX = e.offsetWidth < e.scrollWidth;
      const overY = e.offsetHeight < e.scrollHeight;
      const valueOverflow = overX || overY;
      setState(
        (s) => s.valueOverflow === valueOverflow ? s : { ...s, valueOverflow }
      );
    };
    measure();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(measure);
    observer.observe(e);
    return () => observer.disconnect();
  }, [subtitle, clampLines]);
  const theme = useTheme18();
  const value = /* @__PURE__ */ React94.createElement(
    Typography12,
    {
      ref: valueRef,
      variant: "subtitle2",
      color: theme.palette.text.primary,
      sx: clampLines ? {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: clampLines,
        overflow: "hidden",
        overflowWrap: "anywhere"
      } : void 0
    },
    subtitle || /* @__PURE__ */ React94.createElement(React94.Fragment, null, "-")
  );
  return /* @__PURE__ */ React94.createElement(Grid4, { item: true }, /* @__PURE__ */ React94.createElement(
    Typography12,
    {
      ref,
      style: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    },
    /* @__PURE__ */ React94.createElement(
      LightTooltip,
      {
        open,
        title,
        onOpen,
        onClose,
        placement: "bottom-start"
      },
      /* @__PURE__ */ React94.createElement(
        Typography12,
        {
          variant: "body2",
          color: theme.palette.text.secondary,
          component: "span"
        },
        title,
        ":",
        ` `
      )
    ),
    !!toolTipInfoText && /* @__PURE__ */ React94.createElement(InfoTooltip, { infoText: toolTipInfoText, tooltipPlacement: "right" })
  ), clampLines ? /* @__PURE__ */ React94.createElement(
    LightTooltip,
    {
      open: valueOpen,
      title: subtitle ?? "",
      onOpen: onValueOpen,
      onClose: onValueClose,
      placement: "bottom-start"
    },
    value
  ) : value);
}

// src/atoms/CollapsibleSection.tsx
import * as React95 from "react";
import { useCallback as useCallback21, useMemo as useMemo12, useState as useState16 } from "react";
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon
} from "@mui/icons-material";
import {
  Box as Box20,
  Collapse as Collapse3,
  IconButton as IconButton6,
  Typography as Typography13,
  useTheme as useTheme19
} from "@mui/material";
var getStyles10 = (props) => ({
  root: {
    borderBottom: props.bottomBorder || typeof props.bottomBorder === "undefined" ? "1px solid #eeeeee" : "none"
  },
  expandButton: {
    marginRight: typeof props.buttonMargin !== "undefined" ? `${props.buttonMargin}px` : "20px"
  },
  title: {
    fontSize: "20px",
    fontFamily: "Source Sans Pro Semibold"
  }
});
var CollapsibleSection = (props) => {
  const {
    children,
    dark,
    drawerPadding,
    headerSx,
    headerPadding,
    title,
    onClose,
    onOpen,
    openOnMount = true,
    keepMounted = false,
    headerRightContent,
    headerLeftContent
  } = props;
  const [open, setOpen] = useState16(openOnMount);
  const theme = useTheme19();
  const rootStyles = useMemo12(() => {
    return {
      backgroundColor: dark ? "fbfbfb" : theme.palette.common.white
    };
  }, [dark]);
  const headerStyles = useMemo12(() => {
    return {
      padding: headerPadding || "20px",
      fontSize: "20px"
    };
  }, [headerPadding]);
  const drawerStyles = useMemo12(() => {
    return {
      padding: drawerPadding || "0px 20px 20px 70px"
    };
  }, [drawerPadding]);
  const handleIconClick = useCallback21(() => {
    if (open) {
      if (onClose) {
        onClose();
      }
    } else {
      if (onOpen) {
        onOpen();
      }
    }
    setOpen(!open);
  }, [onClose, onOpen, open]);
  const styles8 = getStyles10(props);
  return /* @__PURE__ */ React95.createElement(Box20, { sx: styles8.root, style: rootStyles }, /* @__PURE__ */ React95.createElement(Box20, { display: "flex", alignItems: "center", style: headerStyles }, /* @__PURE__ */ React95.createElement(
    IconButton6,
    {
      "aria-label": "expand row",
      sx: styles8.expandButton,
      color: "primary",
      onClick: handleIconClick,
      size: "small"
    },
    open ? /* @__PURE__ */ React95.createElement(KeyboardArrowUpIcon, null) : /* @__PURE__ */ React95.createElement(KeyboardArrowDownIcon, null)
  ), !!headerLeftContent && /* @__PURE__ */ React95.createElement(Box20, null, headerLeftContent), /* @__PURE__ */ React95.createElement(Typography13, { sx: headerSx ?? styles8.title }, " ", title, " "), !!headerRightContent && /* @__PURE__ */ React95.createElement(Box20, { ml: "auto" }, headerRightContent)), /* @__PURE__ */ React95.createElement(Collapse3, { in: open, timeout: "auto", unmountOnExit: !keepMounted }, /* @__PURE__ */ React95.createElement(Box20, { style: drawerStyles }, children)));
};

// src/atoms/ConfirmationDialog.tsx
import * as React96 from "react";
import { useCallback as useCallback22 } from "react";
import {
  Button as Button15,
  Dialog as Dialog5,
  DialogActions as DialogActions4,
  DialogContent as DialogContent6,
  DialogContentText as DialogContentText3,
  DialogTitle as DialogTitle5,
  IconButton as IconButton7,
  Slide as Slide2
} from "@mui/material";
import { Close as CloseIcon4 } from "@mui/icons-material";
var Transition3 = React96.forwardRef(function Transition4(props, ref) {
  return /* @__PURE__ */ React96.createElement(Slide2, { direction: "up", ref, ...props });
});
function ConfirmationDialog(props) {
  const {
    backdropClick,
    open,
    okButtonDisabled,
    okClick,
    cancelClick,
    closeIconClick,
    dataTestId,
    title,
    children,
    message,
    cancelButtonText = "Cancel",
    messageFontSize = 16,
    okButtonText
  } = props;
  const handleClose = useCallback22(
    (_event, reason) => {
      if (backdropClick && reason === "backdropClick") {
        backdropClick();
      } else {
        cancelClick();
      }
    },
    [backdropClick, cancelClick]
  );
  return /* @__PURE__ */ React96.createElement(
    Dialog5,
    {
      open,
      TransitionComponent: Transition3,
      keepMounted: true,
      onClose: handleClose,
      "aria-labelledby": "alert-dialog-slide-title",
      "aria-describedby": "alert-dialog-slide-description",
      sx: { minWidth: "486px" }
    },
    /* @__PURE__ */ React96.createElement(
      DialogTitle5,
      {
        id: "alert-dialog-slide-title",
        sx: {
          padding: `${closeIconClick ? "20px" : "24px"} 24px 16px 24px`,
          backgroundColor: "#FBECE9",
          color: "#A62E18",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        },
        variant: "h6"
      },
      title,
      closeIconClick && /* @__PURE__ */ React96.createElement(
        IconButton7,
        {
          onClick: closeIconClick,
          "data-test-id": dataTestId ? `${dataTestId}-closeBtn` : "closeBtn"
        },
        /* @__PURE__ */ React96.createElement(CloseIcon4, null)
      )
    ),
    /* @__PURE__ */ React96.createElement(DialogContent6, { sx: { padding: 0 } }, message && /* @__PURE__ */ React96.createElement(
      DialogContentText3,
      {
        id: "alert-dialog-slide-description",
        sx: {
          fontSize: messageFontSize,
          padding: "24px 24px 20px 24px"
        },
        variant: "body1"
      },
      message
    ), children),
    /* @__PURE__ */ React96.createElement(
      DialogActions4,
      {
        sx: {
          padding: "8px 24px 24px 24px"
        }
      },
      /* @__PURE__ */ React96.createElement(Button15, { onClick: cancelClick, color: "primary", "data-test-id": "cancelBtn" }, cancelButtonText),
      okButtonText && /* @__PURE__ */ React96.createElement(
        Button15,
        {
          disabled: okButtonDisabled,
          onClick: okClick,
          color: "primary",
          "data-test-id": "okBtn",
          variant: "contained"
        },
        okButtonText
      )
    )
  );
}

// src/atoms/Editable.tsx
import { useState as useState17, useEffect as useEffect10 } from "react";
import * as React97 from "react";
var Editable = ({
  text,
  type,
  placeholder,
  children,
  childRef,
  ...props
}) => {
  const [isEditing, setEditing] = useState17(false);
  useEffect10(() => {
    if (childRef && childRef.current && isEditing === true) {
      childRef.current.focus();
    }
  }, [isEditing, childRef]);
  const handleOnBlur = (event) => {
    event.preventDefault();
    setEditing(false);
    if (props.onChangeEdit) {
      props.onChangeEdit(false);
    }
  };
  return /* @__PURE__ */ React97.createElement("div", { ...props }, isEditing ? /* @__PURE__ */ React97.createElement("div", { onBlur: (e) => handleOnBlur(e), className: "editable" }, children) : /* @__PURE__ */ React97.createElement("div", { className: "editable" }, /* @__PURE__ */ React97.createElement("span", null, " ", text !== 0 && text !== 1 ? text || placeholder || "Editable content" : text.toString() || placeholder || "Editable content"), /* @__PURE__ */ React97.createElement(
    EditButtonIcon,
    {
      onClick: () => {
        setEditing(true);
        if (props.onChangeEdit) {
          props.onChangeEdit(true);
        }
      }
    }
  )));
};

// src/atoms/FutureDevelopment.tsx
import { styled as styled22 } from "@mui/material";
import * as React98 from "react";
var Container4 = styled22("div")(({ theme }) => ({
  backgroundColor: "#f7f0f0",
  marginTop: theme.spacing(0.4),
  position: "relative"
}));
var Title = styled22("div")(({ theme }) => ({
  color: "#f00",
  fontFamily: "sans-serif",
  fontWeight: "bold",
  left: "50%",
  letterSpacing: "12px",
  marginTop: theme.spacing(2.2),
  marginLeft: theme.spacing(-12),
  opacity: "0.1",
  pointerEvents: "none",
  position: "absolute",
  textAlign: "center",
  transform: "rotate(-5deg)",
  width: "240px"
}));
var FutureDevelopment = (props) => {
  return /* @__PURE__ */ React98.createElement(Container4, null, /* @__PURE__ */ React98.createElement(Title, null, props.title ? props.title : "FUTURE DEVELOPMENT"), props.children);
};

// src/atoms/HeaderAddButton.tsx
import * as React99 from "react";
import { Button as Button16, useTheme as useTheme20 } from "@mui/material";
var getStyles11 = (theme) => ({
  addEmailAddress: {
    color: theme.palette.primary.light,
    float: "right"
  },
  plusIcon: {
    marginRight: theme.spacing(0.4),
    width: 1.8
  }
});
var HeaderAddButton = (props) => {
  const { children, disabled, onClick } = props;
  const styles8 = getStyles11(useTheme20());
  return /* @__PURE__ */ React99.createElement(Button16, { sx: styles8.addEmailAddress, disabled, onClick }, children);
};
HeaderAddButton.displayName = "HeaderAddButton";

// src/atoms/HighlightedText.tsx
import * as React100 from "react";
function escapeRegExp(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
var HighlightedText = ({
  text,
  searchText,
  phone = false,
  highlightColor = "#fff2bd"
}) => React100.useMemo(() => {
  const parts = text?.split(new RegExp(`(${escapeRegExp(searchText)})`, "gi")) ?? [];
  return /* @__PURE__ */ React100.createElement("span", null, parts.map((part, i) => {
    let highlighted = part.toLowerCase() === searchText?.toLowerCase();
    if (phone && searchText?.length === 9) {
      highlighted = part.replaceAll(/[\(\)\-\s]/g, "") === searchText.replaceAll(/[\(\)\-\s]/g, "");
    }
    return highlighted ? /* @__PURE__ */ React100.createElement("span", { key: i, style: { backgroundColor: highlightColor } }, part) : /* @__PURE__ */ React100.createElement("span", { key: i }, part);
  }));
}, [highlightColor, searchText, text]);
HighlightedText.displayName = "HighlightedText";

// src/atoms/LoadingSpinner.tsx
import * as React101 from "react";
import { styled as styled23, CircularProgress as CircularProgress4 } from "@mui/material";
var Container5 = styled23("div", {
  name: "LoadingBox",
  slot: "Root",
  skipSx: true
})`
  height: 100%;
  display: flex;
  align-items: center;
`;
var Spinner = styled23(CircularProgress4, {
  name: "Spinner",
  slot: "Root",
  skipSx: true
})`
  margin: auto;
`;
function LoadingSpinner() {
  return /* @__PURE__ */ React101.createElement(Container5, null, /* @__PURE__ */ React101.createElement(Spinner, null));
}

// src/atoms/MessageDialogPopup.tsx
import * as React102 from "react";
import { useCallback as useCallback23 } from "react";
import {
  Button as Button17,
  Dialog as Dialog6,
  DialogActions as DialogActions5,
  DialogContent as DialogContent7,
  DialogContentText as DialogContentText4,
  DialogTitle as DialogTitle6,
  Slide as Slide3
} from "@mui/material";
var Transition5 = React102.forwardRef(function Transition6(props, ref) {
  return /* @__PURE__ */ React102.createElement(Slide3, { direction: "up", ref, ...props });
});
function MessageDialogPopup(props) {
  const {
    backdropClick,
    open,
    cancelClick,
    title,
    children,
    message,
    cancelButtonText = "Cancel",
    cancelButtonVariant,
    actionButtons = [],
    actionButtonsPlacement = "start",
    paddingRight = 3
  } = props;
  const handleClose = useCallback23(
    (_event, reason) => {
      if (backdropClick && reason === "backdropClick") {
        backdropClick();
      } else {
        cancelClick();
      }
    },
    [backdropClick, cancelClick]
  );
  return /* @__PURE__ */ React102.createElement(
    Dialog6,
    {
      open,
      TransitionComponent: Transition5,
      keepMounted: true,
      onClose: handleClose,
      "aria-labelledby": "alert-dialog-slide-title",
      "aria-describedby": "alert-dialog-slide-description"
    },
    /* @__PURE__ */ React102.createElement(
      DialogTitle6,
      {
        id: "alert-dialog-slide-title",
        sx: {
          padding: 3,
          paddingBottom: 2
        }
      },
      title
    ),
    /* @__PURE__ */ React102.createElement(DialogContent7, { sx: { paddingX: 3, paddingRight } }, message && /* @__PURE__ */ React102.createElement(
      DialogContentText4,
      {
        id: "alert-dialog-slide-description",
        variant: "body1",
        sx: {
          color: (theme) => theme.palette.text.primary,
          fontSize: "16px"
        }
      },
      message
    ), children),
    /* @__PURE__ */ React102.createElement(DialogActions5, { sx: { paddingX: 3, paddingBottom: 3 } }, actionButtonsPlacement === "start" && actionButtons, /* @__PURE__ */ React102.createElement(
      Button17,
      {
        onClick: cancelClick,
        color: "primary",
        "data-test-id": "cancelBtn",
        variant: cancelButtonVariant || "contained"
      },
      cancelButtonText
    ), actionButtonsPlacement === "end" && actionButtons)
  );
}

// src/atoms/MuiTextFieldFormik.tsx
import * as React103 from "react";
import {
  TextField as MuiTextField
} from "@mui/material";
import { getIn } from "formik";
var MuiTextFieldFormik = ({
  form: { isSubmitting, errors, touched },
  disabled = isSubmitting,
  field: { onBlur: fieldOnBlur, ...field },
  onBlur: propsOnBlur,
  ...props
}) => {
  const errorText = getIn(errors, field.name);
  const error = getIn(touched, field.name) && errorText !== void 0;
  const onBlur = React103.useCallback(
    (event) => {
      if (propsOnBlur) {
        propsOnBlur(event);
      }
      fieldOnBlur(event ?? field.name);
    },
    [field.name, fieldOnBlur, propsOnBlur]
  );
  const textFieldProps = {
    ...field,
    ...props,
    margin: props.margin ?? "dense",
    disabled,
    error,
    helperText: !!errorText && error ? errorText : props.helperText,
    onBlur
  };
  return /* @__PURE__ */ React103.createElement(MuiTextField, { ...textFieldProps });
};
MuiTextFieldFormik.displayName = "MuiTextFieldFormik";

// src/atoms/NoResultsCard.tsx
import * as React104 from "react";
import { useTheme as useTheme21, Box as Box21, Card } from "@mui/material";
var getStyles12 = (theme) => ({
  noResults: {
    width: "100%",
    textAlign: "center",
    padding: `${theme.spacing(5.5)} 0`,
    color: theme.palette.text.disabled
  },
  zero: {
    fontSize: "104px"
  }
});
var NoResultsCard = (props) => {
  const styles8 = getStyles12(useTheme21());
  return /* @__PURE__ */ React104.createElement(Card, { sx: { ...styles8.noResults }, square: true, elevation: 1 }, /* @__PURE__ */ React104.createElement(Box21, { sx: { ...styles8.zero } }, "0"), props.label);
};
NoResultsCard.displayName = "NoResultsCard";

// src/atoms/PageHeader.tsx
import * as React105 from "react";
import { Box as Box22 } from "@mui/material";
var PageHeader = (props) => {
  const {
    alignItems,
    children,
    noPadding,
    flexDirection,
    flexWrap,
    dataTestId
  } = props;
  return /* @__PURE__ */ React105.createElement(
    Box22,
    {
      alignItems: alignItems || "center",
      bgcolor: "#f9f9f9",
      boxShadow: "0 2px 4px 0 rgba(202, 202, 202, 0.5)",
      display: "flex",
      px: noPadding ? 0 : 2,
      py: noPadding ? 0 : 1,
      flexDirection,
      flexWrap,
      "data-test-id": dataTestId
    },
    children
  );
};
PageHeader.displayName = "PageHeader";

// src/atoms/SelectStyled.tsx
import { styled as styled24, TextField as TextField4 } from "@mui/material";
var SelectStyled = styled24(TextField4, { name: "StyledSelector" })`
  font-size: 14px;
  text-align: left;
  width: 150px;
  color: theme.palette.text.primary;
`;

// src/atoms/SettingsPage.tsx
import * as React106 from "react";
import {
  Box as Box23,
  colors,
  Divider as Divider2,
  Stack as Stack6,
  Typography as Typography14,
  useTheme as useTheme22
} from "@mui/material";
import { toolbarHeightVar } from "@sales-center/common";
var toolbarHeight = "78px";
var getStyles13 = (theme, props) => ({
  page: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: colors.grey[50],
    height: `calc(100vh - ${toolbarHeightVar})`,
    overflow: "hidden",
    "@supports (height: 100dvh)": {
      height: `calc(100dvh - ${toolbarHeightVar})`
    }
  },
  absolutePage: {
    position: "absolute",
    top: toolbarHeightVar,
    height: `calc(100% - ${toolbarHeightVar})`
  },
  fixed: { flexGrow: 0 },
  header: {
    zIndex: 1,
    backgroundColor: props.headerBgColor ? props.headerBgColor : "initial"
  },
  pageContent: {
    /*overflow: 'hidden'*/
  },
  title: {
    fontFamily: "Source Sans Pro Bold",
    fontSize: "15px",
    padding: `${theme.spacing(1.2)} ${theme.spacing(0.7)}`,
    paddingLeft: theme.spacing(2),
    margin: 0,
    height: "46px"
  },
  content: {
    padding: props.padding ? props.padding : theme.spacing(2),
    height: props.contentHeight ? props.contentHeight : "calc(100% - 46px)",
    backgroundColor: props.bgColor ? props.bgColor : "initial",
    overflowY: props.hideTitleOnScroll ? "visible" : props.preventScroll ? "hidden" : "auto"
  },
  headerContent: {
    zIndex: 2,
    position: "sticky",
    /* position: -webkit-sticky; */
    /* overflow: hidden; */
    // Must track the fixed toolbar's real height. It was hardcoded to 75 for
    // three years, which left the Cancel / Save buttons pinned ~50px behind
    // the toolbar once it stacked into two rows below `sm`. See WWM-17564.
    top: toolbarHeightVar
  }
});
var SettingsPage = React106.forwardRef(
  (props, ref) => {
    const {
      title,
      headContent,
      fullScreen,
      footContent,
      style,
      contentId,
      children,
      isDetailPage,
      hideTitleOnScroll,
      allowCustomTitle,
      fixedFooter = false,
      titleContent,
      hideDivider = false
    } = props;
    const styles8 = getStyles13(useTheme22(), props);
    return /* @__PURE__ */ React106.createElement(React106.Fragment, null, /* @__PURE__ */ React106.createElement(
      Box23,
      {
        sx: {
          ...!!fullScreen && !hideTitleOnScroll && styles8.absolutePage,
          ...!hideTitleOnScroll && styles8.page,
          ...hideTitleOnScroll && styles8.pageContent
        },
        style
      },
      !isDetailPage && /* @__PURE__ */ React106.createElement(React106.Fragment, null, title && /* @__PURE__ */ React106.createElement(Box23, { sx: { ...styles8.fixed, ...styles8.header } }, allowCustomTitle ? title : titleContent ? /* @__PURE__ */ React106.createElement(Stack6, { direction: "row", justifyContent: "space-between" }, /* @__PURE__ */ React106.createElement(Box23, null, /* @__PURE__ */ React106.createElement(Typography14, { sx: { ...styles8.title } }, title)), /* @__PURE__ */ React106.createElement(Box23, { sx: { alignContent: "center", marginRight: 2 } }, titleContent)) : /* @__PURE__ */ React106.createElement(Typography14, { sx: { ...styles8.title } }, title), !hideDivider && /* @__PURE__ */ React106.createElement(Divider2, null)), /* @__PURE__ */ React106.createElement(
        Box23,
        {
          sx: {
            ...hideTitleOnScroll ? styles8.headerContent : styles8.header
          }
        },
        headContent
      )),
      /* @__PURE__ */ React106.createElement(Box23, { sx: { ...styles8.content }, id: contentId, ref }, children),
      !!footContent && !fixedFooter && /* @__PURE__ */ React106.createElement(Box23, { sx: { ...styles8.content } }, /* @__PURE__ */ React106.createElement(Divider2, null), footContent)
    ), !!footContent && fixedFooter && /* @__PURE__ */ React106.createElement(
      Box23,
      {
        sx: {
          display: "flex",
          position: "fixed",
          bottom: 0,
          flexGrow: 1,
          zIndex: 1,
          width: "calc(100% - 46px)"
        }
      },
      footContent
    ));
  }
);
SettingsPage.displayName = "SettingsPage";

// src/atoms/Tag.tsx
import * as React107 from "react";
import { Stack as Stack7, Typography as Typography15 } from "@mui/material";
function Tag(props) {
  const { title, color } = props;
  return /* @__PURE__ */ React107.createElement(
    Stack7,
    {
      bgcolor: color,
      height: 19,
      borderRadius: 0.4,
      width: "fit-content",
      justifyContent: "center",
      paddingX: 0.7
    },
    /* @__PURE__ */ React107.createElement(Typography15, { variant: "caption", fontFamily: "Source Sans Pro Bold" }, title)
  );
}

// src/atoms/TidalPhoneFieldFormik.tsx
import * as React108 from "react";
import { useCallback as useCallback26, useEffect as useEffect11, useMemo as useMemo14, useState as useState18 } from "react";
import {
  TextField as TextField5
} from "@workwave-tidal/core/components";
import { getIn as getIn2 } from "formik";
import { updatePhoneValueForm } from "@sales-center/common";
import { debounce as debounce4 } from "lodash";
function TidalPhoneFieldFormik({
  debounceDelay = 300,
  form: { isSubmitting, errors, touched, setFieldValue },
  disabled = isSubmitting,
  field: { onBlur: fieldOnBlur, ...field },
  onBlur: propsOnBlur,
  onChange: propsOnChange,
  fullWidth = true,
  avoidValidateOnBlur = false,
  ...props
}) {
  const [value, setValue] = useState18(field.value);
  const update = useMemo14(
    () => debounce4((v) => setFieldValue(field.name, v), debounceDelay),
    [debounceDelay, field.name, setFieldValue]
  );
  const handleKeyDown = useCallback26(
    (event) => {
      if (event.key.match(/Backspace/)) {
        if (value.length >= 2 && value[value.length - 2] === "-")
          setValue(value.slice(0, value.length - 1));
      }
    },
    [value]
  );
  const errorText = getIn2(errors, field.name);
  const error = getIn2(touched, field.name) && errorText !== void 0;
  const onBlur = React108.useCallback(
    (event) => {
      if (propsOnBlur) {
        propsOnBlur(event);
      }
      fieldOnBlur(event ?? field.name);
    },
    [field.name, fieldOnBlur, propsOnBlur]
  );
  const onChange = useCallback26(
    (event) => {
      if (propsOnChange) {
        propsOnChange(event);
      }
      const result = event.target.value.replace(/\D/g, "");
      if (result.length <= 10)
        setValue(
          updatePhoneValueForm(
            result,
            event.target.value.length < value.length
          )
        );
    },
    [propsOnChange, value.length]
  );
  useEffect11(() => {
    update(value);
    return () => update.cancel();
  }, [value, update]);
  useEffect11(() => {
    setValue(field.value);
    update.cancel();
  }, [field.value, update]);
  const textFieldProps = {
    ...field,
    ...props,
    disabled,
    error,
    helperText: !!errorText && error ? errorText : props.helperText,
    onBlur: propsOnBlur ? propsOnBlur : !avoidValidateOnBlur ? onBlur : void 0
  };
  return /* @__PURE__ */ React108.createElement(
    TextField5,
    {
      ...textFieldProps,
      onChange,
      onKeyDown: handleKeyDown,
      fullWidth,
      value,
      avoidDisplayingErrorIcon: true
    }
  );
}

// src/atoms/TidalProtectedFormikField.tsx
import * as React110 from "react";
import { useState as useState19, useCallback as useCallback28 } from "react";
import { Field } from "formik";
import { IconButton as IconButton8, InputAdornment as InputAdornment2 } from "@mui/material";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon
} from "@workwave-tidal/core/icons";

// src/atoms/TidalTextFieldFormik.tsx
import * as React109 from "react";
import { useCallback as useCallback27 } from "react";
import { getIn as getIn3 } from "formik";
import {
  TextField as TextField6
} from "@workwave-tidal/core/components";
function TidalTextFieldFormik(props) {
  const {
    form: { isSubmitting, errors, touched },
    disabled = isSubmitting,
    field: { onBlur: fieldOnBlur, ...field },
    onBlur: propsOnBlur,
    ...rest
  } = props;
  const errorText = props.helperText ? props.helperText : getIn3(errors, field.name);
  const error = props?.error !== void 0 ? props?.error : getIn3(touched, field.name) && errorText !== void 0;
  const onBlur = useCallback27(
    (event) => {
      if (!props?.avoidValidateOnBlur) {
        if (propsOnBlur) {
          propsOnBlur(event);
        }
        fieldOnBlur(event ?? field.name);
      }
    },
    [field.name, fieldOnBlur, propsOnBlur, props?.avoidValidateOnBlur]
  );
  const textFieldProps = {
    ...field,
    ...rest,
    disabled,
    error,
    helperText: !!errorText && error ? errorText : props.helperText,
    onBlur
  };
  return /* @__PURE__ */ React109.createElement(TextField6, { avoidDisplayingErrorIcon: true, ...textFieldProps });
}

// src/atoms/TidalProtectedFormikField.tsx
function TidalProtectedFormikField(props) {
  const [visible, setVisibility] = useState19(false);
  const { name, label, required, autoComplete } = props;
  const onChangeVisibility = useCallback28(() => {
    setVisibility((current) => !current);
  }, []);
  const inputType = visible ? "text" : "password";
  const inputAutoComplete = !autoComplete ? "new-password" : void 0;
  return /* @__PURE__ */ React110.createElement(
    Field,
    {
      ...props,
      name,
      label,
      component: TidalTextFieldFormik,
      type: inputType,
      required,
      fullWidth: true,
      InputProps: {
        autoComplete: inputAutoComplete,
        endAdornment: /* @__PURE__ */ React110.createElement(InputAdornment2, { position: "end", color: "primary" }, /* @__PURE__ */ React110.createElement(
          IconButton8,
          {
            sx: {
              padding: 0,
              margin: 0
            },
            onClick: onChangeVisibility,
            size: "large"
          },
          visible ? /* @__PURE__ */ React110.createElement(VisibilityOffIcon, null) : /* @__PURE__ */ React110.createElement(VisibilityIcon, null)
        ))
      }
    }
  );
}

// src/atoms/TidalTextFormikField.tsx
import * as React111 from "react";
import { Field as Field2 } from "formik";
function TidalTextFormikField(props) {
  const { name, label, required, autoComplete, inputProps } = props;
  return /* @__PURE__ */ React111.createElement(
    Field2,
    {
      ...props,
      name,
      label,
      component: TidalTextFieldFormik,
      required,
      fullWidth: true,
      autoComplete,
      inputProps
    }
  );
}

// src/atoms/snackMachine.tsx
import * as React112 from "react";
import {
  createSnackMachine,
  SnackMachine
} from "@workwave-tidal/core/components";
var SNACK_MACHINE_WIDTH = "356px";
var snackMachineMessageSx = {
  "& .MuiAlert-root": {
    width: "100%",
    maxWidth: "100%"
  },
  "& .MuiAlert-message, & .MuiAlertTitle-root": {
    overflow: "hidden",
    overflowX: "hidden",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere"
  }
};
var snackMachine = createSnackMachine();
var snackMachineSideBar = createSnackMachine();
function SCSnackMachine() {
  return /* @__PURE__ */ React112.createElement(React112.Fragment, null, /* @__PURE__ */ React112.createElement(
    SnackMachine,
    {
      width: SNACK_MACHINE_WIDTH,
      sx: {
        // correcting a tidal bug on snackMachine
        zIndex: (theme) => theme.vars.zIndex.snackbar,
        ...snackMachineMessageSx
      },
      snackMachine
    }
  ), /* @__PURE__ */ React112.createElement(
    SnackMachine,
    {
      width: SNACK_MACHINE_WIDTH,
      sx: {
        // correcting a tidal bug on snackMachine
        zIndex: (theme) => theme.vars.zIndex.snackbar,
        ...snackMachineMessageSx,
        mb: 9,
        mr: 1
      },
      snackMachine: snackMachineSideBar
    }
  ));
}
var toast = {
  info: (message, useSideBarToast) => {
    if (!message) return null;
    if (useSideBarToast) {
      snackMachineSideBar.addSnack({
        severity: "info",
        message
      });
      return;
    }
    return snackMachine.addSnack({
      severity: "info",
      message
    });
  },
  error: (message, useSideBarToast) => {
    if (!message) return null;
    if (useSideBarToast) {
      snackMachineSideBar.addSnack({
        severity: "error",
        message
      });
      return;
    }
    return snackMachine.addSnack({
      severity: "error",
      message
    });
  },
  warning: (message, useSideBarToast) => {
    if (!message) return null;
    if (useSideBarToast) {
      snackMachineSideBar.addSnack({
        severity: "warning",
        message
      });
      return;
    }
    return snackMachine.addSnack({
      severity: "warning",
      message
    });
  },
  success: (message, useSideBarToast) => {
    if (!message) return null;
    if (useSideBarToast) {
      snackMachineSideBar.addSnack({
        severity: "success",
        message
      });
      return;
    }
    return snackMachine.addSnack({
      severity: "success",
      message
    });
  }
};

// src/molecules/Validator.ts
var validate = async (value, rules) => {
  let isValid = true;
  for (const rule in rules) {
    switch (rule) {
      case "minLength":
        isValid = isValid && minLengthValidator(value, rules[rule]);
        break;
      case "isRequired":
        isValid = isValid && requiredValidator(value);
        break;
      case "isEmail":
        isValid = isValid && emailValidator(value);
        break;
      case "isUniqueEmail":
        isValid = isValid && emailValidator(value);
        break;
      default:
        isValid = true;
    }
  }
  return isValid;
};
var requiredValidator = (value) => {
  if (!value) {
    return false;
  }
  return value.trim() !== "";
};
var minLengthValidator = (value, minLength) => {
  if (!minLength) return true;
  return value.length >= minLength;
};
var emailValidator = (value) => {
  const re = /^[_A-Za-z0-9-&\+\.]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
  return re.test(String(value).toLowerCase());
};

// src/molecules/ErrorBoundary.tsx
import * as React113 from "react";
var ErrorBoundary = class extends React113.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }
  componentDidCatch(error, errorInfo) {
    console.log(error);
    console.log(errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }
  render() {
    if (this.state.errorInfo) {
      return /* @__PURE__ */ React113.createElement("div", null, /* @__PURE__ */ React113.createElement("h2", null, "Something went wrong."), /* @__PURE__ */ React113.createElement("details", { style: { whiteSpace: "pre-wrap" } }, this.state.error && this.state.error.toString(), /* @__PURE__ */ React113.createElement("br", null)));
    }
    return this.props.children;
  }
};
var ErrorBoundary_default = ErrorBoundary;
export {
  ActionModal,
  ActionModalForm,
  ActivityIcon,
  ActivitySummaryIcon,
  AddLeadHeaderContainer,
  AddNoteIcon,
  AdditionalInfoListItem,
  AddressLink,
  AgreementIcon,
  AlertDialogSlide,
  AppAvatar,
  AttachFileFilled,
  AttachmentPaperClipIcon,
  AutoCompleteInput,
  BadgeIcon,
  Button3 as Button,
  ButtonWithTooltip,
  CalendarButton,
  CalendarDatePicker,
  CalendarIcon,
  CallTrackingIcon,
  CancelButton,
  CardFooterCollapse,
  CardListViewPicker,
  Chevron,
  ChevronContainer,
  CollapsibleSection,
  CollectionPage,
  ConfirmationDialog,
  ContentCentered,
  CustomActionBar,
  CustomFieldsIcon,
  CustomizedTreeView,
  DataItem,
  DatePicker,
  DeleteConfirmationPopup,
  DeleteIcon,
  Dialog3 as Dialog,
  DialogBody,
  DialogForm,
  DropDown,
  DropDownButton,
  EditButtonIcon,
  EditPencilIcon,
  Editable,
  ErrorBoundary_default as ErrorBoundary,
  ExportCSVButton,
  ExternalLink,
  FileUploadIcon,
  FilterIcon,
  FormSection,
  FutureDevelopment,
  HeaderAddButton,
  HighlightedText,
  HugeTabs,
  InfoIcon,
  InfoTooltip,
  LeadIcon,
  LightTooltip,
  LinkArrowIcon,
  LinkButton,
  LoadingButton,
  LoadingSpinner,
  LocationAvatar,
  LocationIcon,
  MapLinkIcon,
  Masonry,
  MenuTenantIcon,
  MessageDialogPopup,
  MoreButton,
  MuiTextFieldFormik,
  MuiValidationIcon,
  MultiServiceLocationDialog,
  NoResultsCard,
  OpenNewFieldIcon,
  OpportunityIcon,
  OpportunityWatermark,
  OverflowDetector,
  PageHeader,
  Pagination_default as Pagination,
  PaymentIcon,
  PaymentIconV2,
  PhoneLink,
  PiggyBank,
  PlusIcon,
  PlusIconDisabled,
  SCSnackMachine,
  SalesFunnelIcon,
  SalesTeamIcon,
  ScheduleIcon,
  SearchField,
  SearchHelperPopup,
  SelectStyled,
  ServiceIcon,
  ServiceIconV2,
  SettingsPage,
  SideDrawer,
  SideDrawerForm,
  SimpleAccordion,
  SimpleAccordionDetails,
  SimpleAccordionNoRotateSummary,
  SimpleAccordionSummary,
  Tab,
  TabPanel,
  TablePagination_default as TablePagination,
  TablePaginationProgress,
  Tag,
  TidalPhoneFieldFormik,
  TidalProtectedFormikField,
  TidalTextFieldFormik,
  TidalTextFormikField,
  ToggleButtons,
  TrashIcon,
  ValidationAlert,
  ValidationAsteriskIcon,
  VolumeUp,
  WWMTooltip,
  customizedTreeViewIconButtonStyles,
  customizedTreeViewIconStyles,
  customizedTreeViewTreeItemStyles,
  getDrawerStyles,
  getFormStyles,
  getStyles2 as getStyles,
  snackMachine,
  snackMachineSideBar,
  styles5 as styles,
  toast,
  toolbarHeight,
  useIsUnmounted,
  useMonitorElementWidth,
  useResize,
  useTablePagination,
  validate
};
//# sourceMappingURL=index.js.map